// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Skeleton Loader Styles (shared with view flow) */
.skeleton-viewflow-container {
  --skeleton-gradient: linear-gradient(
    110deg,
    #f6f7f8 8%,
    #eceef1 18%,
    #f6f7f8 33%
  );
  background: #efeeee;
  min-height: 89vh;
  padding: 24px 0 32px;
  pointer-events: none;
}
.skeleton-viewflow-container *[style*="background: #000"], .skeleton-viewflow-container *[style*="background:#000"], .skeleton-viewflow-container *[style*="background: #000000"], .skeleton-viewflow-container *[style*="background:#000000"] {
  background: #f5f5f5 !important;
}
.skeleton-viewflow-container .skeleton-text,
.skeleton-viewflow-container .skeleton-avatar,
.skeleton-viewflow-container .skeleton-icon,
.skeleton-viewflow-container .skeleton-image,
.skeleton-viewflow-container .skeleton-arrow {
  background-image: var(--skeleton-gradient);
  background-size: 220% 100%;
  animation: skeleton-shimmer 1.35s linear infinite, skeleton-pulse 2s ease-in-out infinite;
}
.skeleton-viewflow-container .skeleton-text {
  border-radius: 4px;
  height: 16px;
  margin: 6px 0;
}
.skeleton-viewflow-container .skeleton-text.skeleton-title {
  height: 24px;
  width: 60%;
}
.skeleton-viewflow-container .skeleton-text.skeleton-subtitle {
  height: 16px;
  width: 40%;
}
.skeleton-viewflow-container .skeleton-text.skeleton-badge-text {
  height: 14px;
  width: 80px;
}
.skeleton-viewflow-container .skeleton-text.short {
  width: 40%;
}
.skeleton-viewflow-container .skeleton-text.skeleton-description.short {
  width: 70%;
}
.skeleton-viewflow-container .skeleton-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}
.skeleton-viewflow-container .skeleton-icon {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  margin-right: 8px;
}
.skeleton-viewflow-container .skeleton-icon.small {
  width: 18px;
  height: 18px;
}
.skeleton-viewflow-container .skeleton-icon.skeleton-share-icon {
  width: 20px;
  height: 20px;
  margin-left: auto;
}
.skeleton-viewflow-container .skeleton-image {
  width: 100%;
  height: 240px;
  border-radius: 12px;
}
.skeleton-viewflow-container .skeleton-image.large {
  height: 320px;
}
.skeleton-viewflow-container .skeleton-image.small {
  width: 120px;
  height: 72px;
  border-radius: 12px;
}
.skeleton-viewflow-container .flow-layout-container {
  padding: 0 24px;
}
.skeleton-viewflow-container .skeleton-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(49, 53, 73, 0.05);
  margin-bottom: 16px;
}
.skeleton-viewflow-container .skeleton-flow-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.skeleton-viewflow-container .skeleton-flow-title {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}
.skeleton-viewflow-container .skeleton-pill {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  border-radius: 40px;
  background: rgba(94, 161, 216, 0.08);
}
.skeleton-viewflow-container .skeleton-pill-text {
  width: 90px;
  height: 14px;
  margin: 0;
}
.skeleton-viewflow-container .skeleton-info-panel {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.skeleton-viewflow-container .info-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 24px;
  background: rgba(240, 240, 240, 0.8);
}
.skeleton-viewflow-container .info-badge .skeleton-text {
  width: 90px;
  height: 14px;
  margin: 0;
}
.skeleton-viewflow-container .video-player-section {
  background: #ffffff !important;
}
.skeleton-viewflow-container .video-player-section .img-wrap {
  background: #f5f5f5 !important;
}
.skeleton-viewflow-container .video-player-section .img-wrap img,
.skeleton-viewflow-container .video-player-section .img-wrap video {
  background: #f5f5f5 !important;
}
.skeleton-viewflow-container .video-player-section .img-wrap .skeleton-image {
  background: #f5f5f5 !important;
  background-image: var(--skeleton-gradient) !important;
}
.skeleton-viewflow-container .mobile-media {
  background: #f5f5f5 !important;
}
.skeleton-viewflow-container .mobile-media img,
.skeleton-viewflow-container .mobile-media video {
  background: #f5f5f5 !important;
}
.skeleton-viewflow-container .mobile-media .skeleton-image {
  background: #f5f5f5 !important;
  background-image: var(--skeleton-gradient) !important;
}
.skeleton-viewflow-container .mobile-media-video {
  background: #f5f5f5 !important;
}
.skeleton-viewflow-container .img-wrap,
.skeleton-viewflow-container .video-player-section .img-wrap,
.skeleton-viewflow-container .mobile-media,
.skeleton-viewflow-container .mobile-media-video {
  background: #f5f5f5 !important;
}
.skeleton-viewflow-container .img-wrap img,
.skeleton-viewflow-container .img-wrap video,
.skeleton-viewflow-container .video-player-section .img-wrap img,
.skeleton-viewflow-container .video-player-section .img-wrap video,
.skeleton-viewflow-container .mobile-media img,
.skeleton-viewflow-container .mobile-media video,
.skeleton-viewflow-container .mobile-media-video img,
.skeleton-viewflow-container .mobile-media-video video {
  background: #f5f5f5 !important;
}
.skeleton-viewflow-container .metadata-skeleton .step-header-main {
  display: flex;
  align-items: center;
  gap: 14px;
}
.skeleton-viewflow-container .metadata-skeleton .skeleton-step-circle {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  margin-right: 4px;
}
.skeleton-viewflow-container .metadata-skeleton .skeleton-step-title {
  flex: 1;
  height: 22px;
  margin: 0;
  border-radius: 8px;
}
.skeleton-viewflow-container .metadata-skeleton .video-actions-bar {
  margin-top: 20px;
}
.skeleton-viewflow-container .metadata-skeleton .video-actions-bar .action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.skeleton-viewflow-container .metadata-skeleton .video-actions-bar .skeleton-action-item {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  min-width: 110px;
}
.skeleton-viewflow-container .channel-info-section .channel-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}
.skeleton-viewflow-container .channel-info-section .channel-meta,
.skeleton-viewflow-container .channel-info-section .channel-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}
.skeleton-viewflow-container .channel-info-section .channel-actions .skeleton-text {
  width: 120px;
  height: 32px;
  border-radius: 16px;
}
.skeleton-viewflow-container .description-section .skeleton-text {
  height: 14px;
}
.skeleton-viewflow-container .comments-section .skeleton-comment {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 12px;
}
.skeleton-viewflow-container .comments-section .skeleton-comment-body {
  flex: 1;
}
.skeleton-viewflow-container .flow-sidebar {
  align-self: flex-start;
}
.skeleton-viewflow-container .step-navigation .step-scroll {
  max-height: 320px;
  overflow: hidden;
}
.skeleton-viewflow-container .step-navigation .steps-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.skeleton-viewflow-container .step-navigation .step-btn {
  border: none;
  background: rgba(240, 240, 240, 0.8);
  padding: 10px 16px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.skeleton-viewflow-container .step-navigation .skeleton-step-pill {
  flex: 1;
  height: 14px;
  margin: 0;
}
.skeleton-viewflow-container .recommendations-section h2 {
  font-size: 1.1rem;
  margin-bottom: 12px;
  min-height: 24px;
}
.skeleton-viewflow-container .recommendations-section.nested-bundle-categories {
  margin-top: 8px;
  margin-bottom: 24px;
}
.skeleton-viewflow-container .recommendations-section.nested-bundle-categories > h2 {
  margin-top: 4px;
  margin-bottom: 16px;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.3;
}
.skeleton-viewflow-container .recommendations-section.nested-bundle-categories .bundle-view-category {
  margin-bottom: 20px;
}
.skeleton-viewflow-container .recommendations-section.nested-bundle-categories .bundle-view-category:not(:first-child) {
  margin-top: 8px;
  padding-top: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}
.skeleton-viewflow-container .recommendations-section.nested-bundle-categories .bundle-view-category-title {
  font-size: 0.95rem;
  margin: 0 0 12px;
  padding-top: 4px;
  font-weight: 600;
  line-height: 1.3;
  color: #374151;
}
.skeleton-viewflow-container .recommendations-section input[type=text].bundle-search-input,
.skeleton-viewflow-container .recommendations-section .bundle-search-container .bundle-search-field input.bundle-search-input,
.skeleton-viewflow-container .recommendations-section .bundle-search-container .bundle-search-field .bundle-search-input {
  border-radius: 24px !important;
  -webkit-border-radius: 24px !important;
  -moz-border-radius: 24px !important;
  -webkit-appearance: none !important;
  appearance: none !important;
}
.skeleton-viewflow-container .recommendations-section .bundle-search-container {
  margin-bottom: 16px;
  width: 100%;
}
.skeleton-viewflow-container .recommendations-section .skeleton-search-box {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 24px;
  padding: 8px 12px;
  gap: 8px;
}
.skeleton-viewflow-container .recommendations-section .skeleton-search-box .skeleton-search-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
.skeleton-viewflow-container .recommendations-section .skeleton-search-box .skeleton-search-input {
  flex: 1;
  height: 20px;
  margin: 0;
  border-radius: 4px;
}
.skeleton-viewflow-container .recommendations-section .bundle-search-field {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  width: 100%;
  height: 36px;
}
.skeleton-viewflow-container .recommendations-section .bundle-search-field input.bundle-search-input,
.skeleton-viewflow-container .recommendations-section .bundle-search-field .bundle-search-input {
  flex: 1;
  min-width: 0;
  padding: 8px 72px 8px 12px;
  border: 1px solid #d0d0d0 !important;
  border-radius: 24px !important;
  -webkit-border-radius: 24px !important;
  -moz-border-radius: 24px !important;
  font-size: 14px;
  background: #ffffff;
  height: 36px;
  outline: none !important;
  color: #000000;
  box-sizing: border-box;
  -webkit-appearance: none !important;
  appearance: none !important;
  font-family: inherit;
  margin: 0;
  line-height: normal;
  width: 100%;
}
.skeleton-viewflow-container .recommendations-section .bundle-search-field input.bundle-search-input::placeholder,
.skeleton-viewflow-container .recommendations-section .bundle-search-field .bundle-search-input::placeholder {
  color: #666666;
}
.skeleton-viewflow-container .recommendations-section .bundle-search-field input.bundle-search-input:focus,
.skeleton-viewflow-container .recommendations-section .bundle-search-field .bundle-search-input:focus {
  border-color: #d0d0d0 !important;
  box-shadow: none;
  border-radius: 24px !important;
  -webkit-border-radius: 24px !important;
  -moz-border-radius: 24px !important;
}
.skeleton-viewflow-container .recommendations-section .bundle-search-field .cancel-icon-button {
  position: absolute;
  right: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #666666;
  border-radius: 50%;
  transition: color 0.2s, background-color 0.2s;
  flex-shrink: 0;
  z-index: 1;
  width: 28px;
  height: 28px;
}
.skeleton-viewflow-container .recommendations-section .bundle-search-field .cancel-icon-button:hover {
  color: #000000;
  background-color: #f0f0f0;
}
.skeleton-viewflow-container .recommendations-section .bundle-search-field .cancel-icon-button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.skeleton-viewflow-container .recommendations-section .bundle-search-field .search-icon-button {
  position: absolute;
  right: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #666666;
  border-radius: 50%;
  transition: color 0.2s, background-color 0.2s;
  flex-shrink: 0;
  z-index: 1;
  width: 28px;
  height: 28px;
}
.skeleton-viewflow-container .recommendations-section .bundle-search-field .search-icon-button:hover {
  color: #000000;
  background-color: #f0f0f0;
}
.skeleton-viewflow-container .recommendations-section .bundle-search-field .search-icon-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
@media (max-width: 768px) {
  .skeleton-viewflow-container .recommendations-section .bundle-search-field {
    height: 36px;
  }
  .skeleton-viewflow-container .recommendations-section .bundle-search-field input.bundle-search-input,
  .skeleton-viewflow-container .recommendations-section .bundle-search-field .bundle-search-input {
    font-size: 14px;
    padding: 8px 72px 8px 12px;
    height: 36px;
    border-radius: 24px !important;
    -webkit-border-radius: 24px !important;
    -moz-border-radius: 24px !important;
  }
}
@media (max-width: 480px) {
  .skeleton-viewflow-container .recommendations-section .bundle-search-field {
    height: 32px;
  }
  .skeleton-viewflow-container .recommendations-section .bundle-search-field input.bundle-search-input,
  .skeleton-viewflow-container .recommendations-section .bundle-search-field .bundle-search-input {
    font-size: 13px;
    padding: 8px 64px 8px 10px;
    height: 32px;
    border-radius: 20px !important;
    -webkit-border-radius: 20px !important;
    -moz-border-radius: 20px !important;
  }
  .skeleton-viewflow-container .recommendations-section .bundle-search-field .cancel-icon-button {
    right: 36px;
    width: 24px;
    height: 24px;
  }
  .skeleton-viewflow-container .recommendations-section .bundle-search-field .cancel-icon-button mat-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
  }
  .skeleton-viewflow-container .recommendations-section .bundle-search-field .search-icon-button {
    right: 4px;
    width: 24px;
    height: 24px;
  }
  .skeleton-viewflow-container .recommendations-section .bundle-search-field .search-icon-button mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
}
.skeleton-viewflow-container .recommendations-section .recommendations-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 100px;
}
.skeleton-viewflow-container .recommendations-section .no-results-message {
  padding: 24px 16px;
  text-align: center;
  color: #666666;
  font-size: 14px;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 16px 0;
}
.skeleton-viewflow-container .recommendations-section .no-results-message p {
  margin: 0;
  color: #666666;
}
.skeleton-viewflow-container .recommendations-section .recommendation-item {
  display: flex;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  background: #f9f9f9;
  margin-bottom: 8px;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
}
.skeleton-viewflow-container .recommendations-section .recommendation-item:hover {
  background: #f0f0f0;
  transform: translateY(-1px);
}
.skeleton-viewflow-container .recommendations-section .recommendation-item:last-child {
  margin-bottom: 0;
}
.skeleton-viewflow-container .recommendations-section .recommendation-thumbnail {
  flex-shrink: 0;
  width: 120px;
  height: 72px;
  border-radius: 8px;
  overflow: hidden;
  background: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.skeleton-viewflow-container .recommendations-section .recommendation-thumbnail .flow-seq-badge {
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 2;
  min-width: 22px;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: rgba(94, 161, 216, 0.95);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}
.skeleton-viewflow-container .recommendations-section .recommendation-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.skeleton-viewflow-container .recommendations-section .recommendation-thumbnail video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.skeleton-viewflow-container .recommendations-section .recommendation-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.skeleton-viewflow-container .recommendations-section .recommendation-info .recommendation-title {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.skeleton-viewflow-container .recommendations-section .recommendation-info .recommendation-meta {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
  font-size: 12px;
  color: #666666;
}
.skeleton-viewflow-container .recommendations-section .recommendation-info .recommendation-meta .recommendation-creator {
  font-weight: 500;
}
.skeleton-viewflow-container .recommendations-section .recommendation-info .recommendation-meta .recommendation-id {
  color: #999999;
}
.skeleton-viewflow-container .recommendations-section .recommendation-info .recommendation-price {
  font-size: 13px;
  font-weight: 600;
  color: #5ea1d8;
  margin-top: 4px;
}
.skeleton-viewflow-container .recommendations-section .skeleton-small {
  height: 12px;
  width: 50%;
}
.skeleton-viewflow-container.mobile .skeleton-mobile {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.skeleton-viewflow-container.mobile .mobile-top-panel {
  padding: 0 8px;
}
.skeleton-viewflow-container.mobile .info-badge {
  width: 100%;
  max-width: 180px;
}
.skeleton-viewflow-container.mobile .mobile-section.skeleton-card {
  padding: 16px;
  border-radius: 16px;
}
.skeleton-viewflow-container.mobile .mobile-media .skeleton-image {
  height: 220px;
  border-radius: 16px;
}
.skeleton-viewflow-container.mobile .mobile-items-list {
  margin-top: 12px;
}
.skeleton-viewflow-container.mobile .mobile-item-skeleton {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}
.skeleton-viewflow-container.mobile .mobile-item-skeleton:last-child {
  border-bottom: none;
}
.skeleton-viewflow-container.mobile .mobile-item-skeleton .mobile-item-copy {
  flex: 1;
}
.skeleton-viewflow-container.mobile .mobile-step-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.skeleton-viewflow-container.mobile .mobile-step-media .skeleton-image {
  height: 200px;
}
.skeleton-viewflow-container.mobile .recommendation-item {
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}
.skeleton-viewflow-container.mobile .recommendation-item:last-child {
  border-bottom: none;
}

/* Version preview: show "not available" message in header/body */
.preview-unavailable {
  margin-top: 6px;
  font-size: 12px;
  color: #b71c1c;
  font-weight: 600;
}

.preview-unavailable-body {
  padding: 16px;
  border: 1px solid rgba(183, 28, 28, 0.2);
  background: rgba(183, 28, 28, 0.05);
  border-radius: 10px;
  margin-bottom: 16px;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
@keyframes skeleton-pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.65;
  }
  100% {
    opacity: 1;
  }
}
/* Dark mode skeleton palette (view-bundle) */
:host-context(body.theme-dark) .skeleton-viewflow-container {
  --skeleton-gradient: linear-gradient(
    110deg,
    #1f2937 8%,
    #334155 18%,
    #1f2937 33%
  );
  background: #0a0c10 !important;
}
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-text,
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-avatar,
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-icon,
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-image,
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-arrow {
  background-color: #1f2937 !important;
}
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-card,
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-flow-header {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .skeleton-viewflow-container .video-player-section,
:host-context(body.theme-dark) .skeleton-viewflow-container .video-player-section .img-wrap,
:host-context(body.theme-dark) .skeleton-viewflow-container .video-player-section .img-wrap img,
:host-context(body.theme-dark) .skeleton-viewflow-container .video-player-section .img-wrap video,
:host-context(body.theme-dark) .skeleton-viewflow-container .mobile-media,
:host-context(body.theme-dark) .skeleton-viewflow-container .mobile-media img,
:host-context(body.theme-dark) .skeleton-viewflow-container .mobile-media video,
:host-context(body.theme-dark) .skeleton-viewflow-container .mobile-media-video {
  background: #020617 !important;
}
:host-context(body.theme-dark) .skeleton-viewflow-container .info-badge,
:host-context(body.theme-dark) .skeleton-viewflow-container .skeleton-pill {
  background: rgba(148, 163, 184, 0.16) !important;
}

* {
  padding: 0px;
  margin: 0px;
}

.dialog-scroll-wrapper {
  max-height: 80vh;
  overflow-y: auto;
}

/* Keep bundle preview behavior identical to flow preview:
   sticky header with a dedicated scrollable content area. */
.view-flow.viewbundle.preview-mode {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow: hidden;
}
.view-flow.viewbundle.preview-mode .preview-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  background: #ffffff;
  position: sticky;
  top: 0;
  z-index: 20;
}
.view-flow.viewbundle.preview-mode .preview-dialog-header .header-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 0;
  padding-right: 48px;
}
.view-flow.viewbundle.preview-mode .preview-dialog-header h2 {
  margin: 0;
  font-size: 20px !important;
  font-weight: 600;
  color: #212427;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.view-flow.viewbundle.preview-mode .preview-dialog-header .version-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background-color: #5ea1d8;
  color: #fff;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  width: -moz-fit-content;
  width: fit-content;
}
.view-flow.viewbundle.preview-mode .preview-dialog-header .version-badge mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #fff;
}
.view-flow.viewbundle.preview-mode .preview-dialog-header .preview-unique-code {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px;
  margin-top: 2px;
  font-size: 13px;
  color: #666;
  max-width: 100%;
}
.view-flow.viewbundle.preview-mode .preview-dialog-header .preview-unique-code .preview-unique-code-label {
  font-weight: 600;
  color: #212427;
}
.view-flow.viewbundle.preview-mode .preview-dialog-header .preview-unique-code .preview-unique-code-value {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 12px;
  word-break: break-all;
  color: #212427;
}
.view-flow.viewbundle.preview-mode .preview-dialog-header .close-button {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #666;
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
}
.view-flow.viewbundle.preview-mode .preview-dialog-header .close-button mat-icon {
  color: #666;
}
.view-flow.viewbundle.preview-mode .preview-inline-description {
  margin: 12px 0 16px 0;
  padding: 12px 14px;
  background: #ffffff;
  border-radius: 12px;
  color: #212427;
  max-height: 260px;
  overflow-y: auto;
  overflow-x: hidden;
  word-break: break-word;
}
.view-flow.viewbundle.preview-mode .preview-inline-description p {
  margin: 0 0 10px 0 !important;
  color: #212427 !important;
  line-height: 1.55;
}

@media (max-width: 640px) {
  .view-flow.viewbundle.preview-mode .preview-dialog-header {
    padding: 16px;
  }
  .view-flow.viewbundle.preview-mode .preview-dialog-header h2 {
    font-size: 18px !important;
  }
  .view-flow.viewbundle.preview-mode .preview-dialog-header .header-content {
    padding-right: 40px;
  }
  .view-flow.viewbundle.preview-mode .preview-dialog-header .version-badge {
    font-size: 12px;
    padding: 3px 10px;
  }
  .view-flow.viewbundle.preview-mode .preview-dialog-header .version-badge mat-icon {
    font-size: 14px;
    width: 14px;
    height: 14px;
  }
  .view-flow.viewbundle.preview-mode .preview-dialog-header .close-button {
    top: 8px;
    right: 8px;
  }
  .container1 {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 36px;
    box-sizing: border-box;
  }
}
/* Hard override: ensure desktop preview is always scrollable to the bottom. */
.view-flow.viewbundle.dialog-scroll-wrapper.preview-mode {
  display: flex !important;
  flex-direction: column !important;
  height: 80vh !important;
  max-height: 80vh !important;
  overflow: hidden !important;
}

.view-flow.viewbundle.dialog-scroll-wrapper.preview-mode .container1 {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  height: calc(80vh - 78px) !important;
  max-height: calc(80vh - 78px) !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  padding-bottom: 48px !important;
}

/* Mobile preview: outer Material surface scrolls (see styles.scss .flow-preview-pane) — no nested 80vh trap */
@media (max-width: 1024px) {
  .view-flow.viewbundle.dialog-scroll-wrapper.preview-mode {
    height: auto !important;
    max-height: none !important;
    min-height: 0 !important;
    overflow: visible !important;
  }
  .view-flow.viewbundle.dialog-scroll-wrapper.preview-mode .container1 {
    flex: none !important;
    overflow-y: visible !important;
    overflow-x: hidden !important;
    height: auto !important;
    max-height: none !important;
    min-height: 0 !important;
  }
}
.view-flow.viewbundle.dialog-scroll-wrapper.preview-mode .flow-layout-container,
.view-flow.viewbundle.dialog-scroll-wrapper.preview-mode .flow-main-grid,
.view-flow.viewbundle.dialog-scroll-wrapper.preview-mode .flow-main-content {
  overflow: visible !important;
}

/* Desktop preview only: keep 2-column + sidebar. On mobile, use same responsive rules as standalone view-bundle (single column, sidebar list hidden, recommendations-section-mobile). */
@media (min-width: 1025px) {
  .view-flow.viewbundle.preview-mode .flow-layout-container .flow-main-grid {
    grid-template-columns: minmax(0, 1fr) 402px !important;
    gap: 24px !important;
    padding: 16px 24px !important;
    background: #f6f7f9 !important;
  }
  .view-flow.viewbundle.preview-mode .flow-sidebar {
    display: flex !important;
    width: 402px !important;
    min-width: 402px !important;
    max-width: 402px !important;
  }
  .view-flow.viewbundle.preview-mode .flow-sidebar .recommendations-section {
    display: block !important;
  }
}
body {
  background: #efeeee;
  counter-reset: my-sec-counter;
}

.view-flow {
  background: #efeeee;
  min-height: 89vh;
  padding-top: 10px;
}

.favorite-toggle-icon {
  transition: color 0.2s ease;
}
.favorite-toggle-icon.liked {
  color: #ff4d4d !important;
}

.bookmark-state-icon {
  color: #666666;
}
.bookmark-state-icon.saved {
  color: #212427;
}

.action-item .favorite-toggle-icon.liked {
  color: #ff4d4d !important;
}

.flowbycat {
  height: 100%;
  display: table;
  text-align: center;
}

header {
  width: 100%;
  height: 100px;
  background: #fff;
  border-bottom: 2px solid #5ea1d8;
}

.container1 {
  max-width: 100%;
  width: 100%;
  margin: 0;
  background: transparent;
  padding-bottom: 30px;
  padding: 0;
}

.user-sec {
  padding: 20px 20px;
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  margin: 0px 20px 0px 20px;
  border-radius: 10px;
  position: relative;
}

.user-details {
  flex: 1;
  display: flex;
}

.user-ico {
  flex: 1;
  display: none !important;
}
.user-ico img {
  width: 180px !important;
  height: 180px;
  border-radius: 100%;
  object-fit: cover;
  max-width: 200px;
}

.ico-details {
  flex: 4;
  padding-left: 0px;
  display: flex;
  flex-direction: column;
}
.ico-details p {
  margin-bottom: 20px !important;
  margin-top: 0px !important;
}
.ico-details .profilepic {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.ico-details .profilepic .profinner {
  max-width: 500px;
  width: 100%;
  display: flex;
}
.ico-details .profilepic .profinner > div {
  width: auto;
  margin-right: 20px;
}
.ico-details .profilepic .profinner > div:last-child span {
  color: #212427 !important;
  font-weight: 400 !important;
}
.ico-details .profilepic .profinner > div:last-child span .mat-icon {
  color: #212427 !important;
  font-size: 18px;
  display: flex;
  align-items: center;
}
.ico-details .profilepic .u-ico {
  margin-right: 15px;
}
.ico-details .profilepic .qrcode {
  flex: 1;
  justify-content: flex-end;
  align-items: flex-end;
  color: #212427 !important;
}
.ico-details .profilepic .qrcode span {
  font-weight: 400 !important;
}
.ico-details .profilepic p {
  margin: 0px !important;
}
.ico-details .profilepic > div {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.ico-details .profilepic > div:last-child {
  margin-right: 0px;
}
.ico-details .profilepic img {
  border-radius: 50%;
  cursor: pointer;
}

.like {
  max-width: 100%;
  margin-bottom: 0px;
  display: flex;
}
.like span.material-icons {
  min-height: 30px;
  color: #212427 !important;
}

.qr-ico {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
  position: absolute;
  right: 20px;
}

.qr-ico i {
  flex: 1;
  font-size: 25px;
  color: grey;
  color: #212427;
}

.qr-ico p {
  font-weight: 600;
}

img {
  width: 100%;
}

p {
  font-family: "Raleway";
  font-size: 15px;
  line-height: 20px;
}

button {
  padding: 3px 10px;
  background: #5ea1d8;
  border: 0px;
  color: #fff;
  font-size: 15px;
  border-radius: 5px;
}

h2 {
  font-family: "Raleway";
  margin-bottom: 20px;
}

h3 {
  font-family: "Raleway";
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
}

ul {
  display: flex;
  list-style: none;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

li {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
li span {
  margin-left: 0px;
}

.like .qrcode {
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.like ul {
  max-width: 500px;
  width: 100%;
  display: flex;
  margin-left: -17px;
}

.like li {
  height: 100%;
  justify-content: flex-start;
}

.like li i {
  font-size: 25px;
  color: gray;
  text-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4);
  margin-bottom: 5px;
}

li span {
  font-size: 10px;
  font-family: "Raleway";
  font-weight: 600;
  text-align: center;
  color: #212427 !important;
  padding: 0px !important;
}

/*description wrapper starts here*/
.description-wrapper {
  display: flex;
  background: #fff;
  margin: 10px 20px 10px 20px;
}

.des-item {
  flex-basis: calc(50% - 20px);
  margin-right: 10px;
  display: flex;
  flex-direction: column;
}

.des-item .des {
  /*max-height:200px;*/
  flex: 1;
  border: 1px solid #ddd;
  margin-bottom: 0px;
  border-radius: 0px;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
}

.des-item .des p {
  max-height: 100px;
  overflow-y: auto;
}

.des-item .des > div {
  flex: 1;
  display: flex;
  align-items: flex-start;
  margin-top: 20px;
}

.des-item .des > div span {
  flex: 1;
  font-family: "RALEWAY";
}

.des-item .des > div span.material-icons.ng-star-inserted {
  max-width: 30px;
}

.des-item .des > div span:first-child {
  align-items: flex-start;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.des-item .des > div span:last-child {
  text-align: flex-end;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.des-item .des > div span i {
  margin-right: 5px;
}

.des-item .item {
  flex: 1;
  border: 1px solid #ddd;
  border-radius: 40px;
  padding: 40px 20px;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  margin-top: 20px;
}

.des-item .item .list {
  display: flex;
  /* padding: 20px 0px; */
  max-height: 150px;
  overflow-y: auto;
  align-items: flex-start;
}

.des-item .item .list ul {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 0px 0px 20px;
  padding: 5px;
}

.des-item .item .list ul li {
  font-family: "Raleway";
  font-size: 14px;
  line-height: 28px;
  word-break: break-all;
  position: relative;
  padding-left: 17px;
}
.des-item .item .list ul li:before {
  content: "";
  width: 8px;
  height: 8px;
  background: grey;
  position: absolute;
  left: 0px;
  top: 10px;
  border-radius: 50%;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
}
.des-item .item .list ul li:first-child {
  padding-left: 0px;
}
.des-item .item .list ul li:first-child:before {
  display: none;
}

.des-item .item .list ul li:first-child {
  font-weight: 600;
}

.step-sec {
  flex: 1;
  padding: 40px;
  border: 1px solid #ddd;
  border-radius: 40px;
}

.step-sec .img-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
}
.step-sec .img-wrap img {
  max-width: 100% !important;
  height: 100%;
  margin: 0px auto;
  width: 100% !important;
}
.step-sec .img-wrap video {
  max-width: 100% !important;
  margin: 0px auto;
  width: 100% !important;
}
.step-sec .img-wrap:empty {
  display: none !important;
}

.step-sec .img-wrap:after {
  content: "›";
  background: #fafafa !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  position: absolute;
  right: -49px;
  top: calc(50% - 20px);
  font-size: 35px;
  margin-top: -8px;
  display: none;
}

.step-sec .img-wrap:before {
  content: "‹";
  background: #fafafa !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  position: absolute;
  left: -49px;
  top: calc(50% - 20px);
  font-size: 35px;
  margin-top: -8px;
  display: none;
}

.des-item .des p::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}

.des-item .des p::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.des-item .des p::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

.des-item .item .list::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}

.des-item .item .list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.des-item .item .list::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

.step-sec {
  display: flex;
  flex-direction: column;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
}

.progressbar ul {
  display: flex;
  flex-basis: 100%;
}

.progressbar ul li {
  flex: 1;
  display: flex;
  align-items: center;
}

.progressbar ul li a {
  width: 20px;
  height: 20px;
  background: #5ea1d8;
  border-radius: 50%;
  color: #fff;
  text-decoration: none;
  text-align: center;
  font-size: 12px;
  font-family: "RALEWAY";
  display: flex;
  align-items: center;
  justify-content: center;
}

.progressbar ul li a:before {
  counter-increment: my-sec-counter;
  content: "" counter(my-sec-counter) "";
}

img {
  max-width: 100%;
}

/*new added*/
.viewflow-step {
  width: calc(100% - 40px);
  display: flex;
  padding: 20px 20px;
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  position: relative;
  border-radius: 10px;
  flex-wrap: wrap;
}
.viewflow-step .des-item {
  border-radius: 0px;
  border-right: 1px solid lightgray;
  max-width: calc(50% - 20px);
  padding-right: 10px;
}
.viewflow-step .des-item .des {
  box-shadow: none;
  border: 0px;
  padding: 0px 0px;
}
.viewflow-step .des-item .des h6 {
  font-weight: bold;
  margin-bottom: 5px;
}
.viewflow-step .des-item .des > div {
  flex: none;
  flex-wrap: wrap;
}
.viewflow-step .des-item .des p {
  max-height: 287px;
  padding-right: 10px;
}
.viewflow-step .des-item .des .s-num {
  font-size: 16px;
  width: 30px;
  height: 30px;
  color: #fff;
  border: 0px solid #f3f3f3;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-family: "Raleway";
  font-weight: 600;
  margin-top: 0px;
  margin-bottom: 20px;
  position: relative;
  z-index: 2;
}
.viewflow-step .des-item .des .s-num:before {
  content: "";
  width: 100%;
  height: 100%;
  border-radius: 50%;
  left: 0px;
  top: 0px;
  position: absolute;
  background: lightgray;
  z-index: -1;
}
.viewflow-step .step-sec {
  box-shadow: none;
  border: 0px;
  padding: 0px 0px 0px 0px;
  margin-left: 10px;
  width: 50%;
}
.viewflow-step .step-sec .progressbar {
  border: 2px solid lightgray;
  margin-bottom: 20px;
  background: #fff;
  border-radius: 10px;
  padding: 5px;
}
.viewflow-step .step-sec .progressbar .w3-round {
  height: 7px;
  background: #5ea1d8;
  background: lightgrey;
}
.viewflow-step .clickarrow {
  width: 100%;
  display: block;
  position: absolute;
  margin-top: 0px;
  width: 100%;
  height: 35px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
.viewflow-step .clickarrow button.owl-prev {
  position: absolute;
  background: #fafafa !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  left: -45px;
}
.viewflow-step .clickarrow button.owl-prev span {
  font-size: 35px;
  line-height: 0px;
  display: flex;
  align-items: center;
  margin-top: -8px;
  color: #000;
}
.viewflow-step .clickarrow button.owl-next {
  position: absolute;
  background: #fafafa !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  right: -45px;
}
.viewflow-step .clickarrow button.owl-next span {
  font-size: 35px;
  line-height: 0px;
  display: flex;
  align-items: center;
  margin-top: -8px;
  color: #000;
}

@media only screen and (max-width: 1025px) and (min-width: 320px) {
  .view-flow h2 {
    font-size: 22px !important;
  }
}
@media only screen and (max-width: 992px) and (min-width: 320px) {
  .view-flow .container1 {
    display: flex;
    flex-direction: column;
  }
  .view-flow .container1 .user-sec {
    flex-direction: row;
  }
  .view-flow .container1 .user-sec .user-details {
    flex-direction: column;
    order: 2;
  }
  .view-flow .container1 .user-sec .user-details .user-ico {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .view-flow .container1 .user-sec .user-details .ico-details {
    padding: 0px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic > div p {
    font-size: 14px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like {
    display: flex;
    flex-direction: column;
    margin-left: 0px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul {
    margin-left: 0px;
    max-width: 100%;
    margin-bottom: 10px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul li i {
    font-size: 20px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like .qrcode span {
    margin-right: 0px !important;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like .qrcode p {
    margin-bottom: 0px !important;
  }
  .view-flow .container1 .user-sec .qr-code {
    padding: 10px 0px;
  }
  .view-flow .description-wrapper {
    flex-direction: column;
    margin: 0px;
    margin-bottom: 20px;
  }
  .view-flow .description-wrapper .des-item {
    margin-right: 0px;
    margin-bottom: 20px;
    flex-basis: 100%;
    max-width: unset;
    border-right: 0px;
    padding-right: 0px;
  }
  .view-flow .description-wrapper .des-item .des > div span:first-child {
    justify-content: flex-start;
  }
  .view-flow .description-wrapper .des-item .des .timer-wrap {
    display: flex;
    flex-direction: column;
    flex: none;
    color: #212427;
  }
  .view-flow .description-wrapper .des-item .des .timer-wrap > * {
    margin-right: 10px;
  }
  .view-flow .viewflow-step {
    width: 100%;
    margin: 0px auto 20px;
  }
  .view-flow .viewflow-step .des-item {
    flex-basis: 100%;
    max-width: unset;
    border-bottom: 2px solid lightgrey;
    padding-bottom: 0px;
    border-bottom: 0px;
  }
  .view-flow .viewflow-step .des-item .des {
    padding-bottom: 0px;
    border-radius: 0px;
  }
  .view-flow .viewflow-step .step-sec {
    padding: 0px;
    margin-left: 0px;
    width: 100%;
  }
  .view-flow .viewflow-step .clickarrow button {
    width: 25px;
    height: 25px;
  }
  .qr-ico {
    position: relative;
    right: 0px;
  }
}
/*table struture starts here*/
.table-wrap {
  max-height: 260px;
  overflow-y: auto;
  padding-right: 7px;
}
.table-wrap::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}
.table-wrap::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.table-wrap::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

table {
  padding-right: 20px;
  width: 100%;
}
table tr {
  display: flex;
  width: 100%;
  flex-flow: row wrap;
  justify-content: space-between;
}
table tr th {
  font-family: "Raleway";
  font-weight: 600 !important;
  font-size: 16px !important;
  width: 48%;
  word-break: break-all;
  margin-bottom: 15px;
  line-height: 25px;
}
table tr td {
  width: 100%;
  word-break: break-all;
  margin-bottom: 15px;
  font-family: "Raleway";
  font-weight: 400;
  line-height: 25px;
  font-size: 13px;
  position: relative;
  padding-left: 15px;
  display: flex;
}
table tr td > span {
  width: 48%;
  overflow-wrap: break-word;
}
table tr td > span:first-child {
  margin-right: 4%;
}
table tr td:before {
  content: "";
  width: 8px;
  height: 8px;
  background: grey;
  position: absolute;
  left: 0px;
  top: 8px;
  border-radius: 50%;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
}

.btm-btn {
  display: flex;
  align-items: center;
}
.btm-btn > div {
  flex: 1;
}
.btm-btn > div:first-child {
  justify-content: flex-start;
}
.btm-btn > div:last-child {
  justify-content: right;
  text-align: end;
}
.btm-btn .lock {
  display: flex;
  align-items: center;
  font-family: "Raleway";
}
.btm-btn .lock > span {
  display: flex;
  align-items: center;
}

.profilepic .lock {
  display: block;
}

.like-list .fashion-btn {
  display: block;
}

.qr-code .lock,
.qr-code .fashion-btn {
  display: none;
}

@media only screen and (max-width: 992px) and (min-width: 461px) {
  .view-flow .container1 .user-sec .user-details {
    flex-direction: row;
  }
  .view-flow .container1 .user-sec .user-details .ico-details {
    padding-left: 15px;
    max-width: 100%;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul {
    margin-left: -15px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like .qrcode span {
    margin-right: 15px !important;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic > div p {
    font-size: 14px !important;
  }
  .view-flow .container1 .description-wrapper {
    width: auto;
    margin: 10px 0px;
  }
  .view-flow .container1 .description-wrapper .step-sec .img-wrap {
    max-height: unset;
  }
  .view-flow .container1 .viewflow-step .des-item .des {
    padding-bottom: 20px;
    border-radius: 0px;
  }
  .view-flow .container1 .viewflow-step .clickarrow button.owl-next {
    right: -35px;
  }
  .view-flow .container1 .viewflow-step .clickarrow button.owl-prev {
    left: -35px;
  }
}
@media only screen and (max-width: 992px) and (min-width: 768px) {
  .view-flow .viewflow-step .clickarrow button {
    width: 35px;
    height: 35px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-prev {
    left: -45px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-next {
    right: -45px;
  }
}
@media only screen and (max-width: 460px) and (min-width: 320px) {
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic > div p {
    font-size: 11px !important;
  }
  .ico-details .profilepic > div:last-child span {
    font-size: 11px;
  }
  .view-flow .viewflow-step .clickarrow button {
    width: 25px;
    height: 25px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-prev {
    left: -30px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-next {
    right: -30px;
  }
  .view-flow .viewflow-step {
    width: auto;
    margin: 10px 20px;
  }
  .qr-code {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .qr-code .lock > span {
    display: flex;
    align-items: center;
  }
  .qr-code .lock .priceIcon-p {
    top: -2px;
  }
  .qr-code .lock,
  .qr-code .fashion-btn {
    display: block;
  }
  .profilepic .lock {
    display: none !important;
  }
  .like-list .fashion-btn {
    display: none !important;
  }
  .view-flow h2 span {
    font-size: 20px !important;
    word-break: break-word;
  }
  .view-flow .container1 .user-sec {
    padding: 10px;
  }
  .ico-details .profilepic .profinner > div {
    margin-right: 5px;
  }
  .ico-details .profilepic > div {
    margin-right: 0px;
  }
  .like li:last-child {
    display: none !important;
  }
  .viewflow-step .des-item .des p {
    max-height: 133px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul li span {
    font-size: 9px;
  }
}
button.common {
  padding: 3px 6px !important;
  background: #5ea1d8 !important;
  border: 0px !important;
  color: #fff !important;
  font-size: 13px !important;
  border-radius: 5px !important;
}

@media (max-width: 500px) {
  .ico-details .profilepic .qrcode {
    justify-content: center;
  }
}
.example-list {
  max-width: 100%;
  height: auto;
  display: block;
  background: white;
  overflow-y: auto;
}
.example-list .example-box {
  display: flex;
  padding: 15px 10px;
  border-bottom: 1px solid lightgrey;
  background: white !important;
}
.example-list .example-box .item-name {
  text-align: left;
  width: 70%;
}
.example-list .example-box .item-value {
  text-align: left;
  width: 30%;
}
.example-list .example-box .item-name,
.example-list .example-box .item-delete,
.example-list .example-box .item-reorder,
.example-list .example-box .item-value {
  text-align: left;
  padding: 5px;
  font-size: 14px;
  font-weight: 400 !important;
  overflow-wrap: break-word;
}
.example-list .example-box .item-delete,
.example-list .example-box .item-reorder {
  float: right;
  cursor: pointer;
  font-size: 20px;
  width: 10%;
}
.example-list .example-box:last-child {
  border-bottom: 0px;
}
.example-list::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}
.example-list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.example-list::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

.example-box {
  padding: 15px 10px;
  border-bottom: solid 1px lightgray;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: white;
  font-size: 14px;
}
.example-box > div {
  width: 50%;
  display: flex !important;
}
.example-box > div:first-child {
  width: 80%;
}
.example-box > div:last-child {
  width: 17%;
}
.example-box > div > span {
  text-align: left;
  word-break: keep-all;
  display: flex;
  align-items: center;
}
.example-box > div > span:first-child {
  flex: 1;
  width: 50%;
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: 400 !important;
}
.example-box > div > span:last-child {
  width: 50%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: end;
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: 400 !important;
}

.itemremove span:first-child {
  width: 90% !important;
}
.itemremove span:nth-child(2) {
  display: none;
}

.img-div-left {
  position: fixed;
  z-index: 9999999 !important;
  height: 100px;
  width: 100px;
  overflow: visible;
  margin: auto;
  top: 5% !important;
  left: 0;
  bottom: 0;
  right: 0;
}
.img-div-left img {
  width: 100%;
  height: 100%;
  position: absolute !important;
  top: 0% !important;
}

.card {
  height: 100px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 30%;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.card {
  width: calc(50% - 30px);
  box-shadow: none;
  margin: 40px auto 0px auto;
  height: auto !important;
}
.card .container {
  padding: 5px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

/*new design starts here new bundle*/
@media (max-width: 460px) {
  .viewbundle .step-sec + .row > div {
    width: 50% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
@media only screen and (min-width: 461px) and (max-width: 767px) {
  .viewbundle .step-sec + .row > div {
    width: 33% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
.bundleIcon {
  bottom: 10px;
  right: 10px;
  z-index: 10;
  width: 25px !important;
  height: 25px !important;
  max-width: 25px !important;
  height: 25px !important;
  margin-left: 10px;
}
.bundleIcon img {
  width: 100% !important;
  height: auto !important;
  object-fit: contain;
  border: none;
}

.ico-details .profilepic .uni-wrapper {
  display: flex;
  width: auto;
  align-items: center;
}
.ico-details .profilepic .uni-wrapper P {
  flex: 1;
}

@media only screen and (max-width: 767px) and (min-width: 320px) {
  .view-flow .container1 .user-sec {
    margin: 0px;
  }
  .view-flow .viewflow-step {
    margin: 10px 0px;
  }
  .ico-details .profilepic .qrcode {
    justify-content: right;
  }
}
/*new design add 14-05-2022*/
/* new common design add*/
.flobycategoryadd .user-pro .flowbycategory-row {
  width: calc(100% - 40px);
  margin: 0px 20px !important;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile {
  width: 18.6%;
  margin-right: 1%;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile .item {
  width: 100% !important;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dddddd;
  margin: 0px;
  margin-right: 20px;
  margin-bottom: 20px;
  height: 95%;
  position: relative;
  padding: 10px !important;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile .item div {
  margin: 0px !important;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile .item p {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 35px !important;
  white-space: normal;
  word-break: break-word;
  display: flex;
  align-items: flex-start;
  margin-top: 0px !important;
  line-height: 18px !important;
  margin-left: 5px;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile .item .uni-wrapper {
  display: flex;
  width: 100%;
  align-items: center;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile .item .with-icon {
  width: 100%;
  font-family: "Raleway";
  display: flex;
  align-items: center;
  margin: 0px !important;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile .item .with-icon img {
  object-fit: cover;
  height: 40px !important;
  border: 0px;
  margin: 0px !important;
}
.flobycategoryadd .user-pro .flowbycategory-row video.video-display[poster] {
  height: 100% !important;
  padding-bottom: 12%;
  max-height: 100% !important;
  max-width: 100% !important;
  width: 100% !important;
  text-align: center;
  cursor: pointer;
  min-height: 150px !important;
}
.flobycategoryadd .mat-sidenav-content {
  background: #efeeee !important;
  min-height: 89vh !important;
  padding: 2rem 3rem !important;
  padding-top: 0px !important;
}

@media only screen and (max-width: 992px) and (min-width: 320px) {
  .supportingdoc {
    position: relative !important;
    padding: 10px 10px 10px 0px !important;
  }
}
@media only screen and (max-width: 992px) and (min-width: 768px) {
  .flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile {
    max-width: 23% !important;
    width: 23% !important;
  }
  .view-flow .container1 .description-wrapper {
    margin: 10px 20px !important;
  }
}
@media only screen and (max-width: 767px) and (min-width: 320px) {
  .flobycategoryadd .user-pro .flowbycategory-row {
    width: 100%;
    margin: 0px !important;
  }
  .flobycategoryadd .mat-sidenav-content {
    background: #efeeee !important;
    min-height: 89vh !important;
    padding: 2rem 10px !important;
    padding-top: 0px !important;
  }
}
@media only screen and (max-width: 767px) and (min-width: 461px) {
  .flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile {
    max-width: 31.3% !important;
    width: 31.3% !important;
    margin: 1%;
  }
}
@media screen and (max-width: 460px) {
  .flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile {
    max-width: 48% !important;
    width: 48% !important;
    margin: 1%;
  }
}
.qrcode .uni-wrapper p .common {
  background: #e83e8c !important;
}

.view-flow .partOfBundle {
  padding: 0px 20px 20px;
  background: #fff;
  background: transparent;
  margin: 0px 20px 0px 0px;
  border-radius: 10px;
  overflow-x: scroll;
}
.view-flow .partOfBundle h2 {
  font-size: 2rem;
  line-height: 1.2;
  margin-bottom: 0px !important;
}

.flobycategoryadd .user-pro .flowbycategory-row {
  width: calc(100% - 0px);
  margin: 0px 0px 0px 0px !important;
}

.newdesignadd {
  border: 0px !important;
  padding: 0px !important;
}

.not-draggable {
  -webkit-user-drag: none; /* Safari/Chrome */ /* Firefox */ /* IE10+ */
  -webkit-user-select: none;
          user-select: none; /* Standard syntax */
  cursor: default; /* Optional: Change the cursor style */
  transform: translate(0, 0) !important;
  width: 100%;
}

.divscroll {
  width: 100% !important;
  display: flex;
  flex-direction: row;
  height: 100px;
  overflow-y: auto;
  overflow-x: hidden;
}
.divscroll div {
  width: 100% !important;
}

@media (max-width: 767px) {
  .partOfBundle {
    padding: 0px 0px 20px 0px !important;
    margin-right: 0px !important;
  }
  .partOfBundle h2 {
    margin-top: 0px !important;
  }
  .view-flow .container1 .viewflow-step {
    margin-bottom: 10px !important;
  }
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner div:nth-child(4) {
  position: relative;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner div:nth-child(4) span {
  position: relative !important;
}

@media (max-width: 767px) {
  .priceIcon-wp {
    position: relative !important;
  }
  .qr-code .fashion-btn + .fashion-btn {
    display: none !important;
  }
}
.qrcode.mobview {
  display: none;
}

@media (max-width: 767px) {
  .qrcode.mobview {
    display: flex;
    align-items: center;
  }
  .qrcode.mobview p {
    margin-bottom: 0px !important;
  }
  .desktopview {
    display: none;
  }
}
.view-flow .flow-layout-container {
  width: 100%;
  padding: 0;
  margin: 0;
}
.view-flow .flow-layout-container .flow-main-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 402px;
  gap: 24px;
  max-width: 100%;
  margin: 0;
  padding: 16px 24px;
  background: #f6f7f9;
}
@media (min-width: 1920px) {
  .view-flow .flow-layout-container .flow-main-grid {
    max-width: 1920px;
    margin: 0 auto;
    padding: 24px 48px;
  }
}
@media (max-width: 1024px) {
  .view-flow .flow-layout-container .flow-main-grid {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px;
    background: transparent;
  }
}
@media (max-width: 768px) {
  .view-flow .flow-layout-container .flow-main-grid {
    padding: 2px;
    gap: 12px;
  }
}
.view-flow .flow-main-content {
  min-width: 0;
  /* Sticky Bundle Title Bar */
}
.view-flow .flow-main-content .flow-title-sticky {
  top: 88px;
  z-index: 0;
  background: #ffffff;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: space-between;
  pointer-events: auto;
}
@media (max-width: 1024px) {
  .view-flow .flow-main-content .flow-title-sticky {
    border-radius: 0;
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
    border-bottom: 1px solid #e0e0e0;
    padding: 16px 0 8px 0;
    margin-bottom: 8px;
  }
}
.view-flow .flow-main-content .flow-title-sticky .video-title-sticky {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
  color: #0f0f0f;
  margin: 4px;
  font-family: "Raleway", sans-serif;
  flex: 1;
  min-width: 0;
}
.view-flow .flow-main-content .video-player-section {
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  position: relative;
}
@media (max-width: 1024px) {
  .view-flow .flow-main-content .video-player-section {
    margin: 0;
    border-radius: 0;
  }
  .view-flow .flow-main-content .video-player-section .img-wrap {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
  }
}
.view-flow .flow-main-content .video-player-section .img-wrap {
  width: 100%;
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
}
.view-flow .flow-main-content .video-player-section .img-wrap img,
.view-flow .flow-main-content .video-player-section .img-wrap video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}
.view-flow .flow-main-content .video-player-section .img-wrap .main-video-player {
  width: 100%;
  height: 100%;
}
.view-flow .flow-main-content .video-metadata {
  padding: 16px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 16px;
}
@media (max-width: 1024px) {
  .view-flow .flow-main-content .video-metadata {
    padding: 16px;
    background: #ffffff;
    border-radius: 0;
    box-shadow: none;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 0;
  }
}
.view-flow .flow-main-content .video-metadata .step-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 12px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.view-flow .flow-main-content .video-metadata .step-header .step-header-main {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}
.view-flow .flow-main-content .video-metadata .step-header .video-title {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: #0f0f0f;
  margin: 0;
  flex: 1;
  min-width: 0;
}
.view-flow .flow-main-content .video-metadata .video-actions-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
.view-flow .flow-main-content .video-metadata .video-actions-bar::-webkit-scrollbar {
  height: 6px;
}
.view-flow .flow-main-content .video-metadata .video-actions-bar::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.view-flow .flow-main-content .video-metadata .video-actions-bar::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}
.view-flow .flow-main-content .video-metadata .video-actions-bar .action-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  width: max-content;
}
.view-flow .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 18px;
  cursor: pointer;
  transition: background 0.2s;
  background: #f2f2f2;
  flex: 0 0 auto;
  /* Let labels inherit; do not set span to #212427 !important — it beats global dark theme. */
  color: #212427;
}
.view-flow .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item:hover:not(.disabled) {
  background: #e5e5e5;
}
.view-flow .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
.view-flow .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item.delete-action {
  background: #ffebee;
  color: #d32f2f;
}
.view-flow .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item.delete-action:hover {
  background: #ffcdd2;
}
.view-flow .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item.delete-action mat-icon {
  color: #d32f2f;
}
.view-flow .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item.delete-action span {
  color: #d32f2f;
}
.view-flow .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: currentColor;
}
.view-flow .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item mat-icon[style*="#5ea1d8"] {
  color: #5ea1d8 !important;
}
.view-flow .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item span {
  font-size: 14px;
  font-weight: 500;
}
.view-flow .flow-main-content .channel-info-section {
  padding: 16px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 16px;
}
@media (max-width: 1024px) {
  .view-flow .flow-main-content .channel-info-section {
    padding: 16px;
    background: #ffffff;
    border-radius: 0;
    box-shadow: none;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 0;
  }
}
.view-flow .flow-main-content .channel-info-section .channel-header {
  display: flex;
  align-items: center;
  gap: 16px;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-avatar {
  flex-shrink: 0;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-avatar img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-avatar .material-icons {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #606060;
  cursor: pointer;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-details {
  flex: 1;
  min-width: 0;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-details .channel-name {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  cursor: pointer;
  margin-bottom: 4px;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-details .channel-name:hover {
  color: #606060;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-details .channel-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 14px;
  color: #606060;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-details .channel-meta mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-details .channel-meta .price-tag {
  color: #e83e8c;
  cursor: pointer;
  font-weight: 500;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-details .channel-meta .price-tag:hover {
  text-decoration: underline;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-details .channel-meta .purchased-tag {
  color: #606060;
  background: #f2f2f2;
  padding: 2px 8px;
  border-radius: 4px;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-details .channel-meta .version-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #5ea1d8;
  background: #f0f0f0;
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-details .channel-meta .version-tag:hover {
  background: #e5e5e5;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-details .channel-meta .version-tag mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  color: #5ea1d8;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-actions .follow-btn {
  padding: 10px 16px;
  border-radius: 18px;
  border: 1px solid #5ea1d8;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-actions .follow-btn.following {
  background: #f2f8fc;
  color: #0f0f0f;
  border-color: #5ea1d8;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-actions .follow-btn.following:hover {
  background: #e1f0fa;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-actions .follow-btn:not(.following) {
  background: #5ea1d8;
  color: #ffffff;
  box-shadow: 0 4px 10px rgba(94, 161, 216, 0.35);
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-actions .follow-btn:not(.following):hover {
  background: #4b8ac1;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-actions .purchase-btn {
  padding: 10px 16px;
  border-radius: 18px;
  border: none;
  background: #e83e8c;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}
.view-flow .flow-main-content .channel-info-section .channel-header .channel-actions .purchase-btn:hover {
  background: #d0307a;
}
.view-flow .flow-main-content .description-section {
  padding: 16px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 16px;
}
@media (max-width: 1024px) {
  .view-flow .flow-main-content .description-section {
    background: #f9f9f9;
    border-radius: 12px;
    box-shadow: none;
  }
}
.view-flow .flow-main-content .description-section .description-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.view-flow .flow-main-content .description-section .description-content {
  font-size: 14px;
  line-height: 20px;
  color: #0f0f0f;
  max-height: 60px;
  overflow: hidden;
  transition: max-height 0.3s ease;
}
.view-flow .flow-main-content .description-section .description-content.expanded {
  max-height: none;
}
.view-flow .flow-main-content .description-section .description-content .supporting-docs-link {
  margin-top: 12px;
}
.view-flow .flow-main-content .description-section .description-content .supporting-docs-link a {
  color: #5ea1d8;
  text-decoration: none;
  font-weight: 500;
}
.view-flow .flow-main-content .description-section .description-content .supporting-docs-link a:hover {
  text-decoration: underline;
}
.view-flow .flow-main-content .description-section .expand-description-btn {
  margin-top: 8px;
  background: none;
  border: none;
  color: #606060;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
}
.view-flow .flow-main-content .description-section .expand-description-btn:hover {
  color: #0f0f0f;
}
.view-flow .flow-main-content .comments-section {
  padding: 16px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 16px;
}
@media (max-width: 1024px) {
  .view-flow .flow-main-content .comments-section {
    padding: 16px 0;
    background: transparent;
    border-radius: 0;
    box-shadow: none;
  }
}
.view-flow .flow-main-content .comments-section h3 {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin-bottom: 24px;
}
.view-flow .flow-main-content .comments-section .comment-input-section {
  display: flex;
  gap: 16px;
  margin-bottom: 32px;
}
.view-flow .flow-main-content .comments-section .comment-input-section .comment-avatar {
  flex-shrink: 0;
}
.view-flow .flow-main-content .comments-section .comment-input-section .comment-avatar img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.view-flow .flow-main-content .comments-section .comment-input-section .comment-avatar .material-icons {
  font-size: 40px;
  width: 40px;
  height: 40px;
  color: #606060;
}
.view-flow .flow-main-content .comments-section .comment-input-section .comment-form-wrapper {
  flex: 1;
  position: relative;
}
.view-flow .flow-main-content .comments-section .comment-input-section .comment-form-wrapper form {
  display: flex;
  align-items: center;
  gap: 8px;
}
.view-flow .flow-main-content .comments-section .comment-input-section .comment-form-wrapper .comment-input {
  flex: 1;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #e0e0e0;
  font-size: 14px;
  color: #0f0f0f;
  background: transparent;
}
.view-flow .flow-main-content .comments-section .comment-input-section .comment-form-wrapper .comment-input:focus {
  outline: none;
  border-bottom-color: #5ea1d8;
}
.view-flow .flow-main-content .comments-section .comment-input-section .comment-form-wrapper .comment-input::placeholder {
  color: #909090;
}
.view-flow .flow-main-content .comments-section .comment-input-section .comment-form-wrapper .comment-send-btn {
  flex-shrink: 0;
  background: transparent;
  border: none;
  color: #5ea1d8;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}
.view-flow .flow-main-content .comments-section .comment-input-section .comment-form-wrapper .comment-send-btn:hover:not(:disabled) {
  background: #f0f0f0;
  color: #4a8fc4;
}
.view-flow .flow-main-content .comments-section .comment-input-section .comment-form-wrapper .comment-send-btn:disabled {
  color: #ccc;
  cursor: not-allowed;
}
.view-flow .flow-main-content .comments-section .comment-input-section .comment-form-wrapper .comment-send-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.view-flow .flow-main-content .comments-section .comment-input-section .comment-form-wrapper .comment-guidelines-helper {
  color: #606060;
  font-size: 13px;
  margin-top: 6px;
}
.view-flow .flow-main-content .comments-section .comment-input-section .comment-form-wrapper .comment-guidelines-link {
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;
}
.view-flow .flow-main-content .comments-section .comment-input-section .comment-form-wrapper .comment-guidelines-link:hover {
  color: #1565c0;
}
.view-flow .flow-main-content .comments-section .comment-login-prompt {
  padding: 16px;
  background: #f9f9f9;
  border-radius: 8px;
  text-align: center;
}
.view-flow .flow-main-content .comments-section .comment-login-prompt p {
  margin: 0;
  font-size: 14px;
  color: #606060;
}
.view-flow .flow-main-content .comments-section .comment-login-prompt p a {
  color: #5ea1d8;
  cursor: pointer;
  text-decoration: none;
}
.view-flow .flow-main-content .comments-section .comment-login-prompt p a:hover {
  text-decoration: underline;
}
.view-flow .flow-main-content .comments-section .comments-list {
  margin-top: 24px;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item {
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  border-bottom: 1px solid #e0e0e0;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item:last-child {
  border-bottom: none;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .comment-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .comment-header .comment-author {
  display: flex;
  align-items: center;
  gap: 8px;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .comment-header .comment-author .comment-avatar-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .comment-header .comment-author .comment-avatar-icon {
  font-size: 40px;
  width: 40px;
  height: 40px;
  color: #606060;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .comment-header .comment-author .comment-author-name {
  font-size: 14px;
  font-weight: 500;
  color: #0f0f0f;
  font-family: "Raleway", sans-serif;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .comment-header .comment-date {
  font-size: 12px;
  color: #606060;
  font-family: "Raleway", sans-serif;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .comment-text {
  font-size: 14px;
  line-height: 20px;
  color: #0f0f0f;
  margin-bottom: 8px;
  font-family: "Raleway", sans-serif;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .comment-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -ms-overflow-style: none; /* IE/Edge */
  scrollbar-width: thin;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .comment-actions::-webkit-scrollbar {
  height: 4px;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .comment-actions::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .comment-actions .comment-action-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 0 0 auto;
  background: none;
  border: none;
  color: #606060;
  cursor: pointer;
  font-size: 14px;
  font-family: "Raleway", sans-serif;
  padding: 4px 8px;
  border-radius: 18px;
  transition: background 0.2s;
  height: auto;
  min-height: 28px; /* Consistent height for icon + count */
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .comment-actions .comment-action-btn mat-icon {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  line-height: 18px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  vertical-align: middle;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .comment-actions .comment-action-btn .like-count {
  font-size: 12px;
  line-height: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin: 0;
  padding: 0;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .comment-actions .comment-action-btn:hover {
  background: #f5f5f5;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .comment-actions .comment-action-btn.liked {
  color: #ff4d4d;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .comment-actions .comment-action-btn.liked mat-icon {
  color: #ff4d4d;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .comment-actions .comment-action-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .reply-form {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 8px 0;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .reply-form .reply-input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  font-size: 14px;
  color: #0f0f0f;
  background: #f9f9f9;
  font-family: "Raleway", sans-serif;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .reply-form .reply-input:focus {
  outline: none;
  border-color: #5ea1d8;
  background: #fff;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .reply-form .reply-input::placeholder {
  color: #909090;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .reply-form .reply-send-btn {
  flex-shrink: 0;
  background: #5ea1d8;
  border: none;
  color: white;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  transition: all 0.2s;
  font-size: 20px;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .reply-form .reply-send-btn:hover:not(:disabled) {
  background: #4a8fc4;
  transform: scale(1.05);
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .reply-form .reply-send-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .child-comments {
  margin-left: 56px;
  margin-top: 16px;
  padding-left: 16px;
  border-left: 2px solid #e0e0e0;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .child-comments .child-comment {
  padding: 12px 0;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .child-comments .child-comment .comment-header .comment-author .comment-avatar-img,
.view-flow .flow-main-content .comments-section .comments-list .comment-item .child-comments .child-comment .comment-header .comment-author .comment-avatar-icon {
  width: 32px;
  height: 32px;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .child-comments .child-comment .comment-header .comment-author .comment-author-name {
  font-size: 13px;
}
.view-flow .flow-main-content .comments-section .comments-list .comment-item .child-comments .child-comment .comment-text {
  font-size: 13px;
}
.view-flow .flow-main-content .comments-section .no-comments {
  padding: 32px;
  text-align: center;
  color: #606060;
  font-family: "Raleway", sans-serif;
}
.view-flow .flow-main-content .comments-section .no-comments p {
  margin: 0;
  font-size: 14px;
}
.view-flow .recommendations-section-mobile {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e0e0e0;
}
.view-flow .recommendations-section-mobile h2 {
  font-size: 18px;
  font-weight: 500;
  color: #0f0f0f;
  margin-bottom: 16px;
}
.view-flow .recommendations-section-mobile .recommendations-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-x: hidden;
}
.view-flow .recommendations-section-mobile .recommendation-item {
  display: flex;
  gap: 12px;
  cursor: pointer;
  padding: 12px;
  border-radius: 8px;
  transition: background 0.2s;
  overflow: hidden;
  background: #f9f9f9;
}
.view-flow .recommendations-section-mobile .recommendation-item:hover {
  background: #f0f0f0;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-thumbnail {
  flex-shrink: 0;
  width: 168px;
  height: 94px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-thumbnail .flow-seq-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 6;
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  background: rgba(94, 161, 216, 0.95);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-thumbnail img,
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-thumbnail video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-info {
  flex: 1;
  min-width: 0;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-info .recommendation-title {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin: 0 0 4px 0;
  line-height: 20px;
  white-space: normal;
  word-break: break-word;
  overflow: hidden;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-info .recommendation-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  color: #606060;
  flex-wrap: wrap;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-info .recommendation-meta .recommendation-creator {
  color: #606060;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-info .recommendation-meta .recommendation-id {
  color: #909090;
}
.view-flow .recommendations-section-mobile .recommendation-item .recommendation-info .recommendation-price {
  display: block;
  margin-top: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #e83e8c;
}
@media (min-width: 1025px) {
  .view-flow .recommendations-section-mobile {
    display: none !important;
  }
}
.view-flow .flow-sidebar {
  width: 402px;
  min-width: 402px;
  max-width: 402px;
  position: relative;
  z-index: 10;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
@media (max-width: 1024px) {
  .view-flow .flow-sidebar {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
}
.view-flow .flow-sidebar .recommendations-section {
  flex: 0 0 auto;
  padding-top: 0;
  border-top: 1px solid #e0e0e0;
  align-self: flex-start;
  width: 100%;
}
.view-flow .flow-sidebar .recommendations-section h2 {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin-bottom: 16px;
}
.view-flow .flow-sidebar .recommendations-section .recommendations-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-x: hidden;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item {
  display: flex;
  gap: 8px;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: background 0.2s;
  overflow: hidden;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item:hover {
  background: #f9f9f9;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-thumbnail {
  flex-shrink: 0;
  width: 168px;
  height: 94px;
  border-radius: 4px;
  overflow: hidden;
  background: #000;
  position: relative;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-thumbnail .flow-seq-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 6;
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  background: rgba(94, 161, 216, 0.95);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-thumbnail img,
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-thumbnail video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-thumbnail-skeleton {
  flex-shrink: 0;
  width: 168px;
  height: 94px;
  border-radius: 4px;
  overflow: hidden;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-thumbnail-skeleton img,
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-thumbnail-skeleton video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-info {
  flex: 1;
  min-width: 0;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-title {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin: 0 0 4px 0;
  line-height: 20px;
  white-space: normal;
  word-break: break-word;
  overflow: hidden;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  color: #606060;
  flex-wrap: wrap;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-meta .recommendation-creator {
  color: #606060;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-meta .recommendation-id {
  color: #909090;
}
.view-flow .flow-sidebar .recommendations-section .recommendation-item .recommendation-info .recommendation-price {
  display: block;
  margin-top: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #e83e8c;
}
@media (max-width: 1024px) {
  .view-flow .flow-sidebar .recommendations-section {
    display: none !important;
  }
}

.view-flow {
  background: #efeeee;
  min-height: 100vh;
  padding-top: 0;
  width: 100%;
  overflow-x: hidden;
}

/* Version preview in dialog: same grid + recommendations-section-mobile path as standalone; full-width container. */
.view-flow.viewbundle.preview-mode.mobile .container1 {
  padding: 0;
  margin: 0;
  max-width: 100%;
}

@media (max-width: 1024px) {
  .mobile-stacked-view {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 20px;
    background: #f6f7f9;
  }
  .mobile-top-panel {
    position: sticky;
    top: 76px;
    z-index: 3;
    padding: 12px 0 4px;
    background: linear-gradient(180deg, rgba(246, 247, 249, 0.98) 0%, rgba(246, 247, 249, 0.9) 60%, rgba(246, 247, 249, 0) 100%);
    -webkit-backdrop-filter: blur(8px);
            backdrop-filter: blur(8px);
  }
  .mobile-info-panel {
    padding: 0 12px;
    display: flex;
    overflow-x: auto;
    gap: 12px;
  }
  .mobile-info-panel .info-badge {
    flex: 0 0 auto;
  }
  .mobile-info-panel::-webkit-scrollbar {
    display: none;
  }
  .mobile-section {
    background: #ffffff;
    border-radius: 16px;
    overflow: hidden;
    scroll-margin-top: 140px;
  }
  .mobile-media {
    background: #000;
  }
  .mobile-media img,
  .mobile-media video {
    width: 100%;
    display: block;
    max-height: 260px;
    object-fit: cover;
  }
  .mobile-media-video {
    width: 100%;
    max-height: 260px;
    background: #000;
    border: 0;
  }
  .mobile-section-body {
    padding: 20px 20px 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .mobile-section-title {
    font-size: 20px;
    font-weight: 600;
    margin: 0;
    color: #1f2f46;
  }
  #mobile-bundle-categories .mobile-section-title {
    margin-bottom: 16px;
  }
  #mobile-bundle-categories .bundle-view-category {
    margin-bottom: 20px;
  }
  #mobile-bundle-categories .bundle-view-category:not(:first-of-type) {
    margin-top: 8px;
    padding-top: 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
  }
  #mobile-bundle-categories .bundle-view-category-title {
    font-size: 15px;
    font-weight: 600;
    line-height: 1.3;
    color: #374151;
    margin: 0 0 12px;
    padding-top: 4px;
  }
  .mobile-section-description {
    color: #4a5568;
    line-height: 1.6;
  }
  .mobile-section-description p {
    margin-bottom: 12px;
  }
  .mobile-meta-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
  }
  .mobile-meta-row .channel-header {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
  }
  .mobile-meta-row .channel-header .channel-avatar {
    flex-shrink: 0;
  }
  .mobile-meta-row .channel-header .channel-avatar img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    cursor: pointer;
  }
  .mobile-meta-row .channel-header .channel-avatar .material-icons {
    font-size: 40px;
    width: 40px;
    height: 40px;
    color: #606060;
    cursor: pointer;
  }
  .mobile-meta-row .channel-header .channel-details {
    flex: 1;
    min-width: 0;
  }
  .mobile-meta-row .channel-header .channel-details .channel-name {
    font-size: 14px;
    font-weight: 500;
    color: #0f0f0f;
    cursor: pointer;
    margin-bottom: 2px;
    font-family: "Raleway", sans-serif;
  }
  .mobile-meta-row .channel-header .channel-details .channel-name:hover {
    color: #606060;
  }
  .mobile-meta-row .channel-header .channel-details .channel-meta {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
    font-size: 12px;
    color: #606060;
    font-family: "Raleway", sans-serif;
  }
  .mobile-meta-row .channel-header .channel-details .channel-meta mat-icon {
    font-size: 14px;
    width: 14px;
    height: 14px;
  }
  .mobile-meta-row .channel-header .channel-details .channel-meta .price-tag {
    color: #e83e8c;
    cursor: pointer;
    font-weight: 500;
  }
  .mobile-meta-row .channel-header .channel-details .channel-meta .price-tag:hover {
    text-decoration: underline;
  }
  .mobile-meta-row .channel-header .channel-details .channel-meta .purchased-tag {
    color: #606060;
    background: #f2f2f2;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 11px;
  }
  .mobile-meta-row .channel-header .channel-actions {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
  }
  .mobile-meta-row .channel-header .channel-actions .follow-btn {
    padding: 8px 14px;
    border-radius: 18px;
    border: 1px solid #5ea1d8;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s, box-shadow 0.2s;
    white-space: nowrap;
  }
  .mobile-meta-row .channel-header .channel-actions .follow-btn.following {
    background: #f2f8fc;
    color: #0f0f0f;
    border-color: #5ea1d8;
  }
  .mobile-meta-row .channel-header .channel-actions .follow-btn.following:hover {
    background: #e1f0fa;
  }
  .mobile-meta-row .channel-header .channel-actions .follow-btn:not(.following) {
    background: #5ea1d8;
    color: #ffffff;
    box-shadow: 0 4px 10px rgba(94, 161, 216, 0.35);
  }
  .mobile-meta-row .channel-header .channel-actions .follow-btn:not(.following):hover {
    background: #4b8ac1;
  }
  .mobile-meta-row .channel-header .channel-actions .purchase-btn {
    padding: 8px 14px;
    border-radius: 18px;
    border: none;
    background: #e83e8c;
    color: white;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s;
    white-space: nowrap;
  }
  .mobile-meta-row .channel-header .channel-actions .purchase-btn:hover {
    background: #d0307a;
  }
  .mobile-actions-bar {
    display: flex;
    gap: 16px;
    padding: 12px 0;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    margin: 12px 0;
  }
  .mobile-actions-bar .action-item {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    color: #606060;
    font-size: 14px;
  }
  .mobile-actions-bar .action-item mat-icon {
    font-size: 20px;
    width: 20px;
    height: 20px;
  }
  .mobile-actions-bar .action-item mat-icon[style*="#5ea1d8"] {
    color: #5ea1d8 !important;
  }
  .mobile-supporting-doc {
    margin-top: 12px;
    color: #5ea1d8;
    text-decoration: none;
  }
  .mobile-flows-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 16px;
  }
  .mobile-flow-card {
    display: flex;
    gap: 12px;
    padding: 12px;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    cursor: pointer;
    transition: background 0.2s;
  }
  .mobile-flow-card:hover {
    background: #f9f9f9;
  }
  .mobile-flow-media {
    flex-shrink: 0;
    width: 140px;
    height: 90px;
    border-radius: 8px;
    overflow: hidden;
    background: #000;
  }
  .mobile-flow-media img,
  .mobile-flow-media video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .mobile-flow-content {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .mobile-flow-content h3 {
    font-size: 16px;
    font-weight: 500;
    margin: 0;
    color: #0f0f0f;
    line-height: 20px;
  }
  .mobile-flow-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #606060;
    flex-wrap: wrap;
  }
  .mobile-flow-price {
    margin-left: auto;
    font-weight: 600;
    color: #e83e8c;
  }
  .mobile-flow-description {
    color: #4a5568;
    font-size: 14px;
    line-height: 1.5;
  }
  .mobile-flow-description p {
    margin-bottom: 8px;
  }
}
@media (max-width: 767px) {
  .view-flow {
    width: 100vw !important;
    margin: 0 !important;
    padding: 0 !important;
    background: #ffffff;
  }
  .view-flow .container1,
  .view-flow .flow-layout-container,
  .view-flow .flow-layout-container .flow-main-grid,
  .view-flow .flow-layout-container .flow-main-content {
    width: 100vw !important;
    max-width: 100vw !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  .view-flow .container1 .user-sec {
    padding: 16px !important;
    margin: 0 !important;
    border-radius: 0 !important;
  }
  .view-flow .flow-layout-container .flow-main-grid {
    grid-template-columns: 1fr !important;
    gap: 0 !important;
  }
  .view-flow .flow-layout-container .flow-main-content .flow-title-sticky {
    padding: 1px 5px !important;
    margin: 0 !important;
  }
  .view-flow .flow-layout-container .flow-main-content .video-actions-bar {
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0 16px 12px 16px !important;
  }
  .view-flow .flow-layout-container .flow-main-content .video-actions-bar .action-buttons {
    flex-wrap: nowrap !important;
    gap: 8px !important;
    width: max-content;
  }
  .view-flow .flow-layout-container .flow-main-content .video-actions-bar .action-item {
    flex: 0 0 auto;
    min-width: 100px;
    padding: 6px 10px !important;
    gap: 6px !important;
    border-radius: 14px !important;
  }
  .view-flow .flow-layout-container .flow-main-content .video-actions-bar .action-item mat-icon {
    font-size: 18px !important;
    width: 18px !important;
    height: 18px !important;
  }
  .view-flow .flow-layout-container .flow-main-content .video-actions-bar .action-item span {
    font-size: 13px !important;
    font-weight: 500;
  }
  .view-flow .flow-layout-container .flow-main-content .video-actions-bar::-webkit-scrollbar {
    height: 4px;
  }
  .view-flow .flow-layout-container .flow-main-content .video-actions-bar::-webkit-scrollbar-thumb {
    border-radius: 4px;
  }
  .view-flow .flow-layout-container .flow-main-content .flow-info-panel,
  .view-flow .flow-layout-container .flow-main-content .video-metadata,
  .view-flow .flow-layout-container .flow-main-content .channel-info-section,
  .view-flow .flow-layout-container .flow-main-content .description-section,
  .view-flow .flow-layout-container .flow-main-content .comments-section {
    padding: 16px !important;
    margin: 0 !important;
    border-radius: 0 !important;
  }
  .view-flow .flow-layout-container .flow-main-content .video-player-section {
    margin: 0 !important;
    border-radius: 0 !important;
  }
  .view-flow .flow-layout-container .flow-main-content .video-player-section .img-wrap {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
  }
}
/* Keep layout usable on common laptop resolutions without manual display scaling changes. */
@media (max-width: 1366px) {
  .view-flow .flow-layout-container .flow-main-grid {
    grid-template-columns: 1fr !important;
  }
  .view-flow .flow-sidebar {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
  }
  .view-flow .flow-sidebar .recommendations-section {
    display: none !important;
  }
  .view-flow .recommendations-section-mobile {
    display: block !important;
  }
}
.follow-btn:disabled {
  opacity: 0.8;
  cursor: not-allowed;
}

.btn-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
  animation: follow-spin 0.7s linear infinite;
  vertical-align: middle;
}

@keyframes follow-spin {
  to {
    transform: rotate(360deg);
  }
}
/* Dark mode overrides for view-bundle page */
:host-context(body.theme-dark) {
  /* Comment items + inputs — match view-flow dark mode treatment */
  /* Global dark mode forces light text on all spans; keep action chips dark so text + icons are visible. */
  /* Force readable action row content (base styles use dark text !important). */
  /* Strong fallback: force readable white text inside key view-bundle sections. */
  /* Keep intended accent colors after broad white fallback. */
  /* Restore muted colour for comment action buttons — must come after the broad
     div/span white fallback rule above to win the !important specificity tie. */
  /* Version tag: light grey bg (#f0f0f0) becomes invisible on dark sections; use dark blue chip. */
  /* Higher-specificity selector wins over the broad .comments-section p rule above */
  /* Follow button — dark mode: keep non-following state as-is (blue), update
     following state so light-grey bg doesn't appear washed out on dark surface. */
  /* Mobile: base \`.view-flow\` block forces white page bg; keep view-bundle dark on ≤767px. */
}
:host-context(body.theme-dark) .view-flow.viewbundle,
:host-context(body.theme-dark) .view-flow.viewbundle .container1,
:host-context(body.theme-dark) .view-flow.viewbundle .flow-layout-container,
:host-context(body.theme-dark) .view-flow.viewbundle .flow-main-grid,
:host-context(body.theme-dark) .view-flow.viewbundle .flow-main-content,
:host-context(body.theme-dark) .view-flow.viewbundle .flow-sidebar,
:host-context(body.theme-dark) .view-flow.viewbundle .mobile-stacked-view {
  background: #0a0c10 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .flow-main-grid {
  background: #0a0c10 !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .flow-title-sticky,
:host-context(body.theme-dark) .view-flow.viewbundle .video-metadata,
:host-context(body.theme-dark) .view-flow.viewbundle .channel-info-section,
:host-context(body.theme-dark) .view-flow.viewbundle .description-section,
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section,
:host-context(body.theme-dark) .view-flow.viewbundle .mobile-section,
:host-context(body.theme-dark) .view-flow.viewbundle .preview-dialog-header,
:host-context(body.theme-dark) .view-flow.viewbundle .preview-inline-description {
  background: #111827 !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .preview-dialog-header,
:host-context(body.theme-dark) .view-flow.viewbundle .mobile-actions-bar,
:host-context(body.theme-dark) .view-flow.viewbundle .flow-sidebar .recommendations-section {
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section .comment-item,
:host-context(body.theme-dark) .view-flow.viewbundle .comment-input,
:host-context(body.theme-dark) .view-flow.viewbundle .reply-input {
  background: #111827 !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .video-player-section,
:host-context(body.theme-dark) .view-flow.viewbundle .mobile-media,
:host-context(body.theme-dark) .view-flow.viewbundle .mobile-media-video,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendation-thumbnail {
  background: #020617 !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .video-title-sticky,
:host-context(body.theme-dark) .view-flow.viewbundle .video-title,
:host-context(body.theme-dark) .view-flow.viewbundle .channel-name,
:host-context(body.theme-dark) .view-flow.viewbundle .description-content,
:host-context(body.theme-dark) .view-flow.viewbundle .comment-text,
:host-context(body.theme-dark) .view-flow.viewbundle .comment-author-name,
:host-context(body.theme-dark) .view-flow.viewbundle .mobile-section-title,
:host-context(body.theme-dark) .view-flow.viewbundle .mobile-flow-content h3,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendation-title,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section h2,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section-mobile h2,
:host-context(body.theme-dark) .view-flow.viewbundle .preview-dialog-header h2,
:host-context(body.theme-dark) .view-flow.viewbundle .preview-unique-code-label,
:host-context(body.theme-dark) .view-flow.viewbundle .preview-unique-code-value {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .channel-meta,
:host-context(body.theme-dark) .view-flow.viewbundle .comment-date,
:host-context(body.theme-dark) .view-flow.viewbundle .comment-action-btn,
:host-context(body.theme-dark) .view-flow.viewbundle .no-comments,
:host-context(body.theme-dark) .view-flow.viewbundle .mobile-flow-meta,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendation-meta,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendation-creator,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendation-id,
:host-context(body.theme-dark) .view-flow.viewbundle .preview-unique-code,
:host-context(body.theme-dark) .view-flow.viewbundle .close-button,
:host-context(body.theme-dark) .view-flow.viewbundle .close-button mat-icon {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .action-item,
:host-context(body.theme-dark) .view-flow.viewbundle .comment-login-prompt,
:host-context(body.theme-dark) .view-flow.viewbundle .no-results-message,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendation-item,
:host-context(body.theme-dark) .view-flow.viewbundle .mobile-flow-card,
:host-context(body.theme-dark) .view-flow.viewbundle .reply-input {
  background: #111827 !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item {
  background: #111827 !important;
  border: 1px solid rgba(148, 163, 184, 0.28) !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .flow-main-content .video-metadata .video-actions-bar .action-buttons .action-item:hover:not(.disabled) {
  background: #1b2437 !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .mobile-actions-bar {
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .mobile-actions-bar .action-item {
  background: #111827 !important;
  border: 1px solid rgba(148, 163, 184, 0.28) !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .mobile-actions-bar .action-item mat-icon {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .action-item span,
:host-context(body.theme-dark) .view-flow.viewbundle .action-item mat-icon,
:host-context(body.theme-dark) .view-flow.viewbundle .action-item .review-icon,
:host-context(body.theme-dark) .view-flow.viewbundle .video-actions-bar .action-buttons .action-item span,
:host-context(body.theme-dark) .view-flow.viewbundle .video-actions-bar .action-buttons .action-item mat-icon {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .action-item .bookmark-state-icon,
:host-context(body.theme-dark) .view-flow.viewbundle .action-item .bookmark-state-icon.saved {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .video-actions-bar .action-buttons .action-item.delete-action,
:host-context(body.theme-dark) .view-flow.viewbundle .video-actions-bar .action-buttons .action-item.delete-action span,
:host-context(body.theme-dark) .view-flow.viewbundle .video-actions-bar .action-buttons .action-item.delete-action mat-icon {
  color: #ef5350 !important;
  background: rgba(211, 47, 47, 0.12) !important;
  border-color: rgba(211, 47, 47, 0.3) !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .action-item .favorite-toggle-icon.liked,
:host-context(body.theme-dark) .view-flow.viewbundle .action-item.liked .favorite-toggle-icon,
:host-context(body.theme-dark) .view-flow.viewbundle .video-actions-bar .action-buttons .action-item .favorite-toggle-icon.liked,
:host-context(body.theme-dark) .view-flow.viewbundle .video-actions-bar .action-buttons .action-item.liked .favorite-toggle-icon {
  color: #ff4d4d !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .description-section h3,
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section h3,
:host-context(body.theme-dark) .view-flow.viewbundle .channel-meta span,
:host-context(body.theme-dark) .view-flow.viewbundle .channel-meta .textbodycolor,
:host-context(body.theme-dark) .view-flow.viewbundle .comment-login-prompt p,
:host-context(body.theme-dark) .view-flow.viewbundle .comment-login-prompt a {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .video-metadata p,
:host-context(body.theme-dark) .view-flow.viewbundle .video-metadata span,
:host-context(body.theme-dark) .view-flow.viewbundle .video-metadata h1,
:host-context(body.theme-dark) .view-flow.viewbundle .video-metadata h2,
:host-context(body.theme-dark) .view-flow.viewbundle .video-metadata h3,
:host-context(body.theme-dark) .view-flow.viewbundle .video-metadata h4,
:host-context(body.theme-dark) .view-flow.viewbundle .video-metadata a,
:host-context(body.theme-dark) .view-flow.viewbundle .video-metadata label,
:host-context(body.theme-dark) .view-flow.viewbundle .video-metadata div,
:host-context(body.theme-dark) .view-flow.viewbundle .channel-info-section p,
:host-context(body.theme-dark) .view-flow.viewbundle .channel-info-section span,
:host-context(body.theme-dark) .view-flow.viewbundle .channel-info-section h1,
:host-context(body.theme-dark) .view-flow.viewbundle .channel-info-section h2,
:host-context(body.theme-dark) .view-flow.viewbundle .channel-info-section h3,
:host-context(body.theme-dark) .view-flow.viewbundle .channel-info-section h4,
:host-context(body.theme-dark) .view-flow.viewbundle .channel-info-section a,
:host-context(body.theme-dark) .view-flow.viewbundle .channel-info-section label,
:host-context(body.theme-dark) .view-flow.viewbundle .channel-info-section div,
:host-context(body.theme-dark) .view-flow.viewbundle .description-section p,
:host-context(body.theme-dark) .view-flow.viewbundle .description-section span,
:host-context(body.theme-dark) .view-flow.viewbundle .description-section h1,
:host-context(body.theme-dark) .view-flow.viewbundle .description-section h2,
:host-context(body.theme-dark) .view-flow.viewbundle .description-section h3,
:host-context(body.theme-dark) .view-flow.viewbundle .description-section h4,
:host-context(body.theme-dark) .view-flow.viewbundle .description-section a,
:host-context(body.theme-dark) .view-flow.viewbundle .description-section label,
:host-context(body.theme-dark) .view-flow.viewbundle .description-section div,
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section p,
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section span,
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section h1,
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section h2,
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section h3,
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section h4,
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section a,
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section label,
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section div,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section p,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section span,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section h1,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section h2,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section h3,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section h4,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section a,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section label,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section div,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section-mobile p,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section-mobile span,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section-mobile h1,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section-mobile h2,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section-mobile h3,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section-mobile h4,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section-mobile a,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section-mobile label,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section-mobile div {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .price-tag,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendation-price {
  color: #f472b6 !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section .comment-action-btn,
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section .comment-action-btn mat-icon,
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section .comment-action-btn span {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section .comment-action-btn.liked,
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section .comment-action-btn.liked mat-icon,
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section .comment-action-btn.liked span {
  color: #ff4d4d !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section .comment-send-btn {
  color: #5ea1d8 !important;
  background: transparent !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section .comment-send-btn:hover:not(:disabled) {
  background: #1b2437 !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section .comment-send-btn:disabled {
  color: #4b5563 !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .version-tag {
  background: #1e3a5f !important;
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .version-tag:hover {
  background: #243f6a !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .version-tag mat-icon,
:host-context(body.theme-dark) .view-flow.viewbundle .description-content .supporting-docs-link a {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .purchased-tag {
  color: #cbd5e1 !important;
  background: #1f2937 !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section .recommendation-item,
:host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section-mobile .recommendation-item {
  border: 1px solid rgba(148, 163, 184, 0.24) !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .action-item:hover,
:host-context(body.theme-dark) .view-flow.viewbundle .comment-action-btn:hover,
:host-context(body.theme-dark) .view-flow.viewbundle .comment-send-btn:hover:not(:disabled),
:host-context(body.theme-dark) .view-flow.viewbundle .recommendation-item:hover,
:host-context(body.theme-dark) .view-flow.viewbundle .mobile-flow-card:hover {
  background: #273449 !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .comment-input {
  color: #ffffff !important;
  border-bottom-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .comment-input::placeholder,
:host-context(body.theme-dark) .view-flow.viewbundle .reply-input::placeholder {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .expand-description-btn {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .expand-description-btn:hover {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section .comment-form-wrapper .comment-guidelines-helper {
  color: #fca5a5 !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section .comment-form-wrapper .comment-guidelines-helper .comment-guidelines-link {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .comments-section .comment-form-wrapper .comment-guidelines-helper .comment-guidelines-link:hover {
  color: #60a5fa !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .mobile-top-panel {
  background: linear-gradient(180deg, rgba(15, 23, 42, 0.98) 0%, rgba(15, 23, 42, 0.9) 60%, rgba(15, 23, 42, 0) 100%) !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .video-actions-bar::-webkit-scrollbar-thumb,
:host-context(body.theme-dark) .view-flow.viewbundle .comment-actions::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.55) !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .video-actions-bar::-webkit-scrollbar-thumb:hover {
  background: rgba(148, 163, 184, 0.75) !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .channel-actions .follow-btn:not(.following) {
  background: #5ea1d8 !important;
  color: #ffffff !important;
  border: none !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .channel-actions .follow-btn.following {
  background: #1e3a5f !important;
  color: #93c5fd !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .preview-unavailable {
  color: #fca5a5 !important;
}
:host-context(body.theme-dark) .view-flow.viewbundle .preview-unavailable-body {
  background: rgba(127, 29, 29, 0.25) !important;
  border-color: rgba(248, 113, 113, 0.35) !important;
  color: #fecaca !important;
}
@media (max-width: 767px) {
  :host-context(body.theme-dark) .view-flow.viewbundle {
    background: #0a0c10 !important;
  }
  :host-context(body.theme-dark) .view-flow.viewbundle .container1,
  :host-context(body.theme-dark) .view-flow.viewbundle .flow-layout-container,
  :host-context(body.theme-dark) .view-flow.viewbundle .flow-main-grid,
  :host-context(body.theme-dark) .view-flow.viewbundle .flow-main-content,
  :host-context(body.theme-dark) .view-flow.viewbundle .mobile-stacked-view {
    background: transparent !important;
  }
  :host-context(body.theme-dark) .view-flow.viewbundle .flow-layout-container .flow-main-content .video-metadata,
  :host-context(body.theme-dark) .view-flow.viewbundle .flow-layout-container .flow-main-content .channel-info-section,
  :host-context(body.theme-dark) .view-flow.viewbundle .flow-layout-container .flow-main-content .description-section,
  :host-context(body.theme-dark) .view-flow.viewbundle .flow-layout-container .flow-main-content .flow-info-panel,
  :host-context(body.theme-dark) .view-flow.viewbundle .flow-layout-container .flow-main-content .comments-section,
  :host-context(body.theme-dark) .view-flow.viewbundle .mobile-section {
    background: #111827 !important;
  }
  :host-context(body.theme-dark) .view-flow.viewbundle .flow-title-sticky {
    background: #111827 !important;
  }
  :host-context(body.theme-dark) .view-flow.viewbundle .video-player-section,
  :host-context(body.theme-dark) .view-flow.viewbundle .mobile-media,
  :host-context(body.theme-dark) .view-flow.viewbundle .mobile-media-video {
    background: #020617 !important;
  }
  :host-context(body.theme-dark) .view-flow.viewbundle .mobile-actions-bar {
    background: #0a0c10 !important;
    border-color: rgba(148, 163, 184, 0.28) !important;
  }
  :host-context(body.theme-dark) .view-flow.viewbundle .mobile-actions-bar .action-item {
    background: #111827 !important;
    border: 1px solid rgba(148, 163, 184, 0.28) !important;
    color: #ffffff !important;
  }
  :host-context(body.theme-dark) .view-flow.viewbundle .mobile-actions-bar .action-item span,
  :host-context(body.theme-dark) .view-flow.viewbundle .mobile-actions-bar .action-item mat-icon {
    color: #ffffff !important;
  }
  :host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section-mobile {
    background: transparent !important;
  }
  :host-context(body.theme-dark) .view-flow.viewbundle .recommendations-section-mobile .recommendation-item {
    background: #111827 !important;
    border: 1px solid rgba(148, 163, 184, 0.24) !important;
    color: #ffffff !important;
  }
  :host-context(body.theme-dark) .view-flow.viewbundle .mobile-flow-card {
    background: #111827 !important;
    border-color: rgba(148, 163, 184, 0.28) !important;
    color: #ffffff !important;
  }
  :host-context(body.theme-dark) .view-flow.viewbundle h1,
  :host-context(body.theme-dark) .view-flow.viewbundle h2,
  :host-context(body.theme-dark) .view-flow.viewbundle h3,
  :host-context(body.theme-dark) .view-flow.viewbundle h4,
  :host-context(body.theme-dark) .view-flow.viewbundle h5,
  :host-context(body.theme-dark) .view-flow.viewbundle h6,
  :host-context(body.theme-dark) .view-flow.viewbundle p,
  :host-context(body.theme-dark) .view-flow.viewbundle span,
  :host-context(body.theme-dark) .view-flow.viewbundle label {
    color: #ffffff !important;
  }
}

.view-flow.viewbundle.embed-mode {
  padding-top: 0;
}
.view-flow.viewbundle.embed-mode .container1 {
  max-width: 100%;
  padding: 0 12px 12px;
}
.view-flow.viewbundle.embed-mode .recommendation-title--link {
  cursor: pointer;
  color: #5ea1d8;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.view-flow.viewbundle.embed-mode .recommendation-title--link:hover {
  color: #4a8fc4;
}

.draft-preview-note {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #eef4ff;
  border: 1px solid #c7d7fe;
  color: #1e3a8a;
  font-size: 13px;
}
.draft-preview-note mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

/* Same button size, radius and icon alignment as the guide page's channel actions. */
.view-flow .channel-actions {
  align-items: center;
}
.view-flow .channel-actions > button.follow-btn,
.view-flow .channel-actions > button.purchase-btn {
  box-sizing: border-box !important;
  min-width: 140px;
  height: 38px !important;
  padding: 0 16px !important;
  border-radius: 8px !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-family: "Raleway", sans-serif;
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 1;
  white-space: nowrap;
}
.view-flow .channel-actions .btn-spinner {
  margin-right: 0;
}
@media (max-width: 768px) {
  .view-flow .channel-actions > button.follow-btn,
  .view-flow .channel-actions > button.purchase-btn {
    min-width: 120px;
    height: 36px !important;
    font-size: 13px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/view-bundle/view-bundle.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,mDAAA;AACA;EACE;;;;;GAAA;EAMA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;AAEF;AAEI;EAIE,8BAAA;AAHN;AAOE;;;;;EAKE,0CAAA;EACA,0BAAA;EACA,yFAAA;AALJ;AASE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;AAPJ;AASI;EACE,YAAA;EACA,UAAA;AAPN;AAUI;EACE,YAAA;EACA,UAAA;AARN;AAWI;EACE,YAAA;EACA,WAAA;AATN;AAYI;EACE,UAAA;AAVN;AAaI;EACE,UAAA;AAXN;AAeE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAbJ;AAgBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAdJ;AAgBI;EACE,WAAA;EACA,YAAA;AAdN;AAiBI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAfN;AAmBE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AAjBJ;AAmBI;EACE,aAAA;AAjBN;AAoBI;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AAlBN;AAsBE;EACE,eAAA;AApBJ;AAuBE;EACE,gBAAA;EACA,mBAAA;EACA,8CAAA;EACA,mBAAA;AArBJ;AAwBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAtBJ;AAyBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;AAvBJ;AA0BE;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,oCAAA;AAxBJ;AA2BE;EACE,WAAA;EACA,YAAA;EACA,SAAA;AAzBJ;AA4BE;EACE,aAAA;EACA,eAAA;EACA,SAAA;AA1BJ;AA6BE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;AA3BJ;AA6BI;EACE,WAAA;EACA,YAAA;EACA,SAAA;AA3BN;AAgCE;EACE,8BAAA;AA9BJ;AAgCI;EACE,8BAAA;AA9BN;AAgCM;;EAEE,8BAAA;AA9BR;AAiCM;EACE,8BAAA;EACA,qDAAA;AA/BR;AAoCE;EACE,8BAAA;AAlCJ;AAoCI;;EAEE,8BAAA;AAlCN;AAqCI;EACE,8BAAA;EACA,qDAAA;AAnCN;AAuCE;EACE,8BAAA;AArCJ;AAyCE;;;;EAIE,8BAAA;AAvCJ;AAyCI;;;;;;;;EAEE,8BAAA;AAjCN;AAsCI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AApCN;AAuCI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AArCN;AAwCI;EACE,OAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AAtCN;AAyCI;EACE,gBAAA;AAvCN;AAyCM;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAvCR;AA0CM;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AAxCR;AA8CI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AA5CN;AA+CI;;EAEE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AA7CN;AAgDI;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AA9CN;AAkDE;EACE,YAAA;AAhDJ;AAoDI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AAlDN;AAqDI;EACE,OAAA;AAnDN;AAuDE;EACE,sBAAA;AArDJ;AAyDI;EACE,iBAAA;EACA,gBAAA;AAvDN;AA0DI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAxDN;AA2DI;EACE,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAzDN;AA4DI;EACE,OAAA;EACA,YAAA;EACA,SAAA;AA1DN;AA+DI;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;AA7DN;AAgEI;EACE,eAAA;EACA,mBAAA;AA9DN;AAgEM;EACE,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AA9DR;AAiEM;EACE,mBAAA;AA/DR;AAiEQ;EACE,eAAA;EACA,iBAAA;EACA,yCAAA;AA/DV;AAmEM;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAjER;AAsEI;;;EAGE,8BAAA;EACA,sCAAA;EACA,mCAAA;EACA,mCAAA;EAEA,2BAAA;AApEN;AAuEI;EACE,mBAAA;EACA,WAAA;AArEN;AAwEI;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,QAAA;AAtEN;AAwEM;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAtER;AAyEM;EACE,OAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AAvER;AA2EI;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AAzEN;AA2EM;;EAEE,OAAA;EACA,YAAA;EACA,0BAAA;EACA,oCAAA;EACA,8BAAA;EACA,sCAAA;EACA,mCAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,cAAA;EACA,sBAAA;EACA,mCAAA;EAEA,2BAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AAzER;AA2EQ;;EACE,cAAA;AAxEV;AA2EQ;;EACE,gCAAA;EACA,gBAAA;EACA,8BAAA;EACA,sCAAA;EACA,mCAAA;AAxEV;AA4EM;EACE,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,6CAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AA1ER;AA4EQ;EACE,cAAA;EACA,yBAAA;AA1EV;AA6EQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA3EV;AA+EM;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,6CAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AA7ER;AA+EQ;EACE,cAAA;EACA,yBAAA;AA7EV;AAgFQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA9EV;AAoFI;EACE;IACE,YAAA;EAlFN;EAoFM;;IAEE,eAAA;IACA,0BAAA;IACA,YAAA;IACA,8BAAA;IACA,sCAAA;IACA,mCAAA;EAlFR;AACF;AAsFI;EACE;IACE,YAAA;EApFN;EAsFM;;IAEE,eAAA;IACA,0BAAA;IACA,YAAA;IACA,8BAAA;IACA,sCAAA;IACA,mCAAA;EApFR;EAuFM;IACE,WAAA;IACA,WAAA;IACA,YAAA;EArFR;EAuFQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;EArFV;EAyFM;IACE,UAAA;IACA,WAAA;IACA,YAAA;EAvFR;EAyFQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAvFV;AACF;AA4FI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AA1FN;AA6FI;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AA3FN;AA6FM;EACE,SAAA;EACA,cAAA;AA3FR;AA+FI;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iDAAA;AA7FN;AA+FM;EACE,mBAAA;EACA,2BAAA;AA7FR;AAgGM;EACE,gBAAA;AA9FR;AAkGI;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAhGN;AAkGM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,oCAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,yCAAA;AAhGR;AAmGM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAjGR;AAoGM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAlGR;AAsGI;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AApGN;AAsGM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;AApGR;AAuGM;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AArGR;AAuGQ;EACE,gBAAA;AArGV;AAwGQ;EACE,cAAA;AAtGV;AA0GM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAxGR;AA4GI;EACE,YAAA;EACA,UAAA;AA1GN;AAiHI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA/GN;AAkHI;EACE,cAAA;AAhHN;AAmHI;EACE,WAAA;EACA,gBAAA;AAjHN;AAoHI;EACE,aAAA;EACA,mBAAA;AAlHN;AAqHI;EACE,aAAA;EACA,mBAAA;AAnHN;AAsHI;EACE,gBAAA;AApHN;AAuHI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,gCAAA;AArHN;AAuHM;EACE,mBAAA;AArHR;AAwHM;EACE,OAAA;AAtHR;AA0HI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAxHN;AA2HI;EACE,aAAA;AAzHN;AA4HI;EACE,eAAA;EACA,gCAAA;AA1HN;AA4HM;EACE,mBAAA;AA1HR;;AAgIA,iEAAA;AACA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA7HF;;AAgIA;EACE,aAAA;EACA,wCAAA;EACA,mCAAA;EACA,mBAAA;EACA,mBAAA;AA7HF;;AAgIA;EACE;IACE,4BAAA;EA7HF;EA+HA;IACE,2BAAA;EA7HF;AACF;AAgIA;EACE;IACE,UAAA;EA9HF;EAgIA;IACE,aAAA;EA9HF;EAgIA;IACE,UAAA;EA9HF;AACF;AAiIA,6CAAA;AAEE;EACE;;;;;GAAA;EAMA,8BAAA;AAhIJ;AAkII;;;;;EAKE,oCAAA;AAhIN;AAmII;;EAEE,8BAAA;EACA,iDAAA;EACA,2BAAA;AAjIN;AAoII;;;;;;;;EAQE,8BAAA;AAlIN;AAqII;;EAEE,gDAAA;AAnIN;;AAwIA;EACE,YAAA;EACA,WAAA;AArIF;;AAwIA;EACE,gBAAA;EACA,gBAAA;AArIF;;AAwIA;4DAAA;AAEA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AArIF;AAuIE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AArIJ;AAsII;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,mBAAA;AApIN;AAuII;EACE,SAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AArIN;AAwII;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EAAA,kBAAA;AAtIN;AAwIM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAtIR;AA0II;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AAxIN;AA0IM;EACE,gBAAA;EACA,cAAA;AAxIR;AA2IM;EACE,+GAAA;EAEA,eAAA;EACA,qBAAA;EACA,cAAA;AA1IR;AA8II;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,kCAAA;EACA,2BAAA;EACA,uBAAA;AA5IN;AA8IM;EACE,WAAA;AA5IR;AAiJE;EACE,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AA/IJ;AAiJI;EACE,6BAAA;EACA,yBAAA;EACA,iBAAA;AA/IN;;AAqJA;EAEI;IACE,aAAA;EAnJJ;EAqJI;IACE,0BAAA;EAnJN;EAsJI;IACE,mBAAA;EApJN;EAuJI;IACE,eAAA;IACA,iBAAA;EArJN;EAuJM;IACE,eAAA;IACA,WAAA;IACA,YAAA;EArJR;EAyJI;IACE,QAAA;IACA,UAAA;EAvJN;EA4JA;IACE,cAAA;IACA,aAAA;IAEA,gBAAA;IACA,kBAAA;IACA,oBAAA;IACA,sBAAA;EA3JF;AACF;AA8JA,8EAAA;AACA;EACE,wBAAA;EACA,iCAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;AA5JF;;AA+JA;EACE,yBAAA;EACA,wBAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,6BAAA;EACA,+BAAA;AA5JF;;AA+JA,8GAAA;AACA;EACE;IACE,uBAAA;IACA,2BAAA;IACA,wBAAA;IACA,4BAAA;EA5JF;EA+JA;IACE,qBAAA;IACA,8BAAA;IACA,6BAAA;IACA,uBAAA;IACA,2BAAA;IACA,wBAAA;EA7JF;AACF;AAgKA;;;EAGE,4BAAA;AA9JF;;AAiKA,wLAAA;AACA;EAGM;IACE,sDAAA;IACA,oBAAA;IACA,6BAAA;IACA,8BAAA;EAhKN;EAoKE;IACE,wBAAA;IACA,uBAAA;IACA,2BAAA;IACA,2BAAA;EAlKJ;EAoKI;IACE,yBAAA;EAlKN;AACF;AAsKA;EACE,mBAAA;EACA,6BAAA;AApKF;;AAsKA;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAnKF;;AAsKA;EACE,2BAAA;AAnKF;AAqKE;EACE,yBAAA;AAnKJ;;AAuKA;EACE,cAAA;AApKF;AAsKE;EACE,cAAA;AApKJ;;AAyKE;EACE,yBAAA;AAtKJ;;AA0KA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;AAvKF;;AAyKA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,gCAAA;AAtKF;;AAwKA;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;EACA,oBAAA;EACA,UAAA;AArKF;;AAuKA;EAEE,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iDAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AArKF;;AAuKA;EACE,OAAA;EACA,aAAA;AApKF;;AAsKA;EACE,OAAA;EACA,wBAAA;AAnKF;AAoKE;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAlKJ;;AAqKA;EACE,OAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AAlKF;AAoKE;EACE,8BAAA;EACA,0BAAA;AAlKJ;AAoKE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAlKJ;AAmKI;EACE,gBAAA;EACA,WAAA;EACA,aAAA;AAjKN;AAmKM;EACE,WAAA;EACA,kBAAA;AAjKR;AAmKU;EACE,yBAAA;EACA,2BAAA;AAjKZ;AAkKY;EACE,yBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAhKd;AAuKI;EACE,kBAAA;AArKN;AAuKI;EACE,OAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;AArKN;AAsKM;EACE,2BAAA;AApKR;AAuKI;EACE,sBAAA;AArKN;AAuKI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AArKN;AAsKM;EACE,iBAAA;AApKR;AAuKI;EACE,kBAAA;EACA,eAAA;AArKN;;AAyKA;EACE,eAAA;EACA,kBAAA;EACA,aAAA;AAtKF;AAuKE;EACE,gBAAA;EACA,yBAAA;AArKJ;;AA2KA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAxKF;;AA0KA;EACE,OAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;AAvKF;;AAyKA;EACE,gBAAA;AAtKF;;AAmMA;EACE,WAAA;AAhMF;;AAmMA;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;AAhMF;;AAkMA;EACE,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AA/LF;;AAkMA;EACE,sBAAA;EACA,mBAAA;AA/LF;;AAiMA;EACE,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AA9LF;;AAiMA;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;AA9LF;;AAgMA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AA7LF;AA8LE;EACE,gBAAA;AA5LJ;;AAgME;EACE,OAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;AA7LJ;;AAgMA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AA7LF;;AA+LA;EACE,YAAA;EACA,2BAAA;AA5LF;;AA8LA;EACE,eAAA;EACA,WAAA;EACA,iDAAA;EACA,kBAAA;AA3LF;;AA6LA;EACE,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;AA1LF;;AA6LA,kCAAA;AACA;EACE,aAAA;EACA,gBAAA;EACA,2BAAA;AA1LF;;AA4LA;EACE,4BAAA;EAEA,kBAAA;EACA,aAAA;EACA,sBAAA;AA1LF;;AA4LA;EACE,oBAAA;EACA,OAAA;EACA,sBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,iDAAA;AA1LF;;AA4LA;EACE,iBAAA;EACA,gBAAA;AAzLF;;AA4LA;EACE,OAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AAzLF;;AA2LA;EACE,OAAA;EACA,sBAAA;AAxLF;;AA0LA;EACE,eAAA;AAvLF;;AAyLA;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAtLF;;AAwLA;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AArLF;;AAuLA;EACE,iBAAA;AApLF;;AAsLA;EACE,OAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iDAAA;EACA,gBAAA;AAnLF;;AAqLA;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AAlLF;;AAoLA;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,oBAAA;EACA,YAAA;AAjLF;;AAmLA;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EAEA,kBAAA;AAjLF;AAkLE;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,iDAAA;AAhLJ;AAkLE;EACE,iBAAA;AAhLJ;AAiLI;EACE,aAAA;AA/KN;;AAmLA;EACE,gBAAA;AAhLF;;AAkLA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA/KF;;AAiLA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EAEA,kBAAA;EACA,gBAAA;AA/KF;AAgLE;EAEE,0BAAA;EACA,YAAA;EAGA,gBAAA;EACA,sBAAA;AAjLJ;AAmLE;EAEE,0BAAA;EAEA,gBAAA;EACA,sBAAA;AAnLJ;AAqLE;EACE,wBAAA;AAnLJ;;AAsLA;EACE,YAAA;EAEA,8BAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AArLF;;AAuLA;EACE,YAAA;EAEA,8BAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AAtLF;;AAwLA;EACE,UAAA;EACA,aAAA;AArLF;;AAuLA;EACE,oDAAA;AApLF;;AAsLA;EACE,yBAAA;EACA,0BAAA;AAnLF;;AAsLA;EACE,UAAA;EACA,aAAA;AAnLF;;AAqLA;EACE,oDAAA;AAlLF;;AAoLA;EACE,yBAAA;EACA,0BAAA;AAjLF;;AAoLA;EACE,aAAA;EACA,sBAAA;EACA,iDAAA;AAjLF;;AA0LA;EACE,aAAA;EACA,gBAAA;AAvLF;;AAyLA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;AAtLF;;AAwLA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AArLF;;AAuLA;EACE,iCAAA;EACA,sCAAA;AApLF;;AAuLA;EACE,eAAA;AApLF;;AAuLA,YAAA;AACA;EACE,wBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,iDAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AApLF;AAsLE;EACE,kBAAA;EACA,iCAAA;EACA,2BAAA;EACA,mBAAA;AApLJ;AAqLI;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;AAnLN;AAoLM;EACE,iBAAA;EACA,kBAAA;AAlLR;AAoLM;EACE,UAAA;EACA,eAAA;AAlLR;AAoLM;EACE,iBAAA;EACA,mBAAA;AAlLR;AAoLM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EAEA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AAnLR;AAoLQ;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,qBAAA;EAEA,WAAA;AAnLV;AAwLE;EACE,gBAAA;EACA,WAAA;EACA,wBAAA;EACA,iBAAA;EACA,UAAA;AAtLJ;AAuLI;EACE,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AArLN;AAuLM;EACE,WAAA;EACA,mBAAA;EACA,qBAAA;AArLR;AA6NE;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;AA3NJ;AA6NI;EACE,kBAAA;EACA,8BAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;AA5NN;AA6NM;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AA3NR;AA8NI;EACE,kBAAA;EACA,8BAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;AA7NN;AA8NM;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AA5NR;;AAiOA;EAGI;IACE,0BAAA;EAhOJ;AACF;AAoOA;EAEI;IACE,aAAA;IACA,sBAAA;EAnOJ;EAqOI;IACE,mBAAA;EAnON;EAsOM;IACE,sBAAA;IACA,QAAA;EApOR;EAqOQ;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;EAnOV;EAqOQ;IACE,YAAA;EAnOV;EAsOc;IACE,eAAA;EApOhB;EAwOU;IACE,aAAA;IACA,sBAAA;IACA,gBAAA;EAtOZ;EAuOY;IACE,gBAAA;IACA,eAAA;IACA,mBAAA;EArOd;EAuOgB;IACE,eAAA;EArOlB;EA0Oc;IACE,4BAAA;EAxOhB;EA0Oc;IACE,6BAAA;EAxOhB;EA8OM;IACE,iBAAA;EA5OR;EAgPE;IACE,sBAAA;IACA,WAAA;IACA,mBAAA;EA9OJ;EA+OI;IACE,iBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;EA7ON;EAiPY;IACE,2BAAA;EA/Od;EAmPQ;IACE,aAAA;IACA,sBAAA;IACA,UAAA;IACA,cAAA;EAjPV;EAkPU;IACE,kBAAA;EAhPZ;EA8PE;IACE,WAAA;IACA,qBAAA;EA5PJ;EA8PI;IACE,gBAAA;IACA,gBAAA;IACA,kCAAA;IACA,mBAAA;IACA,kBAAA;EA5PN;EA8PM;IACE,mBAAA;IAEA,kBAAA;EA7PR;EAgQI;IACE,YAAA;IACA,gBAAA;IACA,WAAA;EA9PN;EAkQM;IACE,WAAA;IACA,YAAA;EAhQR;EA+QA;IACE,kBAAA;IACA,UAAA;EA7QF;AACF;AAgRA,6BAAA;AACA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;AA9QF;AA+QE;EACE,UAAA;EACA,aAAA;AA7QJ;AA+QE;EACE,oDAAA;AA7QJ;AA+QE;EACE,yBAAA;EACA,0BAAA;AA7QJ;;AAgRA;EACE,mBAAA;EACA,WAAA;AA7QF;AA8QE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;AA5QJ;AA6QI;EACE,sBAAA;EACA,2BAAA;EACA,0BAAA;EACA,UAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AA3QN;AA6QI;EACE,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AA3QN;AA4QM;EACE,UAAA;EACA,yBAAA;AA1QR;AA2QQ;EACE,gBAAA;AAzQV;AA4QM;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,iDAAA;AA1QR;;AAoRA;EACE,aAAA;EACA,mBAAA;AAjRF;AAkRE;EACE,OAAA;AAhRJ;AAiRI;EACE,2BAAA;AA/QN;AAiRI;EACE,sBAAA;EACA,eAAA;AA/QN;AAkRE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAhRJ;AAiRI;EACE,aAAA;EACA,mBAAA;AA/QN;;AAyRE;EACE,cAAA;AAtRJ;;AA0RE;EACE,cAAA;AAvRJ;;AA2RE;;EAEE,aAAA;AAxRJ;;AA2RA;EAIQ;IACE,mBAAA;EA3RR;EA8RQ;IACE,kBAAA;IACA,eAAA;EA5RV;EA8RY;IACE,kBAAA;EA5Rd;EA+Rc;IACE,6BAAA;EA7RhB;EAmSc;IACE,0BAAA;EAjShB;EAwSI;IACE,WAAA;IAGA,gBAAA;EAxSN;EA2SQ;IACE,iBAAA;EAzSV;EA+SQ;IACE,oBAAA;IAEA,kBAAA;EA9SV;EAkTQ;IACE,YAAA;EAhTV;EAkTQ;IACE,WAAA;EAhTV;AACF;AAuTA;EAIQ;IACE,WAAA;IACA,YAAA;EAxTR;EAyTQ;IACE,WAAA;EAvTV;EAyTQ;IACE,YAAA;EAvTV;AACF;AA6TA;EACE;IAQE,0BAAA;EAlUF;EAqUE;IACE,eAAA;EAnUJ;EAuUE;IACE,WAAA;IACA,YAAA;EArUJ;EAsUI;IACE,WAAA;EApUN;EAwUI;IACE,YAAA;EAtUN;EA4UA;IACE,WAAA;IACA,iBAAA;EA1UF;EA4UA;IACE,aAAA;IACA,mBAAA;IACA,8BAAA;EA1UF;EA4UI;IACE,aAAA;IACA,mBAAA;EA1UN;EA4UI;IACE,SAAA;EA1UN;EAmVE;;IAEE,cAAA;EAjVJ;EAsVE;IACE,wBAAA;EApVJ;EAwVE;IACE,wBAAA;EAtVJ;EAyVA;IACE,0BAAA;IACA,sBAAA;EAvVF;EAyVA;IACE,aAAA;EAvVF;EAyVA;IACE,iBAAA;EAvVF;EAyVA;IACE,iBAAA;EAvVF;EAyVA;IACE,wBAAA;EAvVF;EAyVA;IACE,iBAAA;EAvVF;EAyVA;IACE,cAAA;EAvVF;AACF;AA0VA;EACE,2BAAA;EACA,8BAAA;EAEA,sBAAA;EACA,sBAAA;EACA,0BAAA;EACA,6BAAA;AAzVF;;AA4VA;EACE;IACE,uBAAA;EAzVF;AACF;AA4VA;EACE,eAAA;EAGA,YAAA;EACA,cAAA;EACA,iBAAA;EAEA,gBAAA;AA7VF;AA8VE;EACE,aAAA;EACA,kBAAA;EACA,kCAAA;EACA,4BAAA;AA5VJ;AA6VI;EACE,gBAAA;EACA,UAAA;AA3VN;AA8VI;EACE,gBAAA;EACA,UAAA;AA5VN;AA+VI;;;;EAIE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;AA7VN;AA+VI;;EAEE,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;AA7VN;AA+VI;EACE,kBAAA;AA7VN;AAgWE;EACE,UAAA;EACA,aAAA;AA9VJ;AAgWE;EACE,oDAAA;AA9VJ;AAgWE;EACE,yBAAA;EACA,0BAAA;AA9VJ;;AAkWA;EACE,kBAAA;EACA,kCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AA/VF;AAgWE;EACE,UAAA;EACA,wBAAA;AA9VJ;AA+VI;EACE,UAAA;AA7VN;AA+VI;EACE,UAAA;AA7VN;AA+VI;EAEE,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AA9VN;AAgWM;EACE,OAAA;EACA,UAAA;EACA,qCAAA;EACA,2BAAA;AA9VR;AAgWM;EACE,UAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qCAAA;EACA,2BAAA;AA9VR;;AAqWI;EACE,qBAAA;AAlWN;AAoWI;EACE,aAAA;AAlWN;;AAuWA;EACE,eAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EAEA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AArWF;AAsWE;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;AApWJ;;AAwWA;EACE,aAAA;EACA,0CAAA;EACA,gBAAA;EACA,UAAA;AArWF;;AAwWA;EACE,2CAAA;AArWF;;AAwWA;EACE,uBAAA;EACA,gBAAA;EACA,0BAAA;EACA,uBAAA;AArWF;AAsWE;EACE,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AArWJ;;AA6YA,oCAAA;AA0CA;EAIQ;IACE,qBAAA;EAtbR;EAwbU;IACE,aAAA;IACA,mBAAA;EAtbZ;EAubY;IACE,sBAAA;EArbd;EAubY;IACE,sBAAA;EArbd;EAubY;IACE,4BAAA;EArbd;AACF;AA6bA;EAIQ;IACE,qBAAA;EA9bR;EAgcU;IACE,aAAA;IACA,mBAAA;EA9bZ;EA+bY;IACE,sBAAA;EA7bd;EA+bY;IACE,sBAAA;EA7bd;EA+bY;IACE,4BAAA;EA7bd;AACF;AAscA;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,uBAAA;EACA,iBAAA;AApcF;AAqcE;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAncJ;;AAucA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AApcF;AAqcE;EACE,OAAA;AAncJ;;AAqfA;EACE;IACE,WAAA;EAlfF;EAofA;IACE,gBAAA;EAlfF;EAihBA;IACE,sBAAA;EA/gBF;AACF;AAkhBA,4BAAA;AAEA,yBAAA;AAGE;EACE,wBAAA;EACA,2BAAA;AAnhBJ;AAohBI;EACE,YAAA;EACA,gBAAA;AAlhBN;AAohBM;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;AAlhBR;AAmhBQ;EACE,sBAAA;AAjhBV;AAmhBQ;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,gBAAA;AAjhBV;AAuhBQ;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AArhBV;AAuhBQ;EACE,WAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AArhBV;AAshBU;EAEE,iBAAA;EACA,uBAAA;EACA,WAAA;EACA,sBAAA;AAphBZ;AAyhBI;EACE,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,0BAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;AAvhBN;AA0hBE;EACE,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,2BAAA;AAxhBJ;;AA2hBA;EACE;IACE,6BAAA;IACA,sCAAA;EAxhBF;AACF;AA0hBA;EAIQ;IACE,yBAAA;IACA,qBAAA;EA3hBR;EAiiBA;IACE,4BAAA;EA/hBF;AACF;AAiiBA;EAGM;IACE,WAAA;IACA,sBAAA;EAjiBN;EAqiBE;IACE,8BAAA;IACA,2BAAA;IACA,6BAAA;IACA,2BAAA;EAniBJ;AACF;AAuiBA;EAIQ;IACE,2BAAA;IACA,uBAAA;IACA,UAAA;EAxiBR;AACF;AA6iBA;EAIQ;IACE,yBAAA;IACA,qBAAA;IACA,UAAA;EA9iBR;AACF;AAsjBM;EACE,8BAAA;AApjBR;;AA0jBA;EACE,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;AAvjBF;AAwjBE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;AAtjBJ;;AAyjBA;EACE,uBAAA;EACA,kCAAA;AAtjBF;;AAwjBA;EACE,sBAAA;EACA,uBAAA;AArjBF;;AAyjBA;EACE,uBAAA,EAAA,kBAAA,EACA,YAAA,EACA,UAAA;EACA,yBAAA;UAAA,iBAAA,EAAA,oBAAA;EACA,eAAA,EAAA,sCAAA;EACA,qCAAA;EACA,WAAA;AAtjBF;;AAwjBA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AArjBF;AAsjBE;EACE,sBAAA;AApjBJ;;AAujBA;EACE;IACE,oCAAA;IACA,4BAAA;EApjBF;EAqjBE;IACE,0BAAA;EAnjBJ;EAsjBA;IACE,8BAAA;EApjBF;AACF;AA6jBE;EACE,kBAAA;AA3jBJ;AA4jBI;EACE,6BAAA;AA1jBN;;AA8jBA;EACE;IACE,6BAAA;EA3jBF;EA6jBA;IACE,wBAAA;EA3jBF;AACF;AA6jBA;EACE,aAAA;AA3jBF;;AA6jBA;EACE;IACE,aAAA;IACA,mBAAA;EA1jBF;EA2jBE;IACE,6BAAA;EAzjBJ;EA4jBA;IACE,aAAA;EA1jBF;AACF;AAgkBE;EACE,WAAA;EACA,UAAA;EACA,SAAA;AA9jBJ;AAgkBI;EACE,aAAA;EACA,2CAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AA9jBN;AAgkBM;EATF;IAUI,iBAAA;IACA,cAAA;IACA,kBAAA;EA7jBN;AACF;AA+jBM;EAfF;IAgBI,0BAAA;IACA,SAAA;IACA,aAAA;IACA,uBAAA;EA5jBN;AACF;AA8jBM;EAtBF;IAuBI,YAAA;IACA,SAAA;EA3jBN;AACF;AAgkBE;EACE,YAAA;EAEA,4BAAA;AA/jBJ;AAgkBI;EACE,SAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,8BAAA;EACA,oBAAA;AA/jBN;AAikBM;EAfF;IAgBI,gBAAA;IACA,uCAAA;IACA,gCAAA;IACA,qBAAA;IACA,kBAAA;EA9jBN;AACF;AAgkBM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,kCAAA;EACA,OAAA;EACA,YAAA;AA9jBR;AAmkBI;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAjkBN;AAmkBM;EAPF;IAQI,SAAA;IACA,gBAAA;EAhkBN;EAkkBM;IACE,sBAAA;IACA,0BAAA;IACA,oBAAA;EAhkBR;AACF;AAmkBM;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAjkBR;AAmkBQ;;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AAjkBV;AAokBQ;EACE,WAAA;EACA,YAAA;AAlkBV;AAwkBI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EAEA,mBAAA;AAvkBN;AAykBM;EAPF;IAQI,aAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;IACA,gCAAA;IACA,gBAAA;EAtkBN;AACF;AAwkBM;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;AAtkBR;AAwkBQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AAtkBV;AAykBQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AAvkBV;AA2kBM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;AAzkBR;AA2kBQ;EACE,WAAA;AAzkBV;AA4kBQ;EACE,8BAAA;EACA,kBAAA;AA1kBV;AA6kBQ;EACE,8BAAA;AA3kBV;AA8kBQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;AA5kBV;AA8kBU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,4FAAA;EACA,cAAA;AA5kBZ;AA8kBY;EACE,mBAAA;AA5kBd;AA+kBY;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AA7kBd;AAglBY;EACE,mBAAA;EACA,cAAA;AA9kBd;AAglBc;EACE,mBAAA;AA9kBhB;AAilBc;EACE,cAAA;AA/kBhB;AAklBc;EACE,cAAA;AAhlBhB;AAqlBY;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAnlBd;AAulBY;EACE,yBAAA;AArlBd;AAwlBY;EACE,eAAA;EACA,gBAAA;AAtlBd;AA8lBI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EAEA,mBAAA;AA7lBN;AA+lBM;EAPF;IAQI,aAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;IACA,gCAAA;IACA,gBAAA;EA5lBN;AACF;AA8lBM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA5lBR;AA8lBQ;EACE,cAAA;AA5lBV;AA8lBU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AA5lBZ;AA+lBU;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AA7lBZ;AAimBQ;EACE,OAAA;EACA,YAAA;AA/lBV;AAimBU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AA/lBZ;AAimBY;EACE,cAAA;AA/lBd;AAmmBU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AAjmBZ;AAmmBY;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAjmBd;AAomBY;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAlmBd;AAomBc;EACE,0BAAA;AAlmBhB;AAsmBY;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AApmBd;AAumBY;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;AArmBd;AAumBc;EACE,mBAAA;AArmBhB;AAwmBc;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAtmBhB;AA4mBQ;EACE,aAAA;EACA,QAAA;EACA,cAAA;AA1mBV;AA4mBU;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,4CAAA;AA1mBZ;AA4mBY;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AA1mBd;AA4mBc;EACE,mBAAA;AA1mBhB;AA8mBY;EACE,mBAAA;EACA,cAAA;EACA,+CAAA;AA5mBd;AA8mBc;EACE,mBAAA;AA5mBhB;AAinBU;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;AA/mBZ;AAinBY;EACE,mBAAA;AA/mBd;AAunBI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EAEA,mBAAA;AAtnBN;AAwnBM;EAPF;IAQI,mBAAA;IACA,mBAAA;IACA,gBAAA;EArnBN;AACF;AAunBM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AArnBR;AAwnBM;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;AAtnBR;AAwnBQ;EACE,gBAAA;AAtnBV;AAynBQ;EACE,gBAAA;AAvnBV;AAynBU;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;AAvnBZ;AAynBY;EACE,0BAAA;AAvnBd;AA6nBM;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AA3nBR;AA6nBQ;EACE,cAAA;AA3nBV;AAioBI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EAEA,mBAAA;AAhoBN;AAkoBM;EAPF;IAQI,eAAA;IACA,uBAAA;IACA,gBAAA;IACA,gBAAA;EA/nBN;AACF;AAioBM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA/nBR;AAkoBM;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAhoBR;AAkoBQ;EACE,cAAA;AAhoBV;AAkoBU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAhoBZ;AAmoBU;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAjoBZ;AAqoBQ;EACE,OAAA;EACA,kBAAA;AAnoBV;AAqoBU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAnoBZ;AAsoBU;EACE,OAAA;EACA,cAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;AApoBZ;AAsoBY;EACE,aAAA;EACA,4BAAA;AApoBd;AAuoBY;EACE,cAAA;AAroBd;AAyoBU;EACE,cAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;AAvoBZ;AAyoBY;EACE,mBAAA;EACA,cAAA;AAvoBd;AA0oBY;EACE,WAAA;EACA,mBAAA;AAxoBd;AA2oBY;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAzoBd;AA6oBU;EACE,cAAA;EACA,eAAA;EACA,eAAA;AA3oBZ;AA8oBU;EACE,cAAA;EACA,0BAAA;EACA,eAAA;AA5oBZ;AA8oBY;EACE,cAAA;AA5oBd;AAkpBM;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAhpBR;AAkpBQ;EACE,SAAA;EACA,eAAA;EACA,cAAA;AAhpBV;AAkpBU;EACE,cAAA;EACA,eAAA;EACA,qBAAA;AAhpBZ;AAkpBY;EACE,0BAAA;AAhpBd;AAspBM;EACE,gBAAA;AAppBR;AAspBQ;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;AAppBV;AAspBU;EACE,mBAAA;AAppBZ;AAupBU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AArpBZ;AAupBY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AArpBd;AAupBc;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AArpBhB;AAwpBc;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAtpBhB;AAypBc;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;AAvpBhB;AA2pBY;EACE,eAAA;EACA,cAAA;EACA,kCAAA;AAzpBd;AA6pBU;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,kCAAA;AA3pBZ;AA8pBU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA,EAAA,YAAA;EACA,qBAAA;AA5pBZ;AA8pBY;EACE,WAAA;AA5pBd;AA+pBY;EACE,8BAAA;EACA,kBAAA;AA7pBd;AAgqBY;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA,EAAA,uCAAA;AA9pBd;AAgqBc;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,sBAAA;AA9pBhB;AAiqBc;EACE,eAAA;EACA,iBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;AA/pBhB;AAkqBc;EACE,mBAAA;AAhqBhB;AAmqBc;EACE,cAAA;AAjqBhB;AAmqBgB;EACE,cAAA;AAjqBlB;AAqqBc;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAnqBhB;AAwqBU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;AAtqBZ;AAwqBY;EACE,OAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kCAAA;AAtqBd;AAwqBc;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;AAtqBhB;AAyqBc;EACE,cAAA;AAvqBhB;AA2qBY;EACE,cAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;AAzqBd;AA2qBc;EACE,mBAAA;EACA,sBAAA;AAzqBhB;AA4qBc;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;AA1qBhB;AA+qBU;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8BAAA;AA7qBZ;AA+qBY;EACE,eAAA;AA7qBd;AAirBkB;;EAEE,WAAA;EACA,YAAA;AA/qBpB;AAkrBkB;EACE,eAAA;AAhrBpB;AAqrBc;EACE,eAAA;AAnrBhB;AA0rBM;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,kCAAA;AAxrBR;AA0rBQ;EACE,SAAA;EACA,eAAA;AAxrBV;AA+rBE;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AA7rBJ;AA+rBI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA7rBN;AAgsBI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AA9rBN;AAisBI;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;AA/rBN;AAisBM;EACE,mBAAA;AA/rBR;AAksBM;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAhsBR;AAksBQ;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,oCAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,yCAAA;AAhsBV;AAmsBQ;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;AAjsBV;AAqsBM;EACE,OAAA;EACA,YAAA;AAnsBR;AAqsBQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAnsBV;AAssBQ;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AApsBV;AAssBU;EACE,cAAA;AApsBZ;AAusBU;EACE,cAAA;AArsBZ;AAysBQ;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAvsBV;AA6sBI;EAhHF;IAiHI,wBAAA;EA1sBJ;AACF;AA8sBE;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AA5sBJ;AA8sBI;EAVF;IAWI,WAAA;IACA,eAAA;IACA,eAAA;EA3sBJ;AACF;AA6sBI;EACE,cAAA;EACA,cAAA;EACA,6BAAA;EACA,sBAAA;EACA,WAAA;AA3sBN;AA6sBM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA3sBR;AA8sBM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AA5sBR;AA+sBM;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;AA7sBR;AA+sBQ;EACE,mBAAA;AA7sBV;AAgtBQ;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA9sBV;AAgtBU;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,oCAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,yCAAA;AA9sBZ;AAitBU;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;AA/sBZ;AAktBQ;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAhtBV;AAktBU;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;AAhtBZ;AAotBQ;EACE,OAAA;EACA,YAAA;AAltBV;AAotBU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAltBZ;AAqtBU;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAntBZ;AAqtBY;EACE,cAAA;AAntBd;AAstBY;EACE,cAAA;AAptBd;AAwtBU;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAttBZ;AA6tBI;EACE;IACE,wBAAA;EA3tBN;AACF;;AAiuBA;EACE,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AA9tBF;;AAiuBA,oHAAA;AAEE;EACE,UAAA;EACA,SAAA;EACA,eAAA;AA/tBJ;;AAouBA;EACE;IACE,aAAA;IACA,sBAAA;IACA,SAAA;IACA,aAAA;IACA,mBAAA;EAjuBF;EAouBA;IACE,gBAAA;IACA,SAAA;IACA,UAAA;IACA,mBAAA;IACA,4HAAA;IAMA,kCAAA;YAAA,0BAAA;EAvuBF;EA0uBA;IACE,eAAA;IACA,aAAA;IACA,gBAAA;IACA,SAAA;EAxuBF;EA0uBE;IACE,cAAA;EAxuBJ;EA4uBA;IACE,aAAA;EA1uBF;EA6uBA;IACE,mBAAA;IACA,mBAAA;IAEA,gBAAA;IACA,wBAAA;EA5uBF;EA+uBA;IACE,gBAAA;EA7uBF;EAgvBA;;IAEE,WAAA;IACA,cAAA;IACA,iBAAA;IACA,iBAAA;EA9uBF;EAivBA;IACE,WAAA;IACA,iBAAA;IACA,gBAAA;IACA,SAAA;EA/uBF;EAkvBA;IACE,uBAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;EAhvBF;EAmvBA;IACE,eAAA;IACA,gBAAA;IACA,SAAA;IACA,cAAA;EAjvBF;EAqvBE;IACE,mBAAA;EAnvBJ;EAsvBE;IACE,mBAAA;EApvBJ;EAsvBI;IACE,eAAA;IACA,iBAAA;IACA,yCAAA;EApvBN;EAwvBE;IACE,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,cAAA;IACA,gBAAA;IACA,gBAAA;EAtvBJ;EA0vBA;IACE,cAAA;IACA,gBAAA;EAxvBF;EA0vBE;IACE,mBAAA;EAxvBJ;EA4vBA;IACE,aAAA;IACA,mBAAA;IACA,QAAA;IACA,eAAA;EA1vBF;EA4vBE;IACE,aAAA;IACA,mBAAA;IACA,SAAA;IACA,OAAA;IACA,YAAA;EA1vBJ;EA4vBI;IACE,cAAA;EA1vBN;EA4vBM;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,iBAAA;IACA,eAAA;EA1vBR;EA6vBM;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,cAAA;IACA,eAAA;EA3vBR;EA+vBI;IACE,OAAA;IACA,YAAA;EA7vBN;EA+vBM;IACE,eAAA;IACA,gBAAA;IACA,cAAA;IACA,eAAA;IACA,kBAAA;IACA,kCAAA;EA7vBR;EA+vBQ;IACE,cAAA;EA7vBV;EAiwBM;IACE,aAAA;IACA,mBAAA;IACA,QAAA;IACA,eAAA;IACA,eAAA;IACA,cAAA;IACA,kCAAA;EA/vBR;EAiwBQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA/vBV;EAkwBQ;IACE,cAAA;IACA,eAAA;IACA,gBAAA;EAhwBV;EAkwBU;IACE,0BAAA;EAhwBZ;EAowBQ;IACE,cAAA;IACA,mBAAA;IACA,gBAAA;IACA,kBAAA;IACA,eAAA;EAlwBV;EAuwBI;IACE,aAAA;IACA,QAAA;IACA,cAAA;EArwBN;EAuwBM;IACE,iBAAA;IACA,mBAAA;IACA,yBAAA;IACA,eAAA;IACA,gBAAA;IACA,eAAA;IACA,4CAAA;IACA,mBAAA;EArwBR;EAuwBQ;IACE,mBAAA;IACA,cAAA;IACA,qBAAA;EArwBV;EAuwBU;IACE,mBAAA;EArwBZ;EAywBQ;IACE,mBAAA;IACA,cAAA;IACA,+CAAA;EAvwBV;EAywBU;IACE,mBAAA;EAvwBZ;EA4wBM;IACE,iBAAA;IACA,mBAAA;IACA,YAAA;IACA,mBAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,eAAA;IACA,2BAAA;IACA,mBAAA;EA1wBR;EA4wBQ;IACE,mBAAA;EA1wBV;EAixBA;IACE,aAAA;IACA,SAAA;IACA,eAAA;IACA,6BAAA;IACA,gCAAA;IACA,cAAA;EA/wBF;EAixBE;IACE,aAAA;IACA,mBAAA;IACA,QAAA;IACA,eAAA;IACA,cAAA;IACA,eAAA;EA/wBJ;EAixBI;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA/wBN;EAmxBI;IACE,yBAAA;EAjxBN;EAsxBA;IACE,gBAAA;IACA,cAAA;IACA,qBAAA;EApxBF;EAuxBA;IACE,aAAA;IACA,sBAAA;IACA,SAAA;IACA,gBAAA;EArxBF;EAwxBA;IACE,aAAA;IACA,SAAA;IACA,aAAA;IACA,yBAAA;IACA,mBAAA;IACA,eAAA;IACA,2BAAA;EAtxBF;EAwxBE;IACE,mBAAA;EAtxBJ;EA0xBA;IACE,cAAA;IACA,YAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA;EAxxBF;EA0xBE;;IAEE,WAAA;IACA,YAAA;IACA,iBAAA;EAxxBJ;EA4xBA;IACE,OAAA;IACA,YAAA;IACA,aAAA;IACA,sBAAA;IACA,QAAA;EA1xBF;EA6xBA;IACE,eAAA;IACA,gBAAA;IACA,SAAA;IACA,cAAA;IACA,iBAAA;EA3xBF;EA8xBA;IACE,aAAA;IACA,mBAAA;IACA,QAAA;IACA,eAAA;IACA,cAAA;IACA,eAAA;EA5xBF;EA+xBA;IACE,iBAAA;IACA,gBAAA;IACA,cAAA;EA7xBF;EAgyBA;IACE,cAAA;IACA,eAAA;IACA,gBAAA;EA9xBF;EAgyBE;IACE,kBAAA;EA9xBJ;AACF;AAmyBA;EACE;IACE,uBAAA;IACA,oBAAA;IACA,qBAAA;IACA,mBAAA;EAjyBF;EAmyBE;;;;IAIE,uBAAA;IACA,2BAAA;IACA,oBAAA;IACA,qBAAA;EAjyBJ;EAqyBI;IACE,wBAAA;IACA,oBAAA;IACA,2BAAA;EAnyBN;EAwyBI;IACE,qCAAA;IACA,iBAAA;EAtyBN;EA0yBM;IACE,2BAAA;IACA,oBAAA;EAxyBR;EA2yBM;IACE,gBAAA;IACA,kBAAA;IACA,oCAAA;EAzyBR;EA2yBQ;IACE,4BAAA;IACA,mBAAA;IACA,kBAAA;EAzyBV;EA4yBQ;IACE,cAAA;IACA,gBAAA;IACA,4BAAA;IACA,mBAAA;IACA,8BAAA;EA1yBV;EA4yBU;IACE,0BAAA;IACA,sBAAA;IACA,uBAAA;EA1yBZ;EA6yBU;IACE,0BAAA;IACA,gBAAA;EA3yBZ;EA+yBQ;IACE,WAAA;EA7yBV;EAgzBQ;IACE,kBAAA;EA9yBV;EAkzBM;;;;;IAKE,wBAAA;IACA,oBAAA;IACA,2BAAA;EAhzBR;EAmzBM;IACE,oBAAA;IACA,2BAAA;EAjzBR;EAmzBQ;IACE,sBAAA;IACA,0BAAA;IACA,oBAAA;EAjzBV;AACF;AAwzBA,4FAAA;AACA;EAGM;IACE,qCAAA;EAxzBN;EA4zBE;IACE,sBAAA;IACA,0BAAA;IACA,0BAAA;EA1zBJ;EA4zBI;IACE,wBAAA;EA1zBN;EA8zBE;IACE,yBAAA;EA5zBJ;AACF;AAg0BA;EACE,YAAA;EACA,mBAAA;AA9zBF;;AAi0BA;EACE,WAAA;EACA,YAAA;EACA,8BAAA;EACA,+BAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,2CAAA;EACA,sBAAA;AA9zBF;;AAi0BA;EACE;IACE,yBAAA;EA9zBF;AACF;AAi0BA,6CAAA;AACA;EAoCE,iEAAA;EA0DA,yGAAA;EA8BA,8EAAA;EAsCA,gFAAA;EAoBA,4DAAA;EAMA;gFAAA;EA4BA,iGAAA;EAmDA,mFAAA;EA+BA;kFAAA;EAwBA,2FAAA;AArnCF;AAozBE;;;;;;;EAOE,8BAAA;EACA,yBAAA;AAlzBJ;AAqzBE;EACE,8BAAA;AAnzBJ;AAszBE;;;;;;;;;EASE,8BAAA;EACA,yBAAA;EACA,kDAAA;AApzBJ;AAuzBE;;;EAGE,kDAAA;AArzBJ;AAyzBE;;;EAGE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAvzBJ;AA0zBE;;;;EAIE,8BAAA;AAxzBJ;AA2zBE;;;;;;;;;;;;;;EAcE,yBAAA;AAzzBJ;AA4zBE;;;;;;;;;;;EAWE,yBAAA;AA1zBJ;AA6zBE;;;;;;EAME,8BAAA;EACA,yBAAA;EACA,kDAAA;AA3zBJ;AA+zBE;EAME,8BAAA;EACA,sDAAA;EACA,yBAAA;AAl0BJ;AAo0BI;EACE,8BAAA;AAl0BN;AAs0BE;EACE,kDAAA;AAp0BJ;AAu0BE;EACE,8BAAA;EACA,sDAAA;EACA,yBAAA;AAr0BJ;AAw0BE;EACE,yBAAA;AAt0BJ;AA00BE;;;;;EAKE,yBAAA;AAx0BJ;AA20BE;;EAEE,yBAAA;AAz0BJ;AA40BE;;;EAGE,yBAAA;EACA,8CAAA;EACA,+CAAA;AA10BJ;AA60BE;;;;EAIE,yBAAA;AA30BJ;AA80BE;;;;;;EAME,yBAAA;AA50BJ;AAs1BI;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EASE,yBAAA;AAvyBN;AA4yBE;;EAEE,yBAAA;AA1yBJ;AA+yBE;;;EAGE,yBAAA;AA7yBJ;AAgzBE;;;EAGE,yBAAA;AA9yBJ;AAizBE;EACE,yBAAA;EACA,kCAAA;AA/yBJ;AAkzBE;EACE,8BAAA;EACA,yBAAA;AAhzBJ;AAmzBE;EACE,yBAAA;AAjzBJ;AAqzBE;EACE,8BAAA;EACA,yBAAA;AAnzBJ;AAszBE;EACE,8BAAA;AApzBJ;AAuzBE;;EAEE,yBAAA;AArzBJ;AAwzBE;EACE,yBAAA;EACA,8BAAA;AAtzBJ;AAyzBE;;EAEE,sDAAA;AAvzBJ;AA0zBE;;;;;EAKE,8BAAA;AAxzBJ;AA2zBE;EACE,yBAAA;EACA,yDAAA;AAzzBJ;AA4zBE;;EAEE,yBAAA;AA1zBJ;AA6zBE;EACE,yBAAA;AA3zBJ;AA8zBE;EACE,yBAAA;AA5zBJ;AAg0BE;EACE,yBAAA;AA9zBJ;AAi0BE;EACE,yBAAA;AA/zBJ;AAi0BI;EACE,yBAAA;AA/zBN;AAm0BE;EACE,8HAAA;AAj0BJ;AAy0BE;;EAEE,gDAAA;AAv0BJ;AA00BE;EACE,gDAAA;AAx0BJ;AA60BE;EACE,8BAAA;EACA,yBAAA;EACA,uBAAA;AA30BJ;AA80BE;EACE,8BAAA;EACA,yBAAA;EACA,gCAAA;AA50BJ;AA+0BE;EACE,yBAAA;AA70BJ;AAg1BE;EACE,8CAAA;EACA,kDAAA;EACA,yBAAA;AA90BJ;AAk1BE;EACE;IACE,8BAAA;EAh1BJ;EAm1BE;;;;;IAKE,kCAAA;EAj1BJ;EAo1BE;;;;;;IAME,8BAAA;EAl1BJ;EAq1BE;IACE,8BAAA;EAn1BJ;EAs1BE;;;IAGE,8BAAA;EAp1BJ;EAu1BE;IACE,8BAAA;IACA,kDAAA;EAr1BJ;EAw1BE;IACE,8BAAA;IACA,sDAAA;IACA,yBAAA;EAt1BJ;EAy1BE;;IAEE,yBAAA;EAv1BJ;EA01BE;IACE,kCAAA;EAx1BJ;EA21BE;IACE,8BAAA;IACA,sDAAA;IACA,yBAAA;EAz1BJ;EA41BE;IACE,8BAAA;IACA,kDAAA;IACA,yBAAA;EA11BJ;EA61BE;;;;;;;;;IASE,yBAAA;EA31BJ;AACF;;AA+1BA;EACE,cAAA;AA51BF;AA81BE;EACE,eAAA;EACA,oBAAA;AA51BJ;AA+1BE;EACE,eAAA;EACA,cAAA;EACA,0BAAA;EACA,0BAAA;AA71BJ;AA+1BI;EACE,cAAA;AA71BN;;AAk2BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AA/1BF;AAi2BE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA/1BJ;;AAm2BA,qFAAA;AACA;EACE,mBAAA;AAh2BF;AAk2BE;;EAEE,iCAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,6BAAA;EACA,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kCAAA;EACA,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;AAh2BJ;AAm2BE;EACE,eAAA;AAj2BJ;AAo2BE;EACE;;IAEE,gBAAA;IACA,uBAAA;IACA,0BAAA;EAl2BJ;AACF","sourcesContent":["/* Skeleton Loader Styles (shared with view flow) */\n.skeleton-viewflow-container {\n  --skeleton-gradient: linear-gradient(\n    110deg,\n    #f6f7f8 8%,\n    #eceef1 18%,\n    #f6f7f8 33%\n  );\n  background: #efeeee;\n  min-height: 89vh;\n  padding: 24px 0 32px;\n  pointer-events: none;\n  \n  // Override all black backgrounds in skeleton loader\n  * {\n    &[style*=\"background: #000\"],\n    &[style*=\"background:#000\"],\n    &[style*=\"background: #000000\"],\n    &[style*=\"background:#000000\"] {\n      background: #f5f5f5 !important;\n    }\n  }\n\n  .skeleton-text,\n  .skeleton-avatar,\n  .skeleton-icon,\n  .skeleton-image,\n  .skeleton-arrow {\n    background-image: var(--skeleton-gradient);\n    background-size: 220% 100%;\n    animation: skeleton-shimmer 1.35s linear infinite,\n      skeleton-pulse 2s ease-in-out infinite;\n  }\n\n  .skeleton-text {\n    border-radius: 4px;\n    height: 16px;\n    margin: 6px 0;\n\n    &.skeleton-title {\n      height: 24px;\n      width: 60%;\n    }\n\n    &.skeleton-subtitle {\n      height: 16px;\n      width: 40%;\n    }\n\n    &.skeleton-badge-text {\n      height: 14px;\n      width: 80px;\n    }\n\n    &.short {\n      width: 40%;\n    }\n\n    &.skeleton-description.short {\n      width: 70%;\n    }\n  }\n\n  .skeleton-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    margin-right: 10px;\n  }\n\n  .skeleton-icon {\n    width: 24px;\n    height: 24px;\n    border-radius: 4px;\n    margin-right: 8px;\n\n    &.small {\n      width: 18px;\n      height: 18px;\n    }\n\n    &.skeleton-share-icon {\n      width: 20px;\n      height: 20px;\n      margin-left: auto;\n    }\n  }\n\n  .skeleton-image {\n    width: 100%;\n    height: 240px;\n    border-radius: 12px;\n\n    &.large {\n      height: 320px;\n    }\n\n    &.small {\n      width: 120px;\n      height: 72px;\n      border-radius: 12px;\n    }\n  }\n\n  .flow-layout-container {\n    padding: 0 24px;\n  }\n\n  .skeleton-card {\n    background: #fff;\n    border-radius: 16px; \n    box-shadow: 0 10px 25px rgba(49, 53, 73, 0.05);\n    margin-bottom: 16px;\n  }\n\n  .skeleton-flow-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n  }\n\n  .skeleton-flow-title {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    flex: 1;\n  }\n\n  .skeleton-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 14px;\n    border-radius: 40px;\n    background: rgba(94, 161, 216, 0.08);\n  }\n\n  .skeleton-pill-text {\n    width: 90px;\n    height: 14px;\n    margin: 0;\n  }\n\n  .skeleton-info-panel {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n\n  .info-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 14px;\n    border-radius: 24px;\n    background: rgba(240, 240, 240, 0.8);\n\n    .skeleton-text {\n      width: 90px;\n      height: 14px;\n      margin: 0;\n    }\n  }\n\n  // Remove all black backgrounds from skeleton loader\n  .video-player-section {\n    background: #ffffff !important;\n    \n    .img-wrap {\n      background: #f5f5f5 !important;\n      \n      img,\n      video {\n        background: #f5f5f5 !important;\n      }\n      \n      .skeleton-image {\n        background: #f5f5f5 !important;\n        background-image: var(--skeleton-gradient) !important;\n      }\n    }\n  }\n  \n  .mobile-media {\n    background: #f5f5f5 !important;\n    \n    img,\n    video {\n      background: #f5f5f5 !important;\n    }\n    \n    .skeleton-image {\n      background: #f5f5f5 !important;\n      background-image: var(--skeleton-gradient) !important;\n    }\n  }\n  \n  .mobile-media-video {\n    background: #f5f5f5 !important;\n  }\n  \n  // Override all elements with black background in skeleton\n  .img-wrap,\n  .video-player-section .img-wrap,\n  .mobile-media,\n  .mobile-media-video {\n    background: #f5f5f5 !important;\n    \n    img,\n    video {\n      background: #f5f5f5 !important;\n    }\n  }\n\n  .metadata-skeleton {\n    .step-header-main {\n      display: flex;\n      align-items: center;\n      gap: 14px;\n    }\n\n    .skeleton-step-circle {\n      width: 44px;\n      height: 44px;\n      border-radius: 50%;\n      margin-right: 4px;\n    }\n\n    .skeleton-step-title {\n      flex: 1;\n      height: 22px;\n      margin: 0;\n      border-radius: 8px;\n    }\n\n    .video-actions-bar {\n      margin-top: 20px;\n\n      .action-buttons {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 16px;\n      }\n\n      .skeleton-action-item {\n        display: inline-flex;\n        align-items: center;\n        gap: 10px;\n        padding: 6px 0;\n        min-width: 110px;\n      }\n    }\n  }\n\n  .channel-info-section {\n    .channel-header {\n      display: flex;\n      align-items: center;\n      gap: 16px;\n      margin-bottom: 12px;\n    }\n\n    .channel-meta,\n    .channel-actions {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 12px;\n      margin-bottom: 12px;\n    }\n\n    .channel-actions .skeleton-text {\n      width: 120px;\n      height: 32px;\n      border-radius: 16px;\n    }\n  }\n\n  .description-section .skeleton-text {\n    height: 14px;\n  }\n\n  .comments-section {\n    .skeleton-comment {\n      display: flex;\n      align-items: flex-start;\n      gap: 12px;\n      margin-top: 12px;\n    }\n\n    .skeleton-comment-body {\n      flex: 1;\n    }\n  }\n\n  .flow-sidebar {\n    align-self: flex-start;\n  }\n\n  .step-navigation {\n    .step-scroll {\n      max-height: 320px;\n      overflow: hidden;\n    }\n\n    .steps-list {\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n    }\n\n    .step-btn {\n      border: none;\n      background: rgba(240, 240, 240, 0.8);\n      padding: 10px 16px;\n      border-radius: 999px;\n      display: flex;\n      align-items: center;\n      gap: 12px;\n    }\n\n    .skeleton-step-pill {\n      flex: 1;\n      height: 14px;\n      margin: 0;\n    }\n  }\n\n  .recommendations-section {\n    h2 {\n      font-size: 1.1rem;\n      margin-bottom: 12px;\n      min-height: 24px;\n    }\n\n    &.nested-bundle-categories {\n      margin-top: 8px;\n      margin-bottom: 24px;\n\n      > h2 {\n        margin-top: 4px;\n        margin-bottom: 16px;\n        font-size: 1.1rem;\n        font-weight: 600;\n        line-height: 1.3;\n      }\n\n      .bundle-view-category {\n        margin-bottom: 20px;\n\n        &:not(:first-child) {\n          margin-top: 8px;\n          padding-top: 16px;\n          border-top: 1px solid rgba(0, 0, 0, 0.06);\n        }\n      }\n\n      .bundle-view-category-title {\n        font-size: 0.95rem;\n        margin: 0 0 12px;\n        padding-top: 4px;\n        font-weight: 600;\n        line-height: 1.3;\n        color: #374151;\n      }\n    }\n\n    // Force rounded corners on search input\n    input[type=\"text\"].bundle-search-input,\n    .bundle-search-container .bundle-search-field input.bundle-search-input,\n    .bundle-search-container .bundle-search-field .bundle-search-input {\n      border-radius: 24px !important;\n      -webkit-border-radius: 24px !important;\n      -moz-border-radius: 24px !important;\n      -webkit-appearance: none !important;\n      -moz-appearance: none !important;\n      appearance: none !important;\n    }\n\n    .bundle-search-container {\n      margin-bottom: 16px;\n      width: 100%;\n    }\n    \n    .skeleton-search-box {\n      display: flex;\n      align-items: center;\n      background-color: #f5f5f5;\n      border: 1px solid #e0e0e0;\n      border-radius: 24px;\n      padding: 8px 12px;\n      gap: 8px;\n      \n      .skeleton-search-icon {\n        width: 20px;\n        height: 20px;\n        flex-shrink: 0;\n      }\n      \n      .skeleton-search-input {\n        flex: 1;\n        height: 20px;\n        margin: 0;\n        border-radius: 4px;\n      }\n    }\n\n    .bundle-search-field {\n      position: relative;\n      display: flex;\n      align-items: center;\n      flex: 1;\n      width: 100%;\n      height: 36px;\n\n      input.bundle-search-input,\n      .bundle-search-input {\n        flex: 1;\n        min-width: 0;\n        padding: 8px 72px 8px 12px; // Right padding for both icons (cancel + search)\n        border: 1px solid #d0d0d0 !important;\n        border-radius: 24px !important;\n        -webkit-border-radius: 24px !important;\n        -moz-border-radius: 24px !important;\n        font-size: 14px;\n        background: #ffffff;\n        height: 36px;\n        outline: none !important;\n        color: #000000;\n        box-sizing: border-box;\n        -webkit-appearance: none !important;\n        -moz-appearance: none !important;\n        appearance: none !important;\n        font-family: inherit;\n        margin: 0;\n        line-height: normal;\n        width: 100%;\n\n        &::placeholder {\n          color: #666666;\n        }\n\n        &:focus {\n          border-color: #d0d0d0 !important;\n          box-shadow: none;\n          border-radius: 24px !important;\n          -webkit-border-radius: 24px !important;\n          -moz-border-radius: 24px !important;\n        }\n      }\n\n      .cancel-icon-button {\n        position: absolute;\n        right: 40px; // Position before search icon\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        background: transparent;\n        border: none;\n        padding: 4px;\n        cursor: pointer;\n        color: #666666;\n        border-radius: 50%;\n        transition: color 0.2s, background-color 0.2s;\n        flex-shrink: 0;\n        z-index: 1;\n        width: 28px;\n        height: 28px;\n\n        &:hover {\n          color: #000000;\n          background-color: #f0f0f0;\n        }\n\n        mat-icon {\n          font-size: 18px;\n          width: 18px;\n          height: 18px;\n        }\n      }\n\n      .search-icon-button {\n        position: absolute;\n        right: 4px;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        background: transparent;\n        border: none;\n        padding: 4px;\n        cursor: pointer;\n        color: #666666;\n        border-radius: 50%;\n        transition: color 0.2s, background-color 0.2s;\n        flex-shrink: 0;\n        z-index: 1;\n        width: 28px;\n        height: 28px;\n\n        &:hover {\n          color: #000000;\n          background-color: #f0f0f0;\n        }\n\n        mat-icon {\n          font-size: 20px;\n          width: 20px;\n          height: 20px;\n        }\n      }\n    }\n\n    // Mobile responsive adjustments\n    @media (max-width: 768px) {\n      .bundle-search-field {\n        height: 36px;\n\n        input.bundle-search-input,\n        .bundle-search-input {\n          font-size: 14px;\n          padding: 8px 72px 8px 12px;\n          height: 36px;\n          border-radius: 24px !important;\n          -webkit-border-radius: 24px !important;\n          -moz-border-radius: 24px !important;\n        }\n      }\n    }\n\n    @media (max-width: 480px) {\n      .bundle-search-field {\n        height: 32px;\n\n        input.bundle-search-input,\n        .bundle-search-input {\n          font-size: 13px;\n          padding: 8px 64px 8px 10px;\n          height: 32px;\n          border-radius: 20px !important;\n          -webkit-border-radius: 20px !important;\n          -moz-border-radius: 20px !important;\n        }\n\n        .cancel-icon-button {\n          right: 36px;\n          width: 24px;\n          height: 24px;\n\n          mat-icon {\n            font-size: 16px;\n            width: 16px;\n            height: 16px;\n          }\n        }\n\n        .search-icon-button {\n          right: 4px;\n          width: 24px;\n          height: 24px;\n\n          mat-icon {\n            font-size: 18px;\n            width: 18px;\n            height: 18px;\n          }\n        }\n      }\n    }\n\n    .recommendations-list {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n      min-height: 100px;\n    }\n\n    .no-results-message {\n      padding: 24px 16px;\n      text-align: center;\n      color: #666666;\n      font-size: 14px;\n      background: #f9f9f9;\n      border-radius: 8px;\n      margin: 16px 0;\n\n      p {\n        margin: 0;\n        color: #666666;\n      }\n    }\n\n    .recommendation-item {\n      display: flex;\n      gap: 12px;\n      padding: 12px;\n      border-radius: 8px;\n      background: #f9f9f9;\n      margin-bottom: 8px;\n      cursor: pointer;\n      transition: background-color 0.2s, transform 0.1s;\n      \n      &:hover {\n        background: #f0f0f0;\n        transform: translateY(-1px);\n      }\n      \n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    .recommendation-thumbnail {\n      flex-shrink: 0;\n      width: 120px;\n      height: 72px;\n      border-radius: 8px;\n      overflow: hidden;\n      background: #e0e0e0;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n\n      .flow-seq-badge {\n        position: absolute;\n        top: 6px;\n        left: 6px;\n        z-index: 2;\n        min-width: 22px;\n        height: 22px;\n        padding: 0 8px;\n        border-radius: 999px;\n        background: rgba(94, 161, 216, 0.95);\n        color: #fff;\n        font-size: 12px;\n        font-weight: 700;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        pointer-events: none;\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n      }\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        display: block;\n      }\n\n      video {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        display: block;\n      }\n    }\n\n    .recommendation-info {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      gap: 6px;\n      min-width: 0; // Allows text truncation\n      \n      .recommendation-title {\n        margin: 0;\n        font-size: 16px;\n        font-weight: 500;\n        color: #0f0f0f;\n        line-height: 20px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        line-clamp: 2;\n        -webkit-box-orient: vertical;\n      }\n      \n      .recommendation-meta {\n        display: flex;\n        gap: 8px;\n        align-items: center;\n        flex-wrap: wrap;\n        font-size: 12px;\n        color: #666666;\n\n        .recommendation-creator {\n          font-weight: 500;\n        }\n\n        .recommendation-id {\n          color: #999999;\n        }\n      }\n      \n      .recommendation-price {\n        font-size: 13px;\n        font-weight: 600;\n        color: #5ea1d8;\n        margin-top: 4px;\n      }\n    }\n\n    .skeleton-small {\n      height: 12px;\n      width: 50%;\n    }\n  }\n\n  &.mobile {\n  \n\n    .skeleton-mobile {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n    }\n\n    .mobile-top-panel {\n      padding: 0 8px;\n    }\n\n    .info-badge {\n      width: 100%;\n      max-width: 180px;\n    }\n\n    .mobile-section.skeleton-card {\n      padding: 16px;\n      border-radius: 16px;\n    }\n\n    .mobile-media .skeleton-image {\n      height: 220px;\n      border-radius: 16px;\n    }\n\n    .mobile-items-list {\n      margin-top: 12px;\n    }\n\n    .mobile-item-skeleton {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      padding: 8px 0;\n      border-bottom: 1px solid #f0f0f0;\n\n      &:last-child {\n        border-bottom: none;\n      }\n\n      .mobile-item-copy {\n        flex: 1;\n      }\n    }\n\n    .mobile-step-card {\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n    }\n\n    .mobile-step-media .skeleton-image {\n      height: 200px;\n    }\n\n    .recommendation-item {\n      padding: 12px 0;\n      border-bottom: 1px solid #f0f0f0;\n\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n  }\n}\n\n/* Version preview: show \"not available\" message in header/body */\n.preview-unavailable {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #b71c1c;\n  font-weight: 600;\n}\n\n.preview-unavailable-body {\n  padding: 16px;\n  border: 1px solid rgba(183, 28, 28, 0.2);\n  background: rgba(183, 28, 28, 0.05);\n  border-radius: 10px;\n  margin-bottom: 16px;\n}\n\n@keyframes skeleton-shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n@keyframes skeleton-pulse {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.65;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n/* Dark mode skeleton palette (view-bundle) */\n:host-context(body.theme-dark) {\n  .skeleton-viewflow-container {\n    --skeleton-gradient: linear-gradient(\n      110deg,\n      #1f2937 8%,\n      #334155 18%,\n      #1f2937 33%\n    );\n    background: #0a0c10 !important;\n\n    .skeleton-text,\n    .skeleton-avatar,\n    .skeleton-icon,\n    .skeleton-image,\n    .skeleton-arrow {\n      background-color: #1f2937 !important;\n    }\n\n    .skeleton-card,\n    .skeleton-flow-header {\n      background: #111827 !important;\n      border-color: rgba(148, 163, 184, 0.2) !important;\n      box-shadow: none !important;\n    }\n\n    .video-player-section,\n    .video-player-section .img-wrap,\n    .video-player-section .img-wrap img,\n    .video-player-section .img-wrap video,\n    .mobile-media,\n    .mobile-media img,\n    .mobile-media video,\n    .mobile-media-video {\n      background: #020617 !important;\n    }\n\n    .info-badge,\n    .skeleton-pill {\n      background: rgba(148, 163, 184, 0.16) !important;\n    }\n  }\n}\n\n* {\n  padding: 0px;\n  margin: 0px;\n}\n\n.dialog-scroll-wrapper {\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n/* Keep bundle preview behavior identical to flow preview:\n   sticky header with a dedicated scrollable content area. */\n.view-flow.viewbundle.preview-mode {\n  display: flex;\n  flex-direction: column;\n  max-height: 80vh;\n  overflow: hidden;\n\n  .preview-dialog-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 24px;\n    border-bottom: 1px solid #e0e0e0;\n    background: #ffffff;\n    position: sticky;\n    top: 0;\n    z-index: 20;\n    .header-content {\n      display: flex;\n      flex-direction: column;\n      gap: 6px;\n      flex: 1;\n      min-width: 0;\n      padding-right: 48px;\n    }\n\n    h2 {\n      margin: 0;\n      font-size: 20px !important;\n      font-weight: 600;\n      color: #212427;\n      text-align: left;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    .version-badge {\n      display: inline-flex;\n      align-items: center;\n      gap: 6px;\n      padding: 4px 12px;\n      background-color: #5ea1d8;\n      color: #fff;\n      border-radius: 4px;\n      font-size: 13px;\n      font-weight: 500;\n      width: fit-content;\n\n      mat-icon {\n        font-size: 16px;\n        width: 16px;\n        height: 16px;\n        color: #fff;\n      }\n    }\n\n    .preview-unique-code {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: baseline;\n      gap: 8px;\n      margin-top: 2px;\n      font-size: 13px;\n      color: #666;\n      max-width: 100%;\n\n      .preview-unique-code-label {\n        font-weight: 600;\n        color: #212427;\n      }\n\n      .preview-unique-code-value {\n        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n          \"Courier New\", monospace;\n        font-size: 12px;\n        word-break: break-all;\n        color: #212427;\n      }\n    }\n\n    .close-button {\n      position: absolute;\n      top: 12px;\n      right: 12px;\n      color: #666;\n      background: transparent !important;\n      box-shadow: none !important;\n      border: none !important;\n\n      mat-icon {\n        color: #666;\n      }\n    }\n  }\n\n  .preview-inline-description {\n    margin: 12px 0 16px 0;\n    padding: 12px 14px;\n    background: #ffffff;\n    border-radius: 12px;\n    color: #212427;\n    max-height: 260px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    word-break: break-word;\n\n    p {\n      margin: 0 0 10px 0 !important;\n      color: #212427 !important;\n      line-height: 1.55;\n    }\n  }\n\n}\n\n@media (max-width: 640px) {\n  .view-flow.viewbundle.preview-mode {\n    .preview-dialog-header {\n      padding: 16px;\n\n      h2 {\n        font-size: 18px !important;\n      }\n\n      .header-content {\n        padding-right: 40px;\n      }\n\n      .version-badge {\n        font-size: 12px;\n        padding: 3px 10px;\n\n        mat-icon {\n          font-size: 14px;\n          width: 14px;\n          height: 14px;\n        }\n      }\n\n      .close-button {\n        top: 8px;\n        right: 8px;\n      }\n    }\n  }\n\n  .container1 {\n    flex: 1 1 auto;\n    min-height: 0;\n    // max-height: calc(80vh - 78px);\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding-bottom: 36px;\n    box-sizing: border-box;\n  }\n}\n\n/* Hard override: ensure desktop preview is always scrollable to the bottom. */\n.view-flow.viewbundle.dialog-scroll-wrapper.preview-mode {\n  display: flex !important;\n  flex-direction: column !important;\n  height: 80vh !important;\n  max-height: 80vh !important;\n  overflow: hidden !important;\n}\n\n.view-flow.viewbundle.dialog-scroll-wrapper.preview-mode .container1 {\n  flex: 1 1 auto !important;\n  min-height: 0 !important;\n  height: calc(80vh - 78px) !important;\n  max-height: calc(80vh - 78px) !important;\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n  padding-bottom: 48px !important;\n}\n\n/* Mobile preview: outer Material surface scrolls (see styles.scss .flow-preview-pane) — no nested 80vh trap */\n@media (max-width: 1024px) {\n  .view-flow.viewbundle.dialog-scroll-wrapper.preview-mode {\n    height: auto !important;\n    max-height: none !important;\n    min-height: 0 !important;\n    overflow: visible !important;\n  }\n\n  .view-flow.viewbundle.dialog-scroll-wrapper.preview-mode .container1 {\n    flex: none !important;\n    overflow-y: visible !important;\n    overflow-x: hidden !important;\n    height: auto !important;\n    max-height: none !important;\n    min-height: 0 !important;\n  }\n}\n\n.view-flow.viewbundle.dialog-scroll-wrapper.preview-mode .flow-layout-container,\n.view-flow.viewbundle.dialog-scroll-wrapper.preview-mode .flow-main-grid,\n.view-flow.viewbundle.dialog-scroll-wrapper.preview-mode .flow-main-content {\n  overflow: visible !important;\n}\n\n/* Desktop preview only: keep 2-column + sidebar. On mobile, use same responsive rules as standalone view-bundle (single column, sidebar list hidden, recommendations-section-mobile). */\n@media (min-width: 1025px) {\n  .view-flow.viewbundle.preview-mode {\n    .flow-layout-container {\n      .flow-main-grid {\n        grid-template-columns: minmax(0, 1fr) 402px !important;\n        gap: 24px !important;\n        padding: 16px 24px !important;\n        background: #f6f7f9 !important;\n      }\n    }\n\n    .flow-sidebar {\n      display: flex !important;\n      width: 402px !important;\n      min-width: 402px !important;\n      max-width: 402px !important;\n\n      .recommendations-section {\n        display: block !important;\n      }\n    }\n  }\n}\nbody {\n  background: #efeeee;\n  counter-reset: my-sec-counter;\n}\n.view-flow {\n  background: #efeeee;\n  min-height: 89vh;\n  padding-top: 10px;\n}\n\n.favorite-toggle-icon { \n  transition: color 0.2s ease;\n\n  &.liked {\n    color: #ff4d4d !important;\n  }\n}\n\n.bookmark-state-icon {\n  color: #666666;\n\n  &.saved {\n    color: #212427;\n  }\n}\n\n.action-item .favorite-toggle-icon {\n  &.liked {\n    color: #ff4d4d !important;\n  }\n}\n\n.flowbycat {\n  height: 100%;\n  display: table;\n  text-align: center;\n}\nheader {\n  width: 100%;\n  height: 100px;\n  background: #fff;\n  border-bottom: 2px solid #5ea1d8;\n}\n.container1 {\n  max-width: 100%;\n  width: 100%;\n  margin: 0;\n  background: transparent;\n  padding-bottom: 30px;\n  padding: 0;\n}\n.user-sec {\n  //display: flex;\n  padding: 20px 20px;\n  background: #fff;\n  border: 1px solid #ddd;\n  box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n  margin: 0px 20px 0px 20px;\n  border-radius: 10px;\n  position: relative;\n}\n.user-details {\n  flex: 1;\n  display: flex;\n}\n.user-ico {\n  flex: 1;\n  display: none !important;\n  img {\n    width: 180px !important;\n    height: 180px;\n    border-radius: 100%;\n    object-fit: cover;\n    max-width: 200px;\n  }\n}\n.ico-details {\n  flex: 4;\n  padding-left: 0px;\n  display: flex;\n  flex-direction: column;\n\n  p {\n    margin-bottom: 20px !important;\n    margin-top: 0px !important;\n  }\n  .profilepic {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n    flex-wrap: wrap;\n    .profinner {\n      max-width: 500px;\n      width: 100%;\n      display: flex;\n\n      & > div {\n        width: auto;\n        margin-right: 20px;\n        &:last-child {\n          span {\n            color: #212427 !important;\n            font-weight: 400 !important;\n            .mat-icon {\n              color: #212427 !important;\n              font-size: 18px;\n              display: flex;\n              align-items: center;\n            }\n          }\n        }\n      }\n    }\n\n    .u-ico {\n      margin-right: 15px;\n    }\n    .qrcode {\n      flex: 1;\n      justify-content: flex-end;\n      align-items: flex-end;\n      color: #212427 !important;\n      span {\n        font-weight: 400 !important;\n      }\n    }\n    p {\n      margin: 0px !important;\n    }\n    & > div {\n      display: flex;\n      align-items: center;\n      margin-right: 20px;\n      &:last-child {\n        margin-right: 0px;\n      }\n    }\n    img {\n      border-radius: 50%;\n      cursor: pointer;\n    }\n  }\n}\n.like {\n  max-width: 100%;\n  margin-bottom: 0px;\n  display: flex;\n  span.material-icons {\n    min-height: 30px;\n    color: #212427 !important;\n  }\n}\n.qr-code {\n  // flex:1;\n}\n.qr-ico {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  height: 100%;\n  position: absolute;\n  right: 20px;\n}\n.qr-ico i {\n  flex: 1;\n  font-size: 25px;\n  color: grey;\n  color: #212427;\n}\n.qr-ico p {\n  font-weight: 600;\n}\n\n// .social-ico {\n//   max-width: 275px;\n//   margin-top: 20px;\n// }\n// .social-ico ul li .fa {\n//   font-size: 27px;\n//   color: gray;\n//   color:#212427;\n//   text-shadow: 0px 2px 2px rgb(186 183 183 / 40%);\n//   margin-bottom: 5px;\n//   font-size: 30px;\n// }\n// .social-ico ul li .fa.fa-facebook-square {\n//   color: #4266b2;\n// }\n\n// .social-ico ul li .fa.fa-twitter-square {\n//   color: #55aded;\n// }\n// .social-ico ul li .fa.fa-linkedin-square {\n//   color: #007ab9;\n// }\n// .social-ico ul li .fa.fa-xing-square {\n//   color: #f96678;\n// }\n\nimg {\n  width: 100%;\n}\n\np {\n  font-family: \"Raleway\";\n  font-size: 15px;\n  line-height: 20px;\n}\nbutton {\n  padding: 3px 10px;\n  background: #5ea1d8;\n  border: 0px;\n  color: #fff;\n  font-size: 15px;\n  border-radius: 5px;\n}\n\nh2 {\n  font-family: \"Raleway\";\n  margin-bottom: 20px;\n}\nh3 {\n  font-family: \"Raleway\";\n  margin-bottom: 20px;\n  font-size: 16px;\n  font-weight: bold;\n}\n\nul {\n  display: flex;\n  list-style: none;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\nli {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  span {\n    margin-left: 0px;\n  }\n}\n.like {\n  .qrcode {\n    flex: 1;\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-end;\n  }\n}\n.like ul {\n  max-width: 500px;\n  width: 100%;\n  display: flex;\n  margin-left: -17px;\n}\n.like li {\n  height: 100%;\n  justify-content: flex-start;\n}\n.like li i {\n  font-size: 25px;\n  color: gray;\n  text-shadow: 0px 2px 2px rgb(186 183 183 / 40%);\n  margin-bottom: 5px;\n}\nli span {\n  font-size: 10px;\n  font-family: \"Raleway\";\n  font-weight: 600;\n  text-align: center;\n  color: #212427 !important;\n  padding: 0px !important;\n}\n\n/*description wrapper starts here*/\n.description-wrapper {\n  display: flex;\n  background: #fff;\n  margin: 10px 20px 10px 20px;\n}\n.des-item {\n  flex-basis: calc(50% - 20px);\n  // max-width: 3;\n  margin-right: 10px;\n  display: flex;\n  flex-direction: column;\n}\n.des-item .des {\n  /*max-height:200px;*/\n  flex: 1;\n  border: 1px solid #ddd;\n  margin-bottom: 0px;\n\n  border-radius: 0px;\n  padding: 40px 20px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n}\n.des-item .des p {\n  max-height: 100px;\n  overflow-y: auto;\n}\n\n.des-item .des > div {\n  flex: 1;\n  display: flex;\n  align-items: flex-start;\n  margin-top: 20px;\n}\n.des-item .des > div span {\n  flex: 1;\n  font-family: \"RALEWAY\";\n}\n.des-item .des > div span.material-icons.ng-star-inserted {\n  max-width: 30px;\n}\n.des-item .des > div span:first-child {\n  align-items: flex-start;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.des-item .des > div span:last-child {\n  text-align: flex-end;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n.des-item .des > div span i {\n  margin-right: 5px;\n}\n.des-item .item {\n  flex: 1;\n  border: 1px solid #ddd;\n  border-radius: 40px;\n  padding: 40px 20px;\n  box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n  margin-top: 20px;\n}\n.des-item .item .list {\n  display: flex;\n  /* padding: 20px 0px; */\n  max-height: 150px;\n  overflow-y: auto;\n  align-items: flex-start;\n}\n.des-item .item .list ul {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  margin: 0px 0px 20px;\n  padding: 5px;\n}\n.des-item .item .list ul li {\n  font-family: \"Raleway\";\n  font-size: 14px;\n  line-height: 28px;\n  word-break: break-all;\n  position: relative;\n\n  padding-left: 17px;\n  &:before {\n    content: \"\";\n    width: 8px;\n    height: 8px;\n    background: grey;\n    position: absolute;\n    left: 0px;\n    top: 10px;\n    border-radius: 50%;\n    box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n  }\n  &:first-child {\n    padding-left: 0px;\n    &:before {\n      display: none;\n    }\n  }\n}\n.des-item .item .list ul li:first-child {\n  font-weight: 600;\n}\n.step-sec {\n  flex: 1;\n  padding: 40px;\n  border: 1px solid #ddd;\n  border-radius: 40px;\n}\n.step-sec .img-wrap {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  // max-height: 382px;\n  position: relative;\n  overflow: hidden;\n  img {\n    // width:auto !important;\n    max-width: 100% !important;\n    height: 100%;\n    // object-fit: cover;\n    //max-height: 436px !important;\n    margin: 0px auto;\n    width: 100% !important;\n  }\n  video {\n    // width:auto !important;\n    max-width: 100% !important;\n    //max-height: 300px !important;\n    margin: 0px auto;\n    width: 100% !important;\n  }\n  &:empty {\n    display: none !important;\n  }\n}\n.step-sec .img-wrap:after {\n  content: \"›\";\n\n  background: #fafafa !important;\n  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n    0 1px 18px 0 rgb(0 0 0 / 12%);\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  position: absolute;\n  right: -49px;\n  top: calc(50% - 20px);\n  font-size: 35px;\n  margin-top: -8px;\n  display: none;\n}\n.step-sec .img-wrap:before {\n  content: \"‹\";\n\n  background: #fafafa !important;\n  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n    0 1px 18px 0 rgb(0 0 0 / 12%);\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  position: absolute;\n  left: -49px;\n  top: calc(50% - 20px);\n  font-size: 35px;\n  margin-top: -8px;\n  display: none;\n}\n.des-item .des p::-webkit-scrollbar {\n  width: 4px;\n  height: 100px;\n}\n.des-item .des p::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n.des-item .des p::-webkit-scrollbar-thumb {\n  background-color: #5ea1d8;\n  outline: 1px solid #5ea1d8;\n}\n\n.des-item .item .list::-webkit-scrollbar {\n  width: 4px;\n  height: 100px;\n}\n.des-item .item .list::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n.des-item .item .list::-webkit-scrollbar-thumb {\n  background-color: #5ea1d8;\n  outline: 1px solid #5ea1d8;\n}\n\n.step-sec {\n  display: flex;\n  flex-direction: column;\n  box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n}\n// .progressbar {\n//   flex: 1;\n//   display: table;\n//   align-items: center;\n//   height:30px;\n//   background:#fff;\n// }\n.progressbar ul {\n  display: flex;\n  flex-basis: 100%;\n}\n.progressbar ul li {\n  flex: 1;\n  display: flex;\n  align-items: center;\n}\n.progressbar ul li a {\n  width: 20px;\n  height: 20px;\n  background: #5ea1d8;\n  border-radius: 50%;\n  color: #fff;\n  text-decoration: none;\n  text-align: center;\n  font-size: 12px;\n  font-family: \"RALEWAY\";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.progressbar ul li a:before {\n  counter-increment: my-sec-counter;\n  content: \"\" counter(my-sec-counter) \"\";\n}\n\nimg {\n  max-width: 100%;\n}\n\n/*new added*/\n.viewflow-step {\n  width: calc(100% - 40px);\n  display: flex;\n  padding: 20px 20px;\n  border: 1px solid #ddd;\n  box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n  position: relative;\n  border-radius: 10px;\n  flex-wrap: wrap;\n  //min-height: 300px;\n  .des-item {\n    border-radius: 0px;\n    border-right: 1px solid lightgray;\n    max-width: calc(50% - 20px);\n    padding-right: 10px;\n    .des {\n      box-shadow: none;\n      border: 0px;\n      padding: 0px 0px;\n      h6 {\n        font-weight: bold;\n        margin-bottom: 5px;\n      }\n      & > div {\n        flex: none;\n        flex-wrap: wrap;\n      }\n      p {\n        max-height: 287px;\n        padding-right: 10px;\n      }\n      .s-num {\n        font-size: 16px;\n        width: 30px;\n        height: 30px;\n        color: #fff;\n        border: 0px solid #f3f3f3;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: space-around;\n        // box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n        font-family: \"Raleway\";\n        font-weight: 600;\n        margin-top: 0px;\n        margin-bottom: 20px;\n        position: relative;\n        z-index: 2;\n        &:before {\n          content: \"\";\n          width: 100%;\n          height: 100%;\n          border-radius: 50%;\n          left: 0px;\n          top: 0px;\n          position: absolute;\n          background: lightgray;\n          // border:1px solid #70bfe2;\n          z-index: -1;\n        }\n      }\n    }\n  }\n  .step-sec {\n    box-shadow: none;\n    border: 0px;\n    padding: 0px 0px 0px 0px;\n    margin-left: 10px;\n    width: 50%;\n    .progressbar {\n      border: 2px solid lightgray;\n      margin-bottom: 20px;\n      background: #fff;\n      border-radius: 10px;\n      padding: 5px;\n      // box-shadow:0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n      .w3-round {\n        height: 7px;\n        background: #5ea1d8;\n        background: lightgrey;\n      }\n    }\n  }\n  // &:before{\n  //   content:\"‹\";\n\n  // background: #fafafa !important;\n  //     box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n  //     width: 35px;\n  //     height: 35px;\n  //     border-radius: 50%;\n  //     display:flex;\n  //     align-items: center;\n  //     justify-content: center;\n  //     outline:none;\n  //   position:absolute;\n  // left:-49px;\n  // top: calc(50% - 20px);\n  // font-size:35px;\n\n  // }\n  // &:after{\n  //   content:\"›\";\n\n  // background: #fafafa !important;\n  //     box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n  //     width: 35px;\n  //     height: 35px;\n  //     border-radius: 50%;\n  //     display:flex;\n  //     align-items: center;\n  //     justify-content: center;\n  //     outline:none;\n  //   position:absolute;\n  // right:-49px;\n  // top: calc(50% - 20px);\n  // font-size:35px;\n\n  // }\n  .clickarrow {\n    width: 100%;\n    display: block;\n    position: absolute;\n    margin-top: 0px;\n    width: 100%;\n    height: 35px;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 1;\n\n    button.owl-prev {\n      position: absolute;\n      background: #fafafa !important;\n      box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n        0 1px 18px 0 rgb(0 0 0 / 12%);\n      width: 35px;\n      height: 35px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      outline: none;\n      left: -45px;\n      span {\n        font-size: 35px;\n        line-height: 0px;\n        display: flex;\n        align-items: center;\n        margin-top: -8px;\n        color: #000;\n      }\n    }\n    button.owl-next {\n      position: absolute;\n      background: #fafafa !important;\n      box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n        0 1px 18px 0 rgb(0 0 0 / 12%);\n      width: 35px;\n      height: 35px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      outline: none;\n      right: -45px;\n      span {\n        font-size: 35px;\n        line-height: 0px;\n        display: flex;\n        align-items: center;\n        margin-top: -8px;\n        color: #000;\n      }\n    }\n  }\n}\n@media only screen and (max-width: 1025px) and (min-width: 320px) {\n  .view-flow {\n    // background:#fff;\n    h2 {\n      font-size: 22px !important;\n      // word-break: break-all;\n    }\n  }\n}\n@media only screen and (max-width: 992px) and (min-width: 320px) {\n  .view-flow {\n    .container1 {\n      display: flex;\n      flex-direction: column;\n      // padding: 0px 15px 20px;\n      .user-sec {\n        flex-direction: row;\n        // margin:0px;\n        // padding: 0rem 0px 2rem;\n        .user-details {\n          flex-direction: column;\n          order: 2;\n          .user-ico {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n          }\n          .ico-details {\n            padding: 0px;\n            .profilepic {\n              & > div {\n                p {\n                  font-size: 14px;\n                }\n              }\n            }\n            .like {\n              display: flex;\n              flex-direction: column;\n              margin-left: 0px;\n              ul {\n                margin-left: 0px;\n                max-width: 100%;\n                margin-bottom: 10px;\n                li {\n                  i {\n                    font-size: 20px;\n                  }\n                }\n              }\n              .qrcode {\n                span {\n                  margin-right: 0px !important;\n                }\n                p {\n                  margin-bottom: 0px !important;\n                }\n              }\n            }\n          }\n        }\n        .qr-code {\n          padding: 10px 0px;\n        }\n      }\n    }\n    .description-wrapper {\n      flex-direction: column;\n      margin: 0px;\n      margin-bottom: 20px;\n      .des-item {\n        margin-right: 0px;\n        margin-bottom: 20px;\n        flex-basis: 100%;\n        max-width: unset;\n        border-right: 0px;\n        padding-right: 0px;\n        .des {\n          & > div {\n            span {\n              &:first-child {\n                justify-content: flex-start;\n              }\n            }\n          }\n          .timer-wrap {\n            display: flex;\n            flex-direction: column;\n            flex: none;\n            color: #212427;\n            > * {\n              margin-right: 10px;\n            }\n          }\n        }\n      }\n      .step-sec {\n        .img-wrap {\n          img {\n            //max-height: 300px !important;\n            // width: auto !important;\n          }\n        }\n      }\n    }\n    .viewflow-step {\n      width: 100%;\n      margin: 0px auto 20px;\n\n      .des-item {\n        flex-basis: 100%;\n        max-width: unset;\n        border-bottom: 2px solid lightgrey;\n        padding-bottom: 0px;\n        border-bottom: 0px;\n\n        .des {\n          padding-bottom: 0px;\n          // border-bottom:1px solid lightgray;\n          border-radius: 0px;\n        }\n      }\n      .step-sec {\n        padding: 0px;\n        margin-left: 0px;\n        width: 100%;\n      }\n\n      .clickarrow {\n        button {\n          width: 25px;\n          height: 25px;\n          &.owl-prev {\n            // left: -20px;\n            // background:transparent !important;\n            // box-shadow: none !important;\n          }\n          &.owl-next {\n            // right: -20px;\n            // background:transparent !important;\n            // box-shadow: none !important;\n          }\n        }\n      }\n    }\n  }\n  .qr-ico {\n    position: relative;\n    right: 0px;\n  }\n}\n\n/*table struture starts here*/\n.table-wrap {\n  max-height: 260px;\n  overflow-y: auto;\n  padding-right: 7px;\n  &::-webkit-scrollbar {\n    width: 4px;\n    height: 100px;\n  }\n  &::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: #5ea1d8;\n    outline: 1px solid #5ea1d8;\n  }\n}\ntable {\n  padding-right: 20px;\n  width: 100%;\n  tr {\n    display: flex;\n    width: 100%;\n    flex-flow: row wrap;\n    justify-content: space-between;\n    th {\n      font-family: \"Raleway\";\n      font-weight: 600 !important;\n      font-size: 16px !important;\n      width: 48%;\n      word-break: break-all;\n      margin-bottom: 15px;\n      line-height: 25px;\n    }\n    td {\n      width: 100%;\n      word-break: break-all;\n      margin-bottom: 15px;\n      font-family: \"Raleway\";\n      font-weight: 400;\n      line-height: 25px;\n      font-size: 13px;\n      position: relative;\n      padding-left: 15px;\n      display: flex;\n      & > span {\n        width: 48%;\n        overflow-wrap: break-word;\n        &:first-child {\n          margin-right: 4%;\n        }\n      }\n      &:before {\n        content: \"\";\n        width: 8px;\n        height: 8px;\n        background: grey;\n        position: absolute;\n        left: 0px;\n        top: 8px;\n        border-radius: 50%;\n        box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n      }\n      // &:nth-child(even){\n      //   &:before{\n      //     display: none;\n      //   }\n      // }\n    }\n  }\n}\n.btm-btn {\n  display: flex;\n  align-items: center;\n  & > div {\n    flex: 1;\n    &:first-child {\n      justify-content: flex-start;\n    }\n    &:last-child {\n      justify-content: right;\n      text-align: end;\n    }\n  }\n  .lock {\n    display: flex;\n    align-items: center;\n    font-family: \"Raleway\";\n    & > span {\n      display: flex;\n      align-items: center;\n    }\n  }\n}\n// .cdk-overlay-pane .mat-menu-panel{\n//   left:-250px !important;\n//   top:-19px !important;\n\n// }\n.profilepic {\n  .lock {\n    display: block;\n  }\n}\n.like-list {\n  .fashion-btn {\n    display: block;\n  }\n}\n.qr-code {\n  .lock,\n  .fashion-btn {\n    display: none;\n  }\n}\n@media only screen and (max-width: 992px) and (min-width: 461px) {\n  .view-flow {\n    .container1 {\n      .user-sec {\n        .user-details {\n          flex-direction: row;\n          // margin-bottom:30px;\n          // padding-left:15px;\n          .ico-details {\n            padding-left: 15px;\n            max-width: 100%;\n            .like {\n              ul {\n                margin-left: -15px;\n              }\n              .qrcode {\n                span {\n                  margin-right: 15px !important;\n                }\n              }\n            }\n            .profilepic {\n              & > div {\n                p {\n                  font-size: 14px !important;\n                }\n              }\n            }\n          }\n        }\n      }\n      .description-wrapper {\n        width: auto;\n        // max-width:80%;\n        // max-width:calc(100% - 50px);\n        margin: 10px 0px;\n\n        .step-sec {\n          .img-wrap {\n            max-height: unset;\n          }\n        }\n      }\n      .viewflow-step {\n        .des-item {\n          .des {\n            padding-bottom: 20px;\n            // border-bottom:1px solid lightgray;\n            border-radius: 0px;\n          }\n        }\n        .clickarrow button {\n          &.owl-next {\n            right: -35px;\n          }\n          &.owl-prev {\n            left: -35px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 992px) and (min-width: 768px) {\n  .view-flow {\n    .viewflow-step {\n      .clickarrow {\n        button {\n          width: 35px;\n          height: 35px;\n          &.owl-prev {\n            left: -45px;\n          }\n          &.owl-next {\n            right: -45px;\n          }\n        }\n      }\n    }\n  }\n}\n@media only screen and (max-width: 460px) and (min-width: 320px) {\n  .view-flow\n    .container1\n    .user-sec\n    .user-details\n    .ico-details\n    .profilepic\n    > div\n    p {\n    font-size: 11px !important;\n  }\n  .ico-details .profilepic > div:last-child {\n    span {\n      font-size: 11px;\n    }\n  }\n  .view-flow .viewflow-step .clickarrow {\n    button {\n      width: 25px;\n      height: 25px;\n      &.owl-prev {\n        left: -30px;\n        // background:transparent !important;\n        // box-shadow: none !important;\n      }\n      &.owl-next {\n        right: -30px;\n        // background:transparent !important;\n        // box-shadow: none !important;\n      }\n    }\n  }\n  .view-flow .viewflow-step {\n    width: auto;\n    margin: 10px 20px;\n  }\n  .qr-code {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    .lock {\n      > span {\n        display: flex;\n        align-items: center;\n      }\n      .priceIcon-p {\n        top: -2px;\n      }\n    }\n    .qr-ico {\n      // width: 24px;\n      // background: gray;\n      // display: block;\n      // height: 35px;\n    }\n    .lock,\n    .fashion-btn {\n      display: block;\n    }\n  }\n\n  .profilepic {\n    .lock {\n      display: none !important;\n    }\n  }\n  .like-list {\n    .fashion-btn {\n      display: none !important;\n    }\n  }\n  .view-flow h2 span {\n    font-size: 20px !important;\n    word-break: break-word;\n  }\n  .view-flow .container1 .user-sec {\n    padding: 10px;\n  }\n  .ico-details .profilepic .profinner > div {\n    margin-right: 5px;\n  }\n  .ico-details .profilepic > div {\n    margin-right: 0px;\n  }\n  .like li:last-child {\n    display: none !important;\n  }\n  .viewflow-step .des-item .des p {\n    max-height: 133px;\n  }\n  .view-flow .container1 .user-sec .user-details .ico-details .like ul li span {\n    font-size: 9px;\n  }\n}\n\nbutton.common {\n  padding: 3px 6px !important;\n  background: #5ea1d8 !important;\n\n  border: 0px !important;\n  color: #fff !important;\n  font-size: 13px !important;\n  border-radius: 5px !important;\n}\n\n@media (max-width: 500px) {\n  .ico-details .profilepic .qrcode {\n    justify-content: center;\n  }\n}\n\n.example-list {\n  max-width: 100%;\n  // border: solid 1px #ccc;\n  // min-height: 246px;\n  height: auto;\n  display: block;\n  background: white;\n  // border-radius: 4px;\n  overflow-y: auto;\n  .example-box {\n    display: flex;\n    padding: 15px 10px;\n    border-bottom: 1px solid lightgrey;\n    background: white !important;\n    .item-name {\n      text-align: left;\n      width: 70%;\n    }\n\n    .item-value {\n      text-align: left;\n      width: 30%;\n    }\n\n    .item-name,\n    .item-delete,\n    .item-reorder,\n    .item-value {\n      text-align: left;\n      padding: 5px;\n      font-size: 14px;\n      font-weight: 400 !important;\n      overflow-wrap: break-word;\n    }\n    .item-delete,\n    .item-reorder {\n      float: right;\n      cursor: pointer;\n      font-size: 20px;\n      width: 10%;\n    }\n    &:last-child {\n      border-bottom: 0px;\n    }\n  }\n  &::-webkit-scrollbar {\n    width: 4px;\n    height: 100px;\n  }\n  &::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: #5ea1d8;\n    outline: 1px solid #5ea1d8;\n  }\n}\n\n.example-box {\n  padding: 15px 10px;\n  border-bottom: solid 1px lightgray;\n  color: rgba(0, 0, 0, 0.87);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  cursor: move;\n  background: white;\n  font-size: 14px;\n  & > div {\n    width: 50%;\n    display: flex !important;\n    &:first-child {\n      width: 80%;\n    }\n    &:last-child {\n      width: 17%;\n    }\n    & > span {\n      // width:48%;\n      text-align: left;\n      word-break: keep-all;\n      display: flex;\n      align-items: center;\n\n      &:first-child {\n        flex: 1;\n        width: 50%;\n        color: rgba(0, 0, 0, 0.54) !important;\n        font-weight: 400 !important;\n      }\n      &:last-child {\n        width: 50%;\n        text-align: center;\n        display: flex;\n        align-items: center;\n        justify-content: end;\n        white-space: nowrap;\n        color: rgba(0, 0, 0, 0.54) !important;\n        font-weight: 400 !important;\n      }\n    }\n  }\n}\n.itemremove {\n  span {\n    &:first-child {\n      width: 90% !important;\n    }\n    &:nth-child(2) {\n      display: none;\n    }\n  }\n}\n\n.img-div-left {\n  position: fixed;\n  z-index: 9999999 !important;\n  height: 100px;\n  width: 100px;\n  // background: green !important;\n  overflow: visible;\n  margin: auto;\n  top: 5% !important;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  img {\n    width: 100%;\n    height: 100%;\n    position: absolute !important;\n    top: 0% !important;\n  }\n}\n\n.card {\n  height: 100px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  transition: 0.3s;\n  width: 30%;\n}\n\n.card:hover {\n  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n}\n\n.card {\n  width: calc(50% - 30px);\n  box-shadow: none;\n  margin: 40px auto 0px auto;\n  height: auto !important;\n  .container {\n    padding: 5px 16px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n  }\n}\n\n// .item {\n//   margin-right: 0px !important;\n//   margin-left: 0px !important;\n//   // width: calc(100% - 10px)!important;\n//   border: 1px solid #ddd !important;\n//   margin: 5px !important;\n//   overflow: hidden;\n//   background: #fff;\n//   position: relative;\n//   box-shadow: -2px 2px 7px hsl(0deg 6% 77% / 50%);\n//   p {\n//     text-align: left;\n//   }\n\n//   img {\n//     border: 1px solid #ddd;\n//     width: calc(100% - 10px) !important;\n//     height: 150px !important;\n//     border-radius: 0 !important;\n//     margin: 5px !important;\n//     object-fit: cover;\n//   }\n//   .with-icon {\n//     display: flex;\n//     & > div {\n//       width: 40px !important;\n//     }\n//     img {\n//       // width:100% !important;\n//       height: 30px !important;\n//       border-radius: 20px !important;\n//       object-fit: cover !important;\n//     }\n//   }\n// }\n\n/*new design starts here new bundle*/\n// .viewbundle {\n//   .step-sec {\n//     & + .row {\n//       margin-top: 40px !important;\n//       display: flex;\n//       justify-content: flex-start;\n//       width: 100%;\n//       & > div {\n//         width: 25% !important;\n//         .item {\n//           box-shadow: none !important;\n//           img {\n//             width: calc(100% - 20px) !important;\n//             object-fit: cover;\n//             margin: 10px !important;\n//           }\n//           p {\n//             padding-left: 5px;\n//             display: -webkit-box;\n//             -webkit-line-clamp: 2;\n//             -webkit-box-orient: vertical;\n//             overflow: hidden;\n//             text-overflow: ellipsis;\n//             height: 33px !important;\n//             white-space: normal;\n//             word-break: break-word;\n//           }\n//           .with-icon {\n//             display: flex;\n//             img {\n//               width: 30px !important;\n//               height: 30px !important;\n//               border-radius: 20px !important;\n//             }\n//           }\n//         }\n//       }\n//     }\n//   }\n// }\n\n@media (max-width: 460px) {\n  .viewbundle {\n    .step-sec {\n      & + .row {\n        & > div {\n          width: 50% !important;\n          .item {\n            .with-icon {\n              display: flex;\n              align-items: center;\n              & > div {\n                width: 30px !important;\n              }\n              img {\n                margin: 0px !important;\n              }\n              p {\n                padding-left: 5px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n@media only screen and (min-width: 461px) and (max-width: 767px) {\n  .viewbundle {\n    .step-sec {\n      & + .row {\n        & > div {\n          width: 33% !important;\n          .item {\n            .with-icon {\n              display: flex;\n              align-items: center;\n              & > div {\n                width: 30px !important;\n              }\n              img {\n                margin: 0px !important;\n              }\n              p {\n                padding-left: 5px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.bundleIcon {\n  bottom: 10px;\n  right: 10px;\n  z-index: 10;\n  width: 25px !important;\n  height: 25px !important;\n  max-width: 25px !important;\n  height: 25px !important;\n  margin-left: 10px;\n  img {\n    width: 100% !important;\n    height: auto !important;\n    object-fit: contain;\n    border: none;\n  }\n}\n\n.ico-details .profilepic .uni-wrapper {\n  display: flex;\n  width: auto;\n  align-items: center;\n  P {\n    flex: 1;\n  }\n}\n\n// .partOfBundle {\n//   padding: 0px 20px 0px;\n//   background: #fff;\n//   background: transparent;\n//   // border: 1px solid #ddd;\n//   // box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n//   margin: 0px 20px 0px 0px;\n//   border-radius: 10px;\n//   overflow-x: auto;\n// width: 100%;\n//   h2 {\n//     position: absolute;\n//   }\n//   .row {\n//     flex-wrap: nowrap !important;\n//     width: fit-content;\n//     margin-top: 0px !important;\n//   }\n//   .item {\n//     background: #fff;\n//     margin-left: 0px;\n//     width: 170px !important;\n//     & > div:first-child {\n//       img {\n//         height: 150px !important;\n//       }\n//     }\n//     & > div:last-child {\n//       p {\n//         height: 25px !important;\n//       }\n//     }\n//   }\n//   &.newdesign{\n//     display:flex;\n//     & .row{\n//       flex-wrap: wrap !important;\n//     width: -webkit-fit-content;\n//     width: -moz-fit-content;\n//     width: fit-content;\n//     margin-top: 0px !important;\n\n//     }\n//   }\n// }\n\n@media only screen and (max-width: 767px) and (min-width: 320px) {\n  .view-flow .container1 .user-sec {\n    margin: 0px;\n  }\n  .view-flow .viewflow-step {\n    margin: 10px 0px;\n  }\n  // .partOfBundle {\n  //   padding: 0px 0px 20px;\n  //   overflow: hidden;\n  // }\n  // .partOfBundle .row {\n  //   width: auto;\n  //   margin-top: 0px !important;\n  //   flex-wrap: wrap !important;\n\n  //   // justify-content: space-between;\n  //   &>div{\n  //     display:flex;\n  //     width:44.8vw;\n  //     width:160px;\n  //     margin-bottom:10px;\n  //     margin-right:10px;\n  //   }\n  //   .item{\n  //     width:100% !important;\n  //   }\n  //   &:before{\n  //     display:none !important;\n  //   }\n  // }\n  // .partOfBundle .item {\n  //   width: 150px !important;\n  //   margin: 0px !important;\n  //   box-shadow: none !important;\n  // }\n  .ico-details .profilepic .qrcode {\n    justify-content: right;\n  }\n}\n\n/*new design add 14-05-2022*/\n\n/* new common design add*/\n\n.flobycategoryadd {\n  .user-pro .flowbycategory-row {\n    width: calc(100% - 40px);\n    margin: 0px 20px !important;\n    .flowbycategory-tile {\n      width: 18.6%;\n      margin-right: 1%;\n\n      .item {\n        width: 100% !important;\n        overflow: hidden;\n        background: #fff;\n        border: 1px solid #dddddd;\n        margin: 0px;\n        margin-right: 20px;\n        margin-bottom: 20px;\n        height: 95%;\n        position: relative;\n        padding: 10px !important;\n        div {\n          margin: 0px !important;\n        }\n        p {\n          display: -webkit-box;\n          -webkit-line-clamp: 2;\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          height: 35px !important;\n          white-space: normal;\n          word-break: break-word;\n          display: flex;\n          align-items: flex-start;\n          margin-top: 0px !important;\n          line-height: 18px !important;\n          margin-left: 5px;\n          &:last-of-type {\n            // height: auto !important;\n            // font-size: 12px !important;\n          }\n        }\n        .uni-wrapper {\n          display: flex;\n          width: 100%;\n          align-items: center;\n        }\n        .with-icon {\n          width: 100%;\n          font-family: \"Raleway\";\n          display: flex;\n          align-items: center;\n          margin: 0px !important;\n          img {\n            -o-object-fit: cover;\n            object-fit: cover;\n            height: 40px !important;\n            border: 0px;\n            margin: 0px !important;\n          }\n        }\n      }\n    }\n    video.video-display[poster] {\n      height: 100% !important;\n      padding-bottom: 12%;\n      max-height: 100% !important;\n      max-width: 100% !important;\n      width: 100% !important;\n      text-align: center;\n      cursor: pointer;\n      min-height: 150px !important;\n    }\n  }\n  .mat-sidenav-content {\n    background: #efeeee !important;\n    min-height: 89vh !important;\n    padding: 2rem 3rem !important;\n    padding-top: 0px !important;\n  }\n}\n@media only screen and (max-width: 992px) and (min-width: 320px) {\n  .supportingdoc {\n    position: relative !important;\n    padding: 10px 10px 10px 0px !important;\n  }\n}\n@media only screen and (max-width: 992px) and (min-width: 768px) {\n  .flobycategoryadd {\n    .user-pro {\n      .flowbycategory-row {\n        .flowbycategory-tile {\n          max-width: 23% !important;\n          width: 23% !important;\n          // margin: 1% !important;\n        }\n      }\n    }\n  }\n  .view-flow .container1 .description-wrapper {\n    margin: 10px 20px !important;\n  }\n}\n@media only screen and (max-width: 767px) and (min-width: 320px) {\n  .flobycategoryadd {\n    .user-pro {\n      .flowbycategory-row {\n        width: 100%;\n        margin: 0px !important;\n      }\n    }\n\n    .mat-sidenav-content {\n      background: #efeeee !important;\n      min-height: 89vh !important;\n      padding: 2rem 10px !important;\n      padding-top: 0px !important;\n    }\n  }\n}\n\n@media only screen and (max-width: 767px) and (min-width: 461px) {\n  .flobycategoryadd {\n    .user-pro {\n      .flowbycategory-row {\n        .flowbycategory-tile {\n          max-width: 31.3% !important;\n          width: 31.3% !important;\n          margin: 1%;\n        }\n      }\n    }\n  }\n}\n@media screen and (max-width: 460px) {\n  .flobycategoryadd {\n    .user-pro {\n      .flowbycategory-row {\n        .flowbycategory-tile {\n          max-width: 48% !important;\n          width: 48% !important;\n          margin: 1%;\n        }\n      }\n    }\n  }\n}\n.qrcode {\n  .uni-wrapper {\n    p {\n      .common {\n        background: #e83e8c !important;\n      }\n    }\n  }\n}\n\n.view-flow .partOfBundle {\n  padding: 0px 20px 20px;\n  background: #fff;\n  background: transparent;\n  margin: 0px 20px 0px 0px;\n  border-radius: 10px;\n  overflow-x: scroll;\n  h2 {\n    font-size: 2rem;\n    line-height: 1.2;\n    margin-bottom: 0px !important;\n  }\n}\n.flobycategoryadd .user-pro .flowbycategory-row {\n  width: calc(100% - 0px);\n  margin: 0px 0px 0px 0px !important;\n}\n.newdesignadd {\n  border: 0px !important;\n  padding: 0px !important;\n  // width:100%;\n  // display: block;\n}\n.not-draggable {\n  -webkit-user-drag: none; /* Safari/Chrome */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* IE10+ */\n  user-select: none; /* Standard syntax */\n  cursor: default; /* Optional: Change the cursor style */\n  transform: translate(0, 0) !important;\n  width: 100%;\n}\n.divscroll {\n  width: 100% !important;\n  display: flex;\n  flex-direction: row;\n  height: 100px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  div {\n    width: 100% !important;\n  }\n}\n@media (max-width: 767px) {\n  .partOfBundle {\n    padding: 0px 0px 20px 0px !important;\n    margin-right: 0px !important;\n    h2 {\n      margin-top: 0px !important;\n    }\n  }\n  .view-flow .container1 .viewflow-step {\n    margin-bottom: 10px !important;\n  }\n}\n.view-flow\n  .container1\n  .user-sec\n  .user-details\n  .ico-details\n  .profilepic\n  .profinner {\n  div:nth-child(4) {\n    position: relative;\n    span {\n      position: relative !important;\n    }\n  }\n}\n@media (max-width: 767px) {\n  .priceIcon-wp {\n    position: relative !important;\n  }\n  .qr-code .fashion-btn + .fashion-btn {\n    display: none !important;\n  }\n}\n.qrcode.mobview {\n  display: none;\n}\n@media (max-width: 767px) {\n  .qrcode.mobview {\n    display: flex;\n    align-items: center;\n    p {\n      margin-bottom: 0px !important;\n    }\n  }\n  .desktopview {\n    display: none;\n  }\n}\n\n// Flow-style layout styles (matching view-flow)\n.view-flow {\n  // Flow-style layout container\n  .flow-layout-container {\n    width: 100%;\n    padding: 0;\n    margin: 0;\n\n    .flow-main-grid {\n      display: grid;\n      grid-template-columns: minmax(0, 1fr) 402px;\n      gap: 24px;\n      max-width: 100%;\n      margin: 0;\n      padding: 16px 24px;\n      background: #f6f7f9;\n\n      @media (min-width: 1920px) {\n        max-width: 1920px;\n        margin: 0 auto;\n        padding: 24px 48px;\n      }\n\n      @media (max-width: 1024px) {\n        grid-template-columns: 1fr;\n        gap: 16px;\n        padding: 16px;\n        background: transparent;\n      }\n\n      @media (max-width: 768px) {\n        padding: 2px;\n        gap: 12px;\n      }\n    }\n  }\n\n  // Main Content Area (Left Column)\n  .flow-main-content {\n    min-width: 0; // Prevents grid overflow\n\n    /* Sticky Bundle Title Bar */\n    .flow-title-sticky {\n      top: 88px;\n      z-index: 0;\n      background: #ffffff;\n      border-radius: 16px;\n     //box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n      padding: 16px;\n      margin-bottom: 16px;\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      flex-wrap: wrap;\n      justify-content: space-between;\n      pointer-events: auto;\n\n      @media (max-width: 1024px) {\n        border-radius: 0;\n        box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);\n        border-bottom: 1px solid #e0e0e0;\n        padding: 16px 0 8px 0;\n        margin-bottom: 8px;\n      }\n\n      .video-title-sticky {\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 1.3;\n        color: #0f0f0f;\n        margin: 4px;\n        font-family: \"Raleway\", sans-serif;\n        flex: 1;\n        min-width: 0;\n      }\n    }\n\n    // Video Player Section\n    .video-player-section { \n      background: #000;\n      border-radius: 12px;\n      overflow: hidden;\n      margin-bottom: 16px;\n      position: relative;\n\n      @media (max-width: 1024px) {\n        margin: 0;\n        border-radius: 0;\n\n        .img-wrap {\n          width: 100% !important;\n          max-width: 100% !important;\n          margin: 0 !important;\n        }\n      }\n\n      .img-wrap {\n        width: 100%;\n        position: relative;\n        padding-bottom: 56.25%; // 16:9 aspect ratio\n        height: 0;\n        overflow: hidden; \n\n        img,\n        video {\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 100%;\n          height: 100%;\n          object-fit: contain; \n          background: #000;\n        }\n\n        .main-video-player {\n          width: 100%;\n          height: 100%;\n        }\n      }\n    }\n\n    // Video Metadata Section\n    .video-metadata {\n      padding: 16px;\n      background: #ffffff;\n      border-radius: 16px;\n     //box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n      margin-bottom: 16px;\n\n      @media (max-width: 1024px) {\n        padding: 16px;\n        background: #ffffff;\n        border-radius: 0;\n        box-shadow: none;\n        border-bottom: 1px solid #e0e0e0;\n        margin-bottom: 0;\n      }\n\n      .step-header {\n        display: flex;\n        align-items: flex-start;\n        gap: 16px;\n        margin-bottom: 12px;\n        flex-wrap: wrap;\n        justify-content: space-between;\n\n        .step-header-main {\n          display: flex;\n          align-items: center;\n          gap: 12px;\n          flex: 1;\n          min-width: 0;\n        }\n\n        .video-title {\n          font-size: 20px;\n          font-weight: 500;\n          line-height: 28px;\n          color: #0f0f0f;\n          margin: 0;\n          flex: 1;\n          min-width: 0;\n        }\n      }\n\n      .video-actions-bar {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        overflow-x: auto;\n        overflow-y: hidden;\n        -webkit-overflow-scrolling: touch;\n\n        &::-webkit-scrollbar {\n          height: 6px;\n        }\n\n        &::-webkit-scrollbar-thumb {\n          background: rgba(0, 0, 0, 0.2);\n          border-radius: 4px;\n        }\n\n        &::-webkit-scrollbar-thumb:hover {\n          background: rgba(0, 0, 0, 0.3);\n        }\n\n        .action-buttons {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          flex-wrap: nowrap;\n          width: max-content;\n\n          .action-item {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            padding: 8px 16px;\n            border-radius: 18px;\n            cursor: pointer;\n            transition: background 0.2s;\n            background: #f2f2f2;\n            flex: 0 0 auto;\n            /* Let labels inherit; do not set span to #212427 !important — it beats global dark theme. */\n            color: #212427;\n\n            &:hover:not(.disabled) {\n              background: #e5e5e5;\n            }\n\n            &.disabled {\n              opacity: 0.5;\n              cursor: not-allowed;\n              pointer-events: none;\n            }\n\n            &.delete-action {\n              background: #ffebee;\n              color: #d32f2f;\n\n              &:hover {\n                background: #ffcdd2;\n              }\n\n              mat-icon {\n                color: #d32f2f;\n              }\n\n              span {\n                color: #d32f2f;\n              }\n            }\n\n            // Match label color in light; global dark uses .app-main-content .mat-icon\n            mat-icon {\n              font-size: 20px;\n              width: 20px;\n              height: 20px;\n              color: currentColor;\n            }\n\n            // Bookmark icon - show flowchest blue when saved\n            mat-icon[style*=\"#5ea1d8\"] {\n              color: #5ea1d8 !important;\n            }\n\n            span {\n              font-size: 14px;\n              font-weight: 500;\n            }\n          }\n        }\n      }\n    }\n\n    // Channel Info Section\n    .channel-info-section {\n      padding: 16px;\n      background: #ffffff;\n      border-radius: 16px;\n     //box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n      margin-bottom: 16px;\n\n      @media (max-width: 1024px) {\n        padding: 16px;\n        background: #ffffff;\n        border-radius: 0;\n        box-shadow: none;\n        border-bottom: 1px solid #e0e0e0;\n        margin-bottom: 0;\n      }\n\n      .channel-header {\n        display: flex;\n        align-items: center;\n        gap: 16px;\n\n        .channel-avatar {\n          flex-shrink: 0;\n\n          img {\n            width: 48px;\n            height: 48px;\n            border-radius: 50%;\n            object-fit: cover;\n            cursor: pointer;\n          }\n\n          .material-icons {\n            font-size: 48px;\n            width: 48px;\n            height: 48px;\n            color: #606060;\n            cursor: pointer;\n          }\n        }\n\n        .channel-details {\n          flex: 1;\n          min-width: 0;\n\n          .channel-name {\n            font-size: 16px;\n            font-weight: 500;\n            color: #0f0f0f;\n            cursor: pointer;\n            margin-bottom: 4px;\n\n            &:hover {\n              color: #606060;\n            }\n          }\n\n          .channel-meta {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            flex-wrap: wrap;\n            font-size: 14px;\n            color: #606060;\n\n            mat-icon {\n              font-size: 16px;\n              width: 16px;\n              height: 16px;\n            }\n\n            .price-tag {\n              color: #e83e8c;\n              cursor: pointer;\n              font-weight: 500;\n\n              &:hover {\n                text-decoration: underline;\n              }\n            }\n\n            .purchased-tag {\n              color: #606060;\n              background: #f2f2f2;\n              padding: 2px 8px;\n              border-radius: 4px;\n            }\n\n            .version-tag {\n              display: inline-flex;\n              align-items: center;\n              gap: 4px;\n              color: #5ea1d8;\n              background: #f0f0f0;\n              padding: 3px 10px;\n              border-radius: 4px;\n              font-size: 12px;\n              font-weight: 500;\n              cursor: pointer;\n              transition: background-color 0.2s ease;\n\n              &:hover {\n                background: #e5e5e5;\n              }\n\n              mat-icon {\n                font-size: 14px;\n                width: 14px;\n                height: 14px;\n                color: #5ea1d8;\n              }\n            }\n          }\n        }\n\n        .channel-actions {\n          display: flex;\n          gap: 8px;\n          flex-shrink: 0;\n\n          .follow-btn {\n            padding: 10px 16px;\n            border-radius: 18px;\n            border: 1px solid #5ea1d8;\n            font-size: 14px;\n            font-weight: 500;\n            cursor: pointer;\n            transition: background 0.2s, box-shadow 0.2s;\n\n            &.following {\n              background: #f2f8fc;\n              color: #0f0f0f;\n              border-color: #5ea1d8;\n\n              &:hover {\n                background: #e1f0fa;\n              }\n            }\n\n            &:not(.following) {\n              background: #5ea1d8;\n              color: #ffffff;\n              box-shadow: 0 4px 10px rgba(94, 161, 216, 0.35);\n\n              &:hover {\n                background: #4b8ac1;\n              }\n            }\n          }\n\n          .purchase-btn {\n            padding: 10px 16px;\n            border-radius: 18px;\n            border: none;\n            background: #e83e8c;\n            color: white;\n            font-size: 14px;\n            font-weight: 500;\n            cursor: pointer;\n            transition: background 0.2s;\n\n            &:hover {\n              background: #d0307a;\n            }\n          }\n        }\n      }\n    }\n\n    // Description Section\n    .description-section {\n      padding: 16px;\n      background: #ffffff;\n      border-radius: 16px;\n     //box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n      margin-bottom: 16px;\n\n      @media (max-width: 1024px) {\n        background: #f9f9f9;\n        border-radius: 12px;\n        box-shadow: none;\n      }\n\n      .description-header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-bottom: 8px;\n      }\n\n      .description-content {\n        font-size: 14px;\n        line-height: 20px;\n        color: #0f0f0f;\n        max-height: 60px;\n        overflow: hidden;\n        transition: max-height 0.3s ease;\n\n        &.expanded {\n          max-height: none;\n        }\n\n        .supporting-docs-link {\n          margin-top: 12px;\n\n          a {\n            color: #5ea1d8;\n            text-decoration: none;\n            font-weight: 500;\n\n            &:hover {\n              text-decoration: underline;\n            }\n          }\n        }\n      }\n\n      .expand-description-btn {\n        margin-top: 8px;\n        background: none;\n        border: none;\n        color: #606060;\n        font-size: 14px;\n        font-weight: 500;\n        cursor: pointer;\n        padding: 0;\n\n        &:hover {\n          color: #0f0f0f;\n        }\n      }\n    }\n\n    // Comments Section (matching view-flow)\n    .comments-section {\n      padding: 16px;\n      background: #ffffff;\n      border-radius: 16px;\n     //box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n      margin-bottom: 16px;\n\n      @media (max-width: 1024px) {\n        padding: 16px 0;\n        background: transparent;\n        border-radius: 0;\n        box-shadow: none;\n      }\n\n      h3 {\n        font-size: 16px;\n        font-weight: 500;\n        color: #0f0f0f;\n        margin-bottom: 24px;\n      }\n\n      .comment-input-section {\n        display: flex;\n        gap: 16px;\n        margin-bottom: 32px;\n\n        .comment-avatar {\n          flex-shrink: 0;\n\n          img {\n            width: 40px;\n            height: 40px;\n            border-radius: 50%;\n            object-fit: cover;\n          }\n\n          .material-icons {\n            font-size: 40px;\n            width: 40px;\n            height: 40px;\n            color: #606060;\n          }\n        }\n\n        .comment-form-wrapper {\n          flex: 1;\n          position: relative;\n\n          form {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n          }\n\n          .comment-input {\n            flex: 1;\n            padding: 8px 0;\n            border: none;\n            border-bottom: 1px solid #e0e0e0;\n            font-size: 14px;\n            color: #0f0f0f;\n            background: transparent;\n\n            &:focus {\n              outline: none;\n              border-bottom-color: #5ea1d8;\n            }\n\n            &::placeholder {\n              color: #909090;\n            }\n          }\n\n          .comment-send-btn {\n            flex-shrink: 0;\n            background: transparent;\n            border: none;\n            color: #5ea1d8;\n            cursor: pointer;\n            padding: 8px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border-radius: 50%;\n            transition: all 0.2s;\n\n            &:hover:not(:disabled) {\n              background: #f0f0f0;\n              color: #4a8fc4;\n            }\n\n            &:disabled {\n              color: #ccc;\n              cursor: not-allowed;\n            }\n\n            mat-icon {\n              font-size: 20px;\n              width: 20px;\n              height: 20px;\n            }\n          }\n\n          .comment-guidelines-helper {\n            color: #606060;\n            font-size: 13px;\n            margin-top: 6px;\n          }\n\n          .comment-guidelines-link {\n            color: #1976d2;\n            text-decoration: underline;\n            cursor: pointer;\n\n            &:hover {\n              color: #1565c0;\n            }\n          }\n        }\n      }\n\n      .comment-login-prompt {\n        padding: 16px;\n        background: #f9f9f9;\n        border-radius: 8px;\n        text-align: center;\n\n        p {\n          margin: 0;\n          font-size: 14px;\n          color: #606060;\n\n          a {\n            color: #5ea1d8;\n            cursor: pointer;\n            text-decoration: none;\n\n            &:hover {\n              text-decoration: underline;\n            }\n          }\n        }\n      }\n\n      .comments-list {\n        margin-top: 24px;\n\n        .comment-item {\n          display: flex;\n          flex-direction: column;\n          padding: 16px 0;\n          border-bottom: 1px solid #e0e0e0;\n\n          &:last-child {\n            border-bottom: none;\n          }\n\n          .comment-header {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            margin-bottom: 8px;\n\n            .comment-author {\n              display: flex;\n              align-items: center;\n              gap: 8px;\n\n              .comment-avatar-img {\n                width: 40px;\n                height: 40px;\n                border-radius: 50%;\n                object-fit: cover;\n              }\n\n              .comment-avatar-icon {\n                font-size: 40px;\n                width: 40px;\n                height: 40px;\n                color: #606060;\n              }\n\n              .comment-author-name {\n                font-size: 14px;\n                font-weight: 500;\n                color: #0f0f0f;\n                font-family: \"Raleway\", sans-serif;\n              }\n            }\n\n            .comment-date {\n              font-size: 12px;\n              color: #606060;\n              font-family: \"Raleway\", sans-serif;\n            }\n          }\n\n          .comment-text {\n            font-size: 14px;\n            line-height: 20px;\n            color: #0f0f0f;\n            margin-bottom: 8px;\n            font-family: \"Raleway\", sans-serif;\n          }\n\n          .comment-actions {\n            display: flex;\n            align-items: center;\n            gap: 16px;\n            flex-wrap: nowrap;\n            overflow-x: auto;\n            overflow-y: hidden;\n            -ms-overflow-style: none; /* IE/Edge */\n            scrollbar-width: thin;\n\n            &::-webkit-scrollbar {\n              height: 4px;\n            }\n\n            &::-webkit-scrollbar-thumb {\n              background: rgba(0, 0, 0, 0.2);\n              border-radius: 4px;\n            }\n\n            .comment-action-btn {\n              display: flex;\n              align-items: center;\n              gap: 4px;\n              flex: 0 0 auto;\n              background: none;\n              border: none;\n              color: #606060;\n              cursor: pointer;\n              font-size: 14px;\n              font-family: \"Raleway\", sans-serif;\n              padding: 4px 8px;\n              border-radius: 18px;\n              transition: background 0.2s;\n              height: auto;\n              min-height: 28px; /* Consistent height for icon + count */\n\n              mat-icon {\n                font-size: 18px !important;\n                width: 18px !important;\n                height: 18px !important;\n                line-height: 18px !important;\n                display: inline-flex !important;\n                align-items: center !important;\n                justify-content: center !important;\n                vertical-align: middle;\n              }\n\n              .like-count {\n                font-size: 12px;\n                line-height: 18px;\n                height: 18px;\n                display: inline-flex;\n                align-items: center;\n                vertical-align: middle;\n                margin: 0;\n                padding: 0;\n              }\n\n              &:hover {\n                background: #f5f5f5;\n              }\n\n              &.liked {\n                color: #ff4d4d;\n\n                mat-icon {\n                  color: #ff4d4d;\n                }\n              }\n\n              mat-icon {\n                font-size: 18px;\n                width: 18px;\n                height: 18px;\n              }\n            }\n          }\n\n          .reply-form {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            margin-top: 12px;\n            padding: 8px 0;\n\n            .reply-input {\n              flex: 1;\n              padding: 8px 12px;\n              border: 1px solid #e0e0e0;\n              border-radius: 20px;\n              font-size: 14px;\n              color: #0f0f0f;\n              background: #f9f9f9;\n              font-family: \"Raleway\", sans-serif;\n\n              &:focus {\n                outline: none;\n                border-color: #5ea1d8;\n                background: #fff;\n              }\n\n              &::placeholder {\n                color: #909090;\n              }\n            }\n\n            .reply-send-btn {\n              flex-shrink: 0;\n              background: #5ea1d8;\n              border: none;\n              color: white;\n              cursor: pointer;\n              padding: 8px;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              border-radius: 50%;\n              width: 36px;\n              height: 36px;\n              transition: all 0.2s;\n              font-size: 20px;\n\n              &:hover:not(:disabled) {\n                background: #4a8fc4;\n                transform: scale(1.05);\n              }\n\n              &:disabled {\n                background: #ccc;\n                cursor: not-allowed;\n                transform: none;\n              }\n            }\n          }\n\n          .child-comments {\n            margin-left: 56px;\n            margin-top: 16px;\n            padding-left: 16px;\n            border-left: 2px solid #e0e0e0;\n\n            .child-comment {\n              padding: 12px 0;\n\n              .comment-header {\n                .comment-author {\n                  .comment-avatar-img,\n                  .comment-avatar-icon {\n                    width: 32px;\n                    height: 32px;\n                  }\n\n                  .comment-author-name {\n                    font-size: 13px;\n                  }\n                }\n              }\n\n              .comment-text {\n                font-size: 13px;\n              }\n            }\n          }\n        }\n      }\n\n      .no-comments {\n        padding: 32px;\n        text-align: center;\n        color: #606060;\n        font-family: \"Raleway\", sans-serif;\n\n        p {\n          margin: 0;\n          font-size: 14px;\n        }\n      }\n    }\n  }\n\n  // Mobile Recommendations Section (matching view-flow's parts of bundle)\n  .recommendations-section-mobile {\n    margin-top: 24px;\n    padding-top: 24px;\n    border-top: 1px solid #e0e0e0;\n\n    h2 {\n      font-size: 18px;\n      font-weight: 500;\n      color: #0f0f0f;\n      margin-bottom: 16px;\n    }\n\n    .recommendations-list {\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n      overflow-x: hidden;\n    }\n\n    .recommendation-item {\n      display: flex;\n      gap: 12px;\n      cursor: pointer;\n      padding: 12px;\n      border-radius: 8px;\n      transition: background 0.2s;\n      overflow: hidden;\n      background: #f9f9f9;\n\n      &:hover {\n        background: #f0f0f0;\n      }\n\n      .recommendation-thumbnail {\n        flex-shrink: 0;\n        width: 168px;\n        height: 94px;\n        border-radius: 4px;\n        overflow: hidden; \n        position: relative;\n\n        .flow-seq-badge {\n          position: absolute;\n          top: 8px;\n          left: 8px;\n          z-index: 6;\n          min-width: 24px;\n          height: 24px;\n          padding: 0 8px;\n          border-radius: 999px;\n          background: rgba(94, 161, 216, 0.95);\n          color: #fff;\n          font-size: 12px;\n          font-weight: 700;\n          display: inline-flex;\n          align-items: center;\n          justify-content: center;\n          pointer-events: none;\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n        }\n\n        img,\n        video {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n      }\n\n      .recommendation-info {\n        flex: 1;\n        min-width: 0;\n\n        .recommendation-title {\n          font-size: 16px;\n          font-weight: 500;\n          color: #0f0f0f;\n          margin: 0 0 4px 0;\n          line-height: 20px;\n          white-space: normal;\n          word-break: break-word;\n          overflow: hidden;\n        }\n\n        .recommendation-meta {\n          display: flex;\n          flex-direction: column;\n          gap: 2px;\n          font-size: 12px;\n          color: #606060;\n          flex-wrap: wrap;\n\n          .recommendation-creator {\n            color: #606060;\n          }\n\n          .recommendation-id {\n            color: #909090;\n          }\n        }\n\n        .recommendation-price {\n          display: block;\n          margin-top: 4px;\n          font-size: 14px;\n          font-weight: 500;\n          color: #e83e8c;\n        }\n      }\n    }\n\n    // Hide on desktop\n    @media (min-width: 1025px) {\n      display: none !important;\n    }\n  }\n\n  // Sidebar (Right Column)\n  .flow-sidebar {\n    width: 402px;\n    min-width: 402px;\n    max-width: 402px;\n    position: relative;\n    z-index: 10;\n    overflow-x: hidden;\n    display: flex;\n    flex-direction: column;\n\n    @media (max-width: 1024px) {\n      width: 100%;\n      min-width: 100%;\n      max-width: 100%;\n    }\n\n    .recommendations-section {\n      flex: 0 0 auto;\n      padding-top: 0;\n      border-top: 1px solid #e0e0e0;\n      align-self: flex-start;\n      width: 100%;\n\n      h2 {\n        font-size: 16px;\n        font-weight: 500;\n        color: #0f0f0f;\n        margin-bottom: 16px;\n      }\n\n      .recommendations-list {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        overflow-x: hidden;\n      }\n\n      .recommendation-item {\n        display: flex;\n        gap: 8px;\n        cursor: pointer;\n        padding: 8px;\n        border-radius: 8px;\n        transition: background 0.2s;\n        overflow: hidden;\n\n        &:hover {\n          background: #f9f9f9;\n        }\n\n        .recommendation-thumbnail {\n          flex-shrink: 0;\n          width: 168px;\n          height: 94px;\n          border-radius: 4px;\n          overflow: hidden; \n          background: #000;\n          position: relative;\n\n          .flow-seq-badge {\n            position: absolute;\n            top: 8px;\n            left: 8px;\n            z-index: 6;\n            min-width: 24px;\n            height: 24px;\n            padding: 0 8px;\n            border-radius: 999px;\n            background: rgba(94, 161, 216, 0.95);\n            color: #fff;\n            font-size: 12px;\n            font-weight: 700;\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            pointer-events: none;\n            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n          }\n          \n          img,\n          video {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n          }\n        }\n        .recommendation-thumbnail-skeleton {\n          flex-shrink: 0;\n          width: 168px;\n          height: 94px;\n          border-radius: 4px;\n          overflow: hidden;  \n          \n          img,\n          video {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n          }\n        }\n\n        .recommendation-info {\n          flex: 1;\n          min-width: 0;\n\n          .recommendation-title {\n            font-size: 16px;\n            font-weight: 500;\n            color: #0f0f0f;\n            margin: 0 0 4px 0;\n            line-height: 20px;\n            white-space: normal;\n            word-break: break-word;\n            overflow: hidden;\n          }\n\n          .recommendation-meta {\n            display: flex;\n            flex-direction: column;\n            gap: 2px;\n            font-size: 12px;\n            color: #606060;\n            flex-wrap: wrap;\n\n            .recommendation-creator {\n              color: #606060;\n            }\n\n            .recommendation-id {\n              color: #909090;\n            }\n          }\n\n          .recommendation-price {\n            display: block;\n            margin-top: 4px;\n            font-size: 14px;\n            font-weight: 500;\n            color: #e83e8c;\n          }\n        }\n      }\n    }\n\n    // Hide recommendations section in sidebar on mobile\n    @media (max-width: 1024px) {\n      .recommendations-section {\n        display: none !important;\n      }\n    }\n  }\n}\n\n// Override legacy layout defaults to align with viewflow styling\n.view-flow {\n  background: #efeeee;\n  min-height: 100vh;\n  padding-top: 0;\n  width: 100%;\n  overflow-x: hidden;\n}\n\n/* Version preview in dialog: same grid + recommendations-section-mobile path as standalone; full-width container. */\n.view-flow.viewbundle.preview-mode.mobile {\n  .container1 {\n    padding: 0;\n    margin: 0;\n    max-width: 100%;\n  }\n}\n\n// Mobile Stacked View Styles (matching view-flow)\n@media (max-width: 1024px) {\n  .mobile-stacked-view {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    padding: 20px;\n    background: #f6f7f9;\n  }\n\n  .mobile-top-panel {\n    position: sticky;\n    top: 76px;\n    z-index: 3;\n    padding: 12px 0 4px;\n    background: linear-gradient(\n      180deg,\n      rgba(246, 247, 249, 0.98) 0%,\n      rgba(246, 247, 249, 0.9) 60%,\n      rgba(246, 247, 249, 0) 100%\n    );\n    backdrop-filter: blur(8px);\n  }\n\n  .mobile-info-panel {\n    padding: 0 12px;\n    display: flex;\n    overflow-x: auto;\n    gap: 12px;\n\n    .info-badge {\n      flex: 0 0 auto;\n    }\n  }\n\n  .mobile-info-panel::-webkit-scrollbar {\n    display: none;\n  }\n\n  .mobile-section {\n    background: #ffffff;\n    border-radius: 16px;\n   //box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n    overflow: hidden;\n    scroll-margin-top: 140px;\n  }\n\n  .mobile-media { \n    background: #000;\n  }\n\n  .mobile-media img,\n  .mobile-media video {\n    width: 100%;\n    display: block;\n    max-height: 260px;\n    object-fit: cover;\n  }\n\n  .mobile-media-video {\n    width: 100%;\n    max-height: 260px; \n    background: #000;\n    border: 0;\n  }\n\n  .mobile-section-body {\n    padding: 20px 20px 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .mobile-section-title {\n    font-size: 20px;\n    font-weight: 600;\n    margin: 0;\n    color: #1f2f46;\n  }\n\n  #mobile-bundle-categories {\n    .mobile-section-title {\n      margin-bottom: 16px;\n    }\n\n    .bundle-view-category {\n      margin-bottom: 20px;\n\n      &:not(:first-of-type) {\n        margin-top: 8px;\n        padding-top: 16px;\n        border-top: 1px solid rgba(0, 0, 0, 0.06);\n      }\n    }\n\n    .bundle-view-category-title {\n      font-size: 15px;\n      font-weight: 600;\n      line-height: 1.3;\n      color: #374151;\n      margin: 0 0 12px;\n      padding-top: 4px;\n    }\n  }\n\n  .mobile-section-description {\n    color: #4a5568;\n    line-height: 1.6;\n\n    p {\n      margin-bottom: 12px;\n    }\n  }\n\n  .mobile-meta-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 8px;\n\n    .channel-header {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      flex: 1;\n      min-width: 0;\n\n      .channel-avatar {\n        flex-shrink: 0;\n\n        img {\n          width: 40px;\n          height: 40px;\n          border-radius: 50%;\n          object-fit: cover;\n          cursor: pointer;\n        }\n\n        .material-icons {\n          font-size: 40px;\n          width: 40px;\n          height: 40px;\n          color: #606060;\n          cursor: pointer;\n        }\n      }\n\n      .channel-details {\n        flex: 1;\n        min-width: 0;\n\n        .channel-name {\n          font-size: 14px;\n          font-weight: 500;\n          color: #0f0f0f;\n          cursor: pointer;\n          margin-bottom: 2px;\n          font-family: \"Raleway\", sans-serif;\n\n          &:hover {\n            color: #606060;\n          }\n        }\n\n        .channel-meta {\n          display: flex;\n          align-items: center;\n          gap: 6px;\n          flex-wrap: wrap;\n          font-size: 12px;\n          color: #606060;\n          font-family: \"Raleway\", sans-serif;\n\n          mat-icon {\n            font-size: 14px;\n            width: 14px;\n            height: 14px;\n          }\n\n          .price-tag {\n            color: #e83e8c;\n            cursor: pointer;\n            font-weight: 500;\n\n            &:hover {\n              text-decoration: underline;\n            }\n          }\n\n          .purchased-tag {\n            color: #606060;\n            background: #f2f2f2;\n            padding: 2px 6px;\n            border-radius: 4px;\n            font-size: 11px;\n          }\n        }\n      }\n\n      .channel-actions {\n        display: flex;\n        gap: 8px;\n        flex-shrink: 0;\n\n        .follow-btn {\n          padding: 8px 14px;\n          border-radius: 18px;\n          border: 1px solid #5ea1d8;\n          font-size: 13px;\n          font-weight: 500;\n          cursor: pointer;\n          transition: background 0.2s, box-shadow 0.2s;\n          white-space: nowrap;\n\n          &.following {\n            background: #f2f8fc;\n            color: #0f0f0f;\n            border-color: #5ea1d8;\n\n            &:hover {\n              background: #e1f0fa;\n            }\n          }\n\n          &:not(.following) {\n            background: #5ea1d8;\n            color: #ffffff;\n            box-shadow: 0 4px 10px rgba(94, 161, 216, 0.35);\n\n            &:hover {\n              background: #4b8ac1;\n            }\n          }\n        }\n\n        .purchase-btn {\n          padding: 8px 14px;\n          border-radius: 18px;\n          border: none;\n          background: #e83e8c;\n          color: white;\n          font-size: 13px;\n          font-weight: 500;\n          cursor: pointer;\n          transition: background 0.2s;\n          white-space: nowrap;\n\n          &:hover {\n            background: #d0307a;\n          }\n        }\n      }\n    }\n  }\n\n  .mobile-actions-bar {\n    display: flex;\n    gap: 16px;\n    padding: 12px 0;\n    border-top: 1px solid #e0e0e0;\n    border-bottom: 1px solid #e0e0e0;\n    margin: 12px 0;\n\n    .action-item {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      cursor: pointer;\n      color: #606060;\n      font-size: 14px;\n\n      mat-icon {\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n      }\n\n      // Bookmark icon - show flowchest blue when saved\n      mat-icon[style*=\"#5ea1d8\"] {\n        color: #5ea1d8 !important;\n      }\n    }\n  }\n\n  .mobile-supporting-doc {\n    margin-top: 12px;\n    color: #5ea1d8;\n    text-decoration: none;\n  }\n\n  .mobile-flows-list {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-top: 16px;\n  }\n\n  .mobile-flow-card {\n    display: flex;\n    gap: 12px;\n    padding: 12px;\n    border: 1px solid #e0e0e0;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: background 0.2s;\n\n    &:hover {\n      background: #f9f9f9;\n    }\n  }\n\n  .mobile-flow-media {\n    flex-shrink: 0;\n    width: 140px;\n    height: 90px;\n    border-radius: 8px;\n    overflow: hidden; \n    background: #000;\n\n    img,\n    video {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n\n  .mobile-flow-content {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  .mobile-flow-content h3 {\n    font-size: 16px;\n    font-weight: 500;\n    margin: 0;\n    color: #0f0f0f;\n    line-height: 20px;\n  }\n\n  .mobile-flow-meta {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 12px;\n    color: #606060;\n    flex-wrap: wrap;\n  }\n\n  .mobile-flow-price {\n    margin-left: auto;\n    font-weight: 600;\n    color: #e83e8c;\n  }\n\n  .mobile-flow-description {\n    color: #4a5568;\n    font-size: 14px;\n    line-height: 1.5;\n\n    p {\n      margin-bottom: 8px;\n    }\n  }\n}\n\n// Mobile edge-to-edge video player (matching view-flow)\n@media (max-width: 767px) {\n  .view-flow {\n    width: 100vw !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    background: #ffffff;\n\n    .container1,\n    .flow-layout-container,\n    .flow-layout-container .flow-main-grid,\n    .flow-layout-container .flow-main-content {\n      width: 100vw !important;\n      max-width: 100vw !important;\n      margin: 0 !important;\n      padding: 0 !important;\n    }\n\n    .container1 {\n      .user-sec {\n        padding: 16px !important;\n        margin: 0 !important;\n        border-radius: 0 !important;\n      }\n    }\n\n    .flow-layout-container {\n      .flow-main-grid {\n        grid-template-columns: 1fr !important;\n        gap: 0 !important;\n      }\n\n      .flow-main-content {\n        .flow-title-sticky {\n          padding: 1px 5px !important; \n          margin: 0 !important;\n        }\n\n        .video-actions-bar {\n          overflow-x: auto;\n          overflow-y: hidden;\n          padding: 0 16px 12px 16px !important;\n\n          .action-buttons {\n            flex-wrap: nowrap !important;\n            gap: 8px !important;\n            width: max-content;\n          }\n\n          .action-item {\n            flex: 0 0 auto;\n            min-width: 100px;\n            padding: 6px 10px !important;\n            gap: 6px !important;\n            border-radius: 14px !important;\n\n            mat-icon {\n              font-size: 18px !important;\n              width: 18px !important;\n              height: 18px !important;\n            }\n\n            span {\n              font-size: 13px !important;\n              font-weight: 500; \n            }\n          }\n\n          &::-webkit-scrollbar {\n            height: 4px;\n          }\n\n          &::-webkit-scrollbar-thumb { \n            border-radius: 4px;\n          }\n        }\n\n        .flow-info-panel,\n        .video-metadata,\n        .channel-info-section,\n        .description-section,\n        .comments-section {\n          padding: 16px !important;\n          margin: 0 !important;\n          border-radius: 0 !important;\n        }\n\n        .video-player-section {\n          margin: 0 !important;\n          border-radius: 0 !important;\n\n          .img-wrap {\n            width: 100% !important;\n            max-width: 100% !important;\n            margin: 0 !important;\n          }\n        }\n      }\n    }\n  }\n}\n\n/* Keep layout usable on common laptop resolutions without manual display scaling changes. */\n@media (max-width: 1366px) {\n  .view-flow {\n    .flow-layout-container {\n      .flow-main-grid {\n        grid-template-columns: 1fr !important;\n      }\n    }\n\n    .flow-sidebar {\n      width: 100% !important;\n      min-width: 100% !important;\n      max-width: 100% !important;\n\n      .recommendations-section {\n        display: none !important;\n      }\n    }\n\n    .recommendations-section-mobile {\n      display: block !important;\n    }\n  }\n}\n\n.follow-btn:disabled {\n  opacity: 0.8;\n  cursor: not-allowed;\n}\n\n.btn-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 6px;\n  animation: follow-spin 0.7s linear infinite;\n  vertical-align: middle;\n}\n\n@keyframes follow-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Dark mode overrides for view-bundle page */\n:host-context(body.theme-dark) {\n  .view-flow.viewbundle,\n  .view-flow.viewbundle .container1,\n  .view-flow.viewbundle .flow-layout-container,\n  .view-flow.viewbundle .flow-main-grid,\n  .view-flow.viewbundle .flow-main-content,\n  .view-flow.viewbundle .flow-sidebar,\n  .view-flow.viewbundle .mobile-stacked-view {\n    background: #0a0c10 !important;\n    color: #ffffff !important;\n  }\n\n  .view-flow.viewbundle .flow-main-grid {\n    background: #0a0c10 !important;\n  }\n\n  .view-flow.viewbundle .flow-title-sticky,\n  .view-flow.viewbundle .video-metadata,\n  .view-flow.viewbundle .channel-info-section,\n  .view-flow.viewbundle .description-section,\n  .view-flow.viewbundle .comments-section,\n  .view-flow.viewbundle .recommendations-section,\n  .view-flow.viewbundle .mobile-section,\n  .view-flow.viewbundle .preview-dialog-header,\n  .view-flow.viewbundle .preview-inline-description {\n    background: #111827 !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .view-flow.viewbundle .preview-dialog-header,\n  .view-flow.viewbundle .mobile-actions-bar,\n  .view-flow.viewbundle .flow-sidebar .recommendations-section {\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  /* Comment items + inputs — match view-flow dark mode treatment */\n  .view-flow.viewbundle .comments-section .comment-item,\n  .view-flow.viewbundle .comment-input,\n  .view-flow.viewbundle .reply-input {\n    background: #111827 !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .view-flow.viewbundle .video-player-section,\n  .view-flow.viewbundle .mobile-media,\n  .view-flow.viewbundle .mobile-media-video,\n  .view-flow.viewbundle .recommendation-thumbnail {\n    background: #020617 !important;\n  }\n\n  .view-flow.viewbundle .video-title-sticky,\n  .view-flow.viewbundle .video-title,\n  .view-flow.viewbundle .channel-name,\n  .view-flow.viewbundle .description-content,\n  .view-flow.viewbundle .comment-text,\n  .view-flow.viewbundle .comment-author-name,\n  .view-flow.viewbundle .mobile-section-title,\n  .view-flow.viewbundle .mobile-flow-content h3,\n  .view-flow.viewbundle .recommendation-title,\n  .view-flow.viewbundle .recommendations-section h2,\n  .view-flow.viewbundle .recommendations-section-mobile h2,\n  .view-flow.viewbundle .preview-dialog-header h2,\n  .view-flow.viewbundle .preview-unique-code-label,\n  .view-flow.viewbundle .preview-unique-code-value {\n    color: #ffffff !important;\n  }\n\n  .view-flow.viewbundle .channel-meta,\n  .view-flow.viewbundle .comment-date,\n  .view-flow.viewbundle .comment-action-btn,\n  .view-flow.viewbundle .no-comments,\n  .view-flow.viewbundle .mobile-flow-meta,\n  .view-flow.viewbundle .recommendation-meta,\n  .view-flow.viewbundle .recommendation-creator,\n  .view-flow.viewbundle .recommendation-id,\n  .view-flow.viewbundle .preview-unique-code,\n  .view-flow.viewbundle .close-button,\n  .view-flow.viewbundle .close-button mat-icon {\n    color: #cbd5e1 !important;\n  }\n\n  .view-flow.viewbundle .action-item,\n  .view-flow.viewbundle .comment-login-prompt,\n  .view-flow.viewbundle .no-results-message,\n  .view-flow.viewbundle .recommendation-item,\n  .view-flow.viewbundle .mobile-flow-card,\n  .view-flow.viewbundle .reply-input {\n    background: #111827 !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  /* Global dark mode forces light text on all spans; keep action chips dark so text + icons are visible. */\n  .view-flow.viewbundle\n    .flow-main-content\n    .video-metadata\n    .video-actions-bar\n    .action-buttons\n    .action-item {\n    background: #111827 !important;\n    border: 1px solid rgba(148, 163, 184, 0.28) !important;\n    color: #ffffff !important;\n\n    &:hover:not(.disabled) {\n      background: #1b2437 !important;\n    }\n  }\n\n  .view-flow.viewbundle .mobile-actions-bar {\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .view-flow.viewbundle .mobile-actions-bar .action-item {\n    background: #111827 !important;\n    border: 1px solid rgba(148, 163, 184, 0.28) !important;\n    color: #ffffff !important;\n  }\n\n  .view-flow.viewbundle .mobile-actions-bar .action-item mat-icon {\n    color: #ffffff !important;\n  }\n\n  /* Force readable action row content (base styles use dark text !important). */\n  .view-flow.viewbundle .action-item span,\n  .view-flow.viewbundle .action-item mat-icon,\n  .view-flow.viewbundle .action-item .review-icon,\n  .view-flow.viewbundle .video-actions-bar .action-buttons .action-item span,\n  .view-flow.viewbundle .video-actions-bar .action-buttons .action-item mat-icon {\n    color: #ffffff !important;\n  }\n\n  .view-flow.viewbundle .action-item .bookmark-state-icon,\n  .view-flow.viewbundle .action-item .bookmark-state-icon.saved {\n    color: #ffffff !important;\n  }\n\n  .view-flow.viewbundle .video-actions-bar .action-buttons .action-item.delete-action,\n  .view-flow.viewbundle .video-actions-bar .action-buttons .action-item.delete-action span,\n  .view-flow.viewbundle .video-actions-bar .action-buttons .action-item.delete-action mat-icon {\n    color: #ef5350 !important;\n    background: rgba(211, 47, 47, 0.12) !important;\n    border-color: rgba(211, 47, 47, 0.3) !important;\n  }\n\n  .view-flow.viewbundle .action-item .favorite-toggle-icon.liked,\n  .view-flow.viewbundle .action-item.liked .favorite-toggle-icon,\n  .view-flow.viewbundle .video-actions-bar .action-buttons .action-item .favorite-toggle-icon.liked,\n  .view-flow.viewbundle .video-actions-bar .action-buttons .action-item.liked .favorite-toggle-icon {\n    color: #ff4d4d !important;\n  }\n\n  .view-flow.viewbundle .description-section h3,\n  .view-flow.viewbundle .comments-section h3,\n  .view-flow.viewbundle .channel-meta span,\n  .view-flow.viewbundle .channel-meta .textbodycolor,\n  .view-flow.viewbundle .comment-login-prompt p,\n  .view-flow.viewbundle .comment-login-prompt a {\n    color: #ffffff !important;\n  }\n\n  /* Strong fallback: force readable white text inside key view-bundle sections. */\n  .view-flow.viewbundle .video-metadata,\n  .view-flow.viewbundle .channel-info-section,\n  .view-flow.viewbundle .description-section,\n  .view-flow.viewbundle .comments-section,\n  .view-flow.viewbundle .recommendations-section,\n  .view-flow.viewbundle .recommendations-section-mobile {\n    p,\n    span,\n    h1,\n    h2,\n    h3,\n    h4,\n    a,\n    label,\n    div {\n      color: #ffffff !important;\n    }\n  }\n\n  /* Keep intended accent colors after broad white fallback. */\n  .view-flow.viewbundle .price-tag,\n  .view-flow.viewbundle .recommendation-price {\n    color: #f472b6 !important;\n  }\n\n  /* Restore muted colour for comment action buttons — must come after the broad\n     div/span white fallback rule above to win the !important specificity tie. */\n  .view-flow.viewbundle .comments-section .comment-action-btn,\n  .view-flow.viewbundle .comments-section .comment-action-btn mat-icon,\n  .view-flow.viewbundle .comments-section .comment-action-btn span {\n    color: #cbd5e1 !important;\n  }\n\n  .view-flow.viewbundle .comments-section .comment-action-btn.liked,\n  .view-flow.viewbundle .comments-section .comment-action-btn.liked mat-icon,\n  .view-flow.viewbundle .comments-section .comment-action-btn.liked span {\n    color: #ff4d4d !important;\n  }\n\n  .view-flow.viewbundle .comments-section .comment-send-btn {\n    color: #5ea1d8 !important;\n    background: transparent !important;\n  }\n\n  .view-flow.viewbundle .comments-section .comment-send-btn:hover:not(:disabled) {\n    background: #1b2437 !important;\n    color: #93c5fd !important;\n  }\n\n  .view-flow.viewbundle .comments-section .comment-send-btn:disabled {\n    color: #4b5563 !important;\n  }\n\n  /* Version tag: light grey bg (#f0f0f0) becomes invisible on dark sections; use dark blue chip. */\n  .view-flow.viewbundle .version-tag {\n    background: #1e3a5f !important;\n    color: #93c5fd !important;\n  }\n\n  .view-flow.viewbundle .version-tag:hover {\n    background: #243f6a !important;\n  }\n\n  .view-flow.viewbundle .version-tag mat-icon,\n  .view-flow.viewbundle .description-content .supporting-docs-link a {\n    color: #93c5fd !important;\n  }\n\n  .view-flow.viewbundle .purchased-tag {\n    color: #cbd5e1 !important;\n    background: #1f2937 !important;\n  }\n\n  .view-flow.viewbundle .recommendations-section .recommendation-item,\n  .view-flow.viewbundle .recommendations-section-mobile .recommendation-item {\n    border: 1px solid rgba(148, 163, 184, 0.24) !important;\n  }\n\n  .view-flow.viewbundle .action-item:hover,\n  .view-flow.viewbundle .comment-action-btn:hover,\n  .view-flow.viewbundle .comment-send-btn:hover:not(:disabled),\n  .view-flow.viewbundle .recommendation-item:hover,\n  .view-flow.viewbundle .mobile-flow-card:hover {\n    background: #273449 !important;\n  }\n\n  .view-flow.viewbundle .comment-input {\n    color: #ffffff !important;\n    border-bottom-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .view-flow.viewbundle .comment-input::placeholder,\n  .view-flow.viewbundle .reply-input::placeholder {\n    color: #cbd5e1 !important;\n  }\n\n  .view-flow.viewbundle .expand-description-btn {\n    color: #cbd5e1 !important;\n  }\n\n  .view-flow.viewbundle .expand-description-btn:hover {\n    color: #ffffff !important;\n  }\n\n  /* Higher-specificity selector wins over the broad .comments-section p rule above */\n  .view-flow.viewbundle .comments-section .comment-form-wrapper .comment-guidelines-helper {\n    color: #fca5a5 !important;\n  }\n\n  .view-flow.viewbundle .comments-section .comment-form-wrapper .comment-guidelines-helper .comment-guidelines-link {\n    color: #93c5fd !important;\n\n    &:hover {\n      color: #60a5fa !important;\n    }\n  }\n\n  .view-flow.viewbundle .mobile-top-panel {\n    background: linear-gradient(\n      180deg,\n      rgba(15, 23, 42, 0.98) 0%,\n      rgba(15, 23, 42, 0.9) 60%,\n      rgba(15, 23, 42, 0) 100%\n    ) !important;\n  }\n\n  .view-flow.viewbundle .video-actions-bar::-webkit-scrollbar-thumb,\n  .view-flow.viewbundle .comment-actions::-webkit-scrollbar-thumb {\n    background: rgba(148, 163, 184, 0.55) !important;\n  }\n\n  .view-flow.viewbundle .video-actions-bar::-webkit-scrollbar-thumb:hover {\n    background: rgba(148, 163, 184, 0.75) !important;\n  }\n\n  /* Follow button — dark mode: keep non-following state as-is (blue), update\n     following state so light-grey bg doesn't appear washed out on dark surface. */\n  .view-flow.viewbundle .channel-actions .follow-btn:not(.following) {\n    background: #5ea1d8 !important;\n    color: #ffffff !important;\n    border: none !important;\n  }\n\n  .view-flow.viewbundle .channel-actions .follow-btn.following {\n    background: #1e3a5f !important;\n    color: #93c5fd !important;\n    border-color: #5ea1d8 !important;\n  }\n\n  .view-flow.viewbundle .preview-unavailable {\n    color: #fca5a5 !important;\n  }\n\n  .view-flow.viewbundle .preview-unavailable-body {\n    background: rgba(127, 29, 29, 0.25) !important;\n    border-color: rgba(248, 113, 113, 0.35) !important;\n    color: #fecaca !important;\n  }\n\n  /* Mobile: base `.view-flow` block forces white page bg; keep view-bundle dark on ≤767px. */\n  @media (max-width: 767px) {\n    .view-flow.viewbundle {\n      background: #0a0c10 !important;\n    }\n\n    .view-flow.viewbundle .container1,\n    .view-flow.viewbundle .flow-layout-container,\n    .view-flow.viewbundle .flow-main-grid,\n    .view-flow.viewbundle .flow-main-content,\n    .view-flow.viewbundle .mobile-stacked-view {\n      background: transparent !important;\n    }\n\n    .view-flow.viewbundle .flow-layout-container .flow-main-content .video-metadata,\n    .view-flow.viewbundle .flow-layout-container .flow-main-content .channel-info-section,\n    .view-flow.viewbundle .flow-layout-container .flow-main-content .description-section,\n    .view-flow.viewbundle .flow-layout-container .flow-main-content .flow-info-panel,\n    .view-flow.viewbundle .flow-layout-container .flow-main-content .comments-section,\n    .view-flow.viewbundle .mobile-section {\n      background: #111827 !important;\n    }\n\n    .view-flow.viewbundle .flow-title-sticky {\n      background: #111827 !important;\n    }\n\n    .view-flow.viewbundle .video-player-section,\n    .view-flow.viewbundle .mobile-media,\n    .view-flow.viewbundle .mobile-media-video {\n      background: #020617 !important;\n    }\n\n    .view-flow.viewbundle .mobile-actions-bar {\n      background: #0a0c10 !important;\n      border-color: rgba(148, 163, 184, 0.28) !important;\n    }\n\n    .view-flow.viewbundle .mobile-actions-bar .action-item {\n      background: #111827 !important;\n      border: 1px solid rgba(148, 163, 184, 0.28) !important;\n      color: #ffffff !important;\n    }\n\n    .view-flow.viewbundle .mobile-actions-bar .action-item span,\n    .view-flow.viewbundle .mobile-actions-bar .action-item mat-icon {\n      color: #ffffff !important;\n    }\n\n    .view-flow.viewbundle .recommendations-section-mobile {\n      background: transparent !important;\n    }\n\n    .view-flow.viewbundle .recommendations-section-mobile .recommendation-item {\n      background: #111827 !important;\n      border: 1px solid rgba(148, 163, 184, 0.24) !important;\n      color: #ffffff !important;\n    }\n\n    .view-flow.viewbundle .mobile-flow-card {\n      background: #111827 !important;\n      border-color: rgba(148, 163, 184, 0.28) !important;\n      color: #ffffff !important;\n    }\n\n    .view-flow.viewbundle h1,\n    .view-flow.viewbundle h2,\n    .view-flow.viewbundle h3,\n    .view-flow.viewbundle h4,\n    .view-flow.viewbundle h5,\n    .view-flow.viewbundle h6,\n    .view-flow.viewbundle p,\n    .view-flow.viewbundle span,\n    .view-flow.viewbundle label {\n      color: #ffffff !important;\n    }\n  }\n}\n\n.view-flow.viewbundle.embed-mode {\n  padding-top: 0;\n\n  .container1 {\n    max-width: 100%;\n    padding: 0 12px 12px;\n  }\n\n  .recommendation-title--link {\n    cursor: pointer;\n    color: #5ea1d8;\n    text-decoration: underline;\n    text-underline-offset: 2px;\n\n    &:hover {\n      color: #4a8fc4;\n    }\n  }\n}\n\n.draft-preview-note {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 6px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  background: #eef4ff;\n  border: 1px solid #c7d7fe;\n  color: #1e3a8a;\n  font-size: 13px;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n}\n\n/* Same button size, radius and icon alignment as the guide page's channel actions. */\n.view-flow .channel-actions {\n  align-items: center;\n\n  > button.follow-btn,\n  > button.purchase-btn {\n    box-sizing: border-box !important;\n    min-width: 140px;\n    height: 38px !important;\n    padding: 0 16px !important;\n    border-radius: 8px !important;\n    display: inline-flex !important;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    font-family: \"Raleway\", sans-serif;\n    font-size: 14px !important;\n    font-weight: 600 !important;\n    line-height: 1;\n    white-space: nowrap;\n  }\n\n  .btn-spinner {\n    margin-right: 0;\n  }\n\n  @media (max-width: 768px) {\n    > button.follow-btn,\n    > button.purchase-btn {\n      min-width: 120px;\n      height: 36px !important;\n      font-size: 13px !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
